/* eslint-disable */
// @ts-nocheck
export * from '@redviking/argonaut-util/types/db';
export * from './db-ops';

import * as Operations from './db-ops';
import * as VueApolloComposable from '@redviking/argonaut-core-ui/src/util/gql-client';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;


/**
 * __useGetAllAclsQuery__
 *
 * To run a query within a Vue component, call `useGetAllAclsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAclsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAclsQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortby: // value for 'sortby'
 *   }
 * );
 */
export function useGetAllAclsQuery(variables?: Operations.GetAllAclsQueryVariables | VueCompositionApi.Ref<Operations.GetAllAclsQueryVariables> | ReactiveFunction<Operations.GetAllAclsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllAclsQuery, Operations.GetAllAclsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllAclsQuery, Operations.GetAllAclsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllAclsQuery, Operations.GetAllAclsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllAclsQuery, Operations.GetAllAclsQueryVariables>(Operations.GetAllAclsDocument, variables, options);
          }
export type GetAllAclsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllAclsQuery, Operations.GetAllAclsQueryVariables>;

/**
 * __useGetAppletDesignVersionQuery__
 *
 * To run a query within a Vue component, call `useGetAppletDesignVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppletDesignVersionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAppletDesignVersionQuery(
 *   {
 *      appletDesignVersionId: // value for 'appletDesignVersionId'
 *   }
 * );
 */
export function useGetAppletDesignVersionQuery(variables: Operations.GetAppletDesignVersionQueryVariables | VueCompositionApi.Ref<Operations.GetAppletDesignVersionQueryVariables> | ReactiveFunction<Operations.GetAppletDesignVersionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignVersionQuery, Operations.GetAppletDesignVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignVersionQuery, Operations.GetAppletDesignVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignVersionQuery, Operations.GetAppletDesignVersionQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAppletDesignVersionQuery, Operations.GetAppletDesignVersionQueryVariables>(Operations.GetAppletDesignVersionDocument, variables, options);
          }
export type GetAppletDesignVersionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAppletDesignVersionQuery, Operations.GetAppletDesignVersionQueryVariables>;

/**
 * __useGetAppletDesignVersionConfigsForDeploymentQuery__
 *
 * To run a query within a Vue component, call `useGetAppletDesignVersionConfigsForDeploymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppletDesignVersionConfigsForDeploymentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAppletDesignVersionConfigsForDeploymentQuery(
 *   {
 *      appletDesignVersionIds: // value for 'appletDesignVersionIds'
 *   }
 * );
 */
export function useGetAppletDesignVersionConfigsForDeploymentQuery(variables: Operations.GetAppletDesignVersionConfigsForDeploymentQueryVariables | VueCompositionApi.Ref<Operations.GetAppletDesignVersionConfigsForDeploymentQueryVariables> | ReactiveFunction<Operations.GetAppletDesignVersionConfigsForDeploymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignVersionConfigsForDeploymentQuery, Operations.GetAppletDesignVersionConfigsForDeploymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignVersionConfigsForDeploymentQuery, Operations.GetAppletDesignVersionConfigsForDeploymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignVersionConfigsForDeploymentQuery, Operations.GetAppletDesignVersionConfigsForDeploymentQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAppletDesignVersionConfigsForDeploymentQuery, Operations.GetAppletDesignVersionConfigsForDeploymentQueryVariables>(Operations.GetAppletDesignVersionConfigsForDeploymentDocument, variables, options);
          }
export type GetAppletDesignVersionConfigsForDeploymentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAppletDesignVersionConfigsForDeploymentQuery, Operations.GetAppletDesignVersionConfigsForDeploymentQueryVariables>;

/**
 * __useGetDeploymentQuery__
 *
 * To run a query within a Vue component, call `useGetDeploymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeploymentQuery(
 *   {
 *      deploymentId: // value for 'deploymentId'
 *   }
 * );
 */
export function useGetDeploymentQuery(variables: Operations.GetDeploymentQueryVariables | VueCompositionApi.Ref<Operations.GetDeploymentQueryVariables> | ReactiveFunction<Operations.GetDeploymentQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetDeploymentQuery, Operations.GetDeploymentQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetDeploymentQuery, Operations.GetDeploymentQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetDeploymentQuery, Operations.GetDeploymentQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetDeploymentQuery, Operations.GetDeploymentQueryVariables>(Operations.GetDeploymentDocument, variables, options);
          }
export type GetDeploymentQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetDeploymentQuery, Operations.GetDeploymentQueryVariables>;

/**
 * __useFetchProcessDataForWorkInstructionDecompositionQuery__
 *
 * To run a query within a Vue component, call `useFetchProcessDataForWorkInstructionDecompositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchProcessDataForWorkInstructionDecompositionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchProcessDataForWorkInstructionDecompositionQuery(
 *   {
 *      processId: // value for 'processId'
 *   }
 * );
 */
export function useFetchProcessDataForWorkInstructionDecompositionQuery(variables: Operations.FetchProcessDataForWorkInstructionDecompositionQueryVariables | VueCompositionApi.Ref<Operations.FetchProcessDataForWorkInstructionDecompositionQueryVariables> | ReactiveFunction<Operations.FetchProcessDataForWorkInstructionDecompositionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.FetchProcessDataForWorkInstructionDecompositionQuery, Operations.FetchProcessDataForWorkInstructionDecompositionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.FetchProcessDataForWorkInstructionDecompositionQuery, Operations.FetchProcessDataForWorkInstructionDecompositionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.FetchProcessDataForWorkInstructionDecompositionQuery, Operations.FetchProcessDataForWorkInstructionDecompositionQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.FetchProcessDataForWorkInstructionDecompositionQuery, Operations.FetchProcessDataForWorkInstructionDecompositionQueryVariables>(Operations.FetchProcessDataForWorkInstructionDecompositionDocument, variables, options);
          }
export type FetchProcessDataForWorkInstructionDecompositionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.FetchProcessDataForWorkInstructionDecompositionQuery, Operations.FetchProcessDataForWorkInstructionDecompositionQueryVariables>;

/**
 * __useGetLatestApprovedDesignVersionDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetLatestApprovedDesignVersionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestApprovedDesignVersionDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLatestApprovedDesignVersionDetailsQuery(
 *   {
 *      designId: // value for 'designId'
 *   }
 * );
 */
export function useGetLatestApprovedDesignVersionDetailsQuery(variables: Operations.GetLatestApprovedDesignVersionDetailsQueryVariables | VueCompositionApi.Ref<Operations.GetLatestApprovedDesignVersionDetailsQueryVariables> | ReactiveFunction<Operations.GetLatestApprovedDesignVersionDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetLatestApprovedDesignVersionDetailsQuery, Operations.GetLatestApprovedDesignVersionDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetLatestApprovedDesignVersionDetailsQuery, Operations.GetLatestApprovedDesignVersionDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetLatestApprovedDesignVersionDetailsQuery, Operations.GetLatestApprovedDesignVersionDetailsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetLatestApprovedDesignVersionDetailsQuery, Operations.GetLatestApprovedDesignVersionDetailsQueryVariables>(Operations.GetLatestApprovedDesignVersionDetailsDocument, variables, options);
          }
export type GetLatestApprovedDesignVersionDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetLatestApprovedDesignVersionDetailsQuery, Operations.GetLatestApprovedDesignVersionDetailsQueryVariables>;

/**
 * __useGetLatestNonStagedDesignVersionNumberQuery__
 *
 * To run a query within a Vue component, call `useGetLatestNonStagedDesignVersionNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestNonStagedDesignVersionNumberQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLatestNonStagedDesignVersionNumberQuery(
 *   {
 *      designId: // value for 'designId'
 *   }
 * );
 */
export function useGetLatestNonStagedDesignVersionNumberQuery(variables: Operations.GetLatestNonStagedDesignVersionNumberQueryVariables | VueCompositionApi.Ref<Operations.GetLatestNonStagedDesignVersionNumberQueryVariables> | ReactiveFunction<Operations.GetLatestNonStagedDesignVersionNumberQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetLatestNonStagedDesignVersionNumberQuery, Operations.GetLatestNonStagedDesignVersionNumberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetLatestNonStagedDesignVersionNumberQuery, Operations.GetLatestNonStagedDesignVersionNumberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetLatestNonStagedDesignVersionNumberQuery, Operations.GetLatestNonStagedDesignVersionNumberQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetLatestNonStagedDesignVersionNumberQuery, Operations.GetLatestNonStagedDesignVersionNumberQueryVariables>(Operations.GetLatestNonStagedDesignVersionNumberDocument, variables, options);
          }
export type GetLatestNonStagedDesignVersionNumberQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetLatestNonStagedDesignVersionNumberQuery, Operations.GetLatestNonStagedDesignVersionNumberQueryVariables>;

/**
 * __useSelectAssetQuery__
 *
 * To run a query within a Vue component, call `useSelectAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectAssetQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectAssetQuery(
 *   {
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   }
 * );
 */
export function useSelectAssetQuery(variables: Operations.SelectAssetQueryVariables | VueCompositionApi.Ref<Operations.SelectAssetQueryVariables> | ReactiveFunction<Operations.SelectAssetQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.SelectAssetQuery, Operations.SelectAssetQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.SelectAssetQuery, Operations.SelectAssetQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.SelectAssetQuery, Operations.SelectAssetQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.SelectAssetQuery, Operations.SelectAssetQueryVariables>(Operations.SelectAssetDocument, variables, options);
          }
export type SelectAssetQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.SelectAssetQuery, Operations.SelectAssetQueryVariables>;

/**
 * __useSelectLocationQuery__
 *
 * To run a query within a Vue component, call `useSelectLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectLocationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectLocationQuery(
 *   {
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *   }
 * );
 */
export function useSelectLocationQuery(variables: Operations.SelectLocationQueryVariables | VueCompositionApi.Ref<Operations.SelectLocationQueryVariables> | ReactiveFunction<Operations.SelectLocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.SelectLocationQuery, Operations.SelectLocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.SelectLocationQuery, Operations.SelectLocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.SelectLocationQuery, Operations.SelectLocationQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.SelectLocationQuery, Operations.SelectLocationQueryVariables>(Operations.SelectLocationDocument, variables, options);
          }
export type SelectLocationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.SelectLocationQuery, Operations.SelectLocationQueryVariables>;

/**
 * __useSelectMaterialClassQuery__
 *
 * To run a query within a Vue component, call `useSelectMaterialClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectMaterialClassQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectMaterialClassQuery(
 *   {
 *   }
 * );
 */
export function useSelectMaterialClassQuery(options: VueApolloComposable.UseQueryOptions<Operations.SelectMaterialClassQuery, Operations.SelectMaterialClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.SelectMaterialClassQuery, Operations.SelectMaterialClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.SelectMaterialClassQuery, Operations.SelectMaterialClassQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.SelectMaterialClassQuery, undefined>(Operations.SelectMaterialClassDocument, undefined, options);
          }
export type SelectMaterialClassQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.SelectMaterialClassQuery, Operations.SelectMaterialClassQueryVariables>;

/**
 * __useSelectProcessQuery__
 *
 * To run a query within a Vue component, call `useSelectProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectProcessQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectProcessQuery(
 *   {
 *   }
 * );
 */
export function useSelectProcessQuery(options: VueApolloComposable.UseQueryOptions<Operations.SelectProcessQuery, Operations.SelectProcessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.SelectProcessQuery, Operations.SelectProcessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.SelectProcessQuery, Operations.SelectProcessQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.SelectProcessQuery, undefined>(Operations.SelectProcessDocument, undefined, options);
          }
export type SelectProcessQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.SelectProcessQuery, Operations.SelectProcessQueryVariables>;

/**
 * __useSelectProcessByIdQuery__
 *
 * To run a query within a Vue component, call `useSelectProcessByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectProcessByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectProcessByIdQuery(
 *   {
 *      processId: // value for 'processId'
 *   }
 * );
 */
export function useSelectProcessByIdQuery(variables: Operations.SelectProcessByIdQueryVariables | VueCompositionApi.Ref<Operations.SelectProcessByIdQueryVariables> | ReactiveFunction<Operations.SelectProcessByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.SelectProcessByIdQuery, Operations.SelectProcessByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.SelectProcessByIdQuery, Operations.SelectProcessByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.SelectProcessByIdQuery, Operations.SelectProcessByIdQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.SelectProcessByIdQuery, Operations.SelectProcessByIdQueryVariables>(Operations.SelectProcessByIdDocument, variables, options);
          }
export type SelectProcessByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.SelectProcessByIdQuery, Operations.SelectProcessByIdQueryVariables>;

/**
 * __useSelectWorkInstructionVersionQuery__
 *
 * To run a query within a Vue component, call `useSelectWorkInstructionVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectWorkInstructionVersionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectWorkInstructionVersionQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useSelectWorkInstructionVersionQuery(variables?: Operations.SelectWorkInstructionVersionQueryVariables | VueCompositionApi.Ref<Operations.SelectWorkInstructionVersionQueryVariables> | ReactiveFunction<Operations.SelectWorkInstructionVersionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.SelectWorkInstructionVersionQuery, Operations.SelectWorkInstructionVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.SelectWorkInstructionVersionQuery, Operations.SelectWorkInstructionVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.SelectWorkInstructionVersionQuery, Operations.SelectWorkInstructionVersionQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.SelectWorkInstructionVersionQuery, Operations.SelectWorkInstructionVersionQueryVariables>(Operations.SelectWorkInstructionVersionDocument, variables, options);
          }
export type SelectWorkInstructionVersionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.SelectWorkInstructionVersionQuery, Operations.SelectWorkInstructionVersionQueryVariables>;

/**
 * __useSelectWorkInstructionVersionByIdQuery__
 *
 * To run a query within a Vue component, call `useSelectWorkInstructionVersionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectWorkInstructionVersionByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectWorkInstructionVersionByIdQuery(
 *   {
 *      workInstructionVersionId: // value for 'workInstructionVersionId'
 *   }
 * );
 */
export function useSelectWorkInstructionVersionByIdQuery(variables: Operations.SelectWorkInstructionVersionByIdQueryVariables | VueCompositionApi.Ref<Operations.SelectWorkInstructionVersionByIdQueryVariables> | ReactiveFunction<Operations.SelectWorkInstructionVersionByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.SelectWorkInstructionVersionByIdQuery, Operations.SelectWorkInstructionVersionByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.SelectWorkInstructionVersionByIdQuery, Operations.SelectWorkInstructionVersionByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.SelectWorkInstructionVersionByIdQuery, Operations.SelectWorkInstructionVersionByIdQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.SelectWorkInstructionVersionByIdQuery, Operations.SelectWorkInstructionVersionByIdQueryVariables>(Operations.SelectWorkInstructionVersionByIdDocument, variables, options);
          }
export type SelectWorkInstructionVersionByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.SelectWorkInstructionVersionByIdQuery, Operations.SelectWorkInstructionVersionByIdQueryVariables>;

/**
 * __useGetProcessByIdForProcessCollectNodeQuery__
 *
 * To run a query within a Vue component, call `useGetProcessByIdForProcessCollectNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessByIdForProcessCollectNodeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProcessByIdForProcessCollectNodeQuery(
 *   {
 *      processId: // value for 'processId'
 *   }
 * );
 */
export function useGetProcessByIdForProcessCollectNodeQuery(variables: Operations.GetProcessByIdForProcessCollectNodeQueryVariables | VueCompositionApi.Ref<Operations.GetProcessByIdForProcessCollectNodeQueryVariables> | ReactiveFunction<Operations.GetProcessByIdForProcessCollectNodeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetProcessByIdForProcessCollectNodeQuery, Operations.GetProcessByIdForProcessCollectNodeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetProcessByIdForProcessCollectNodeQuery, Operations.GetProcessByIdForProcessCollectNodeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetProcessByIdForProcessCollectNodeQuery, Operations.GetProcessByIdForProcessCollectNodeQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetProcessByIdForProcessCollectNodeQuery, Operations.GetProcessByIdForProcessCollectNodeQueryVariables>(Operations.GetProcessByIdForProcessCollectNodeDocument, variables, options);
          }
export type GetProcessByIdForProcessCollectNodeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetProcessByIdForProcessCollectNodeQuery, Operations.GetProcessByIdForProcessCollectNodeQueryVariables>;

/**
 * __useGetProcessDataElementsForWorkInstructionInputsQuery__
 *
 * To run a query within a Vue component, call `useGetProcessDataElementsForWorkInstructionInputsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessDataElementsForWorkInstructionInputsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProcessDataElementsForWorkInstructionInputsQuery(
 *   {
 *      processIds: // value for 'processIds'
 *   }
 * );
 */
export function useGetProcessDataElementsForWorkInstructionInputsQuery(variables: Operations.GetProcessDataElementsForWorkInstructionInputsQueryVariables | VueCompositionApi.Ref<Operations.GetProcessDataElementsForWorkInstructionInputsQueryVariables> | ReactiveFunction<Operations.GetProcessDataElementsForWorkInstructionInputsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetProcessDataElementsForWorkInstructionInputsQuery, Operations.GetProcessDataElementsForWorkInstructionInputsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetProcessDataElementsForWorkInstructionInputsQuery, Operations.GetProcessDataElementsForWorkInstructionInputsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetProcessDataElementsForWorkInstructionInputsQuery, Operations.GetProcessDataElementsForWorkInstructionInputsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetProcessDataElementsForWorkInstructionInputsQuery, Operations.GetProcessDataElementsForWorkInstructionInputsQueryVariables>(Operations.GetProcessDataElementsForWorkInstructionInputsDocument, variables, options);
          }
export type GetProcessDataElementsForWorkInstructionInputsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetProcessDataElementsForWorkInstructionInputsQuery, Operations.GetProcessDataElementsForWorkInstructionInputsQueryVariables>;

/**
 * __useGetWorkInstructionVersionDetailQuery__
 *
 * To run a query within a Vue component, call `useGetWorkInstructionVersionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkInstructionVersionDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWorkInstructionVersionDetailQuery(
 *   {
 *      workInstructionVersionId: // value for 'workInstructionVersionId'
 *   }
 * );
 */
export function useGetWorkInstructionVersionDetailQuery(variables: Operations.GetWorkInstructionVersionDetailQueryVariables | VueCompositionApi.Ref<Operations.GetWorkInstructionVersionDetailQueryVariables> | ReactiveFunction<Operations.GetWorkInstructionVersionDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetWorkInstructionVersionDetailQuery, Operations.GetWorkInstructionVersionDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetWorkInstructionVersionDetailQuery, Operations.GetWorkInstructionVersionDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetWorkInstructionVersionDetailQuery, Operations.GetWorkInstructionVersionDetailQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetWorkInstructionVersionDetailQuery, Operations.GetWorkInstructionVersionDetailQueryVariables>(Operations.GetWorkInstructionVersionDetailDocument, variables, options);
          }
export type GetWorkInstructionVersionDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetWorkInstructionVersionDetailQuery, Operations.GetWorkInstructionVersionDetailQueryVariables>;

/**
 * __useAppletDesignVersionQuery__
 *
 * To run a query within a Vue component, call `useAppletDesignVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppletDesignVersionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppletDesignVersionQuery(
 *   {
 *      id: // value for 'id'
 *   }
 * );
 */
export function useAppletDesignVersionQuery(variables: Operations.AppletDesignVersionQueryVariables | VueCompositionApi.Ref<Operations.AppletDesignVersionQueryVariables> | ReactiveFunction<Operations.AppletDesignVersionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.AppletDesignVersionQuery, Operations.AppletDesignVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.AppletDesignVersionQuery, Operations.AppletDesignVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.AppletDesignVersionQuery, Operations.AppletDesignVersionQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.AppletDesignVersionQuery, Operations.AppletDesignVersionQueryVariables>(Operations.AppletDesignVersionDocument, variables, options);
          }
export type AppletDesignVersionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.AppletDesignVersionQuery, Operations.AppletDesignVersionQueryVariables>;

/**
 * __useAppletDesignsQuery__
 *
 * To run a query within a Vue component, call `useAppletDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppletDesignsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppletDesignsQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useAppletDesignsQuery(variables: Operations.AppletDesignsQueryVariables | VueCompositionApi.Ref<Operations.AppletDesignsQueryVariables> | ReactiveFunction<Operations.AppletDesignsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.AppletDesignsQuery, Operations.AppletDesignsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.AppletDesignsQuery, Operations.AppletDesignsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.AppletDesignsQuery, Operations.AppletDesignsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.AppletDesignsQuery, Operations.AppletDesignsQueryVariables>(Operations.AppletDesignsDocument, variables, options);
          }
export type AppletDesignsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.AppletDesignsQuery, Operations.AppletDesignsQueryVariables>;

/**
 * __useAttributeSchemaQuery__
 *
 * To run a query within a Vue component, call `useAttributeSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeSchemaQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAttributeSchemaQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useAttributeSchemaQuery(variables: Operations.AttributeSchemaQueryVariables | VueCompositionApi.Ref<Operations.AttributeSchemaQueryVariables> | ReactiveFunction<Operations.AttributeSchemaQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.AttributeSchemaQuery, Operations.AttributeSchemaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.AttributeSchemaQuery, Operations.AttributeSchemaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.AttributeSchemaQuery, Operations.AttributeSchemaQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.AttributeSchemaQuery, Operations.AttributeSchemaQueryVariables>(Operations.AttributeSchemaDocument, variables, options);
          }
export type AttributeSchemaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.AttributeSchemaQuery, Operations.AttributeSchemaQueryVariables>;

/**
 * __useGetAppletDesignVersionConfigQuery__
 *
 * To run a query within a Vue component, call `useGetAppletDesignVersionConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppletDesignVersionConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAppletDesignVersionConfigQuery(
 *   {
 *      appletDesignVersionId: // value for 'appletDesignVersionId'
 *   }
 * );
 */
export function useGetAppletDesignVersionConfigQuery(variables: Operations.GetAppletDesignVersionConfigQueryVariables | VueCompositionApi.Ref<Operations.GetAppletDesignVersionConfigQueryVariables> | ReactiveFunction<Operations.GetAppletDesignVersionConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignVersionConfigQuery, Operations.GetAppletDesignVersionConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignVersionConfigQuery, Operations.GetAppletDesignVersionConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignVersionConfigQuery, Operations.GetAppletDesignVersionConfigQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAppletDesignVersionConfigQuery, Operations.GetAppletDesignVersionConfigQueryVariables>(Operations.GetAppletDesignVersionConfigDocument, variables, options);
          }
export type GetAppletDesignVersionConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAppletDesignVersionConfigQuery, Operations.GetAppletDesignVersionConfigQueryVariables>;

/**
 * __useGetAppletDesignsForListViewQuery__
 *
 * To run a query within a Vue component, call `useGetAppletDesignsForListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppletDesignsForListViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAppletDesignsForListViewQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAppletDesignsForListViewQuery(variables: Operations.GetAppletDesignsForListViewQueryVariables | VueCompositionApi.Ref<Operations.GetAppletDesignsForListViewQueryVariables> | ReactiveFunction<Operations.GetAppletDesignsForListViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignsForListViewQuery, Operations.GetAppletDesignsForListViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignsForListViewQuery, Operations.GetAppletDesignsForListViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAppletDesignsForListViewQuery, Operations.GetAppletDesignsForListViewQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAppletDesignsForListViewQuery, Operations.GetAppletDesignsForListViewQueryVariables>(Operations.GetAppletDesignsForListViewDocument, variables, options);
          }
export type GetAppletDesignsForListViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAppletDesignsForListViewQuery, Operations.GetAppletDesignsForListViewQueryVariables>;

/**
 * __useGetUdfColumnsForMaterialClassQuery__
 *
 * To run a query within a Vue component, call `useGetUdfColumnsForMaterialClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUdfColumnsForMaterialClassQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUdfColumnsForMaterialClassQuery(
 *   {
 *      materialClassId: // value for 'materialClassId'
 *   }
 * );
 */
export function useGetUdfColumnsForMaterialClassQuery(variables?: Operations.GetUdfColumnsForMaterialClassQueryVariables | VueCompositionApi.Ref<Operations.GetUdfColumnsForMaterialClassQueryVariables> | ReactiveFunction<Operations.GetUdfColumnsForMaterialClassQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetUdfColumnsForMaterialClassQuery, Operations.GetUdfColumnsForMaterialClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetUdfColumnsForMaterialClassQuery, Operations.GetUdfColumnsForMaterialClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetUdfColumnsForMaterialClassQuery, Operations.GetUdfColumnsForMaterialClassQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetUdfColumnsForMaterialClassQuery, Operations.GetUdfColumnsForMaterialClassQueryVariables>(Operations.GetUdfColumnsForMaterialClassDocument, variables, options);
          }
export type GetUdfColumnsForMaterialClassQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetUdfColumnsForMaterialClassQuery, Operations.GetUdfColumnsForMaterialClassQueryVariables>;

/**
 * __useSelectReleasedWorkInstructionVersionsQuery__
 *
 * To run a query within a Vue component, call `useSelectReleasedWorkInstructionVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectReleasedWorkInstructionVersionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectReleasedWorkInstructionVersionsQuery(
 *   {
 *   }
 * );
 */
export function useSelectReleasedWorkInstructionVersionsQuery(options: VueApolloComposable.UseQueryOptions<Operations.SelectReleasedWorkInstructionVersionsQuery, Operations.SelectReleasedWorkInstructionVersionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.SelectReleasedWorkInstructionVersionsQuery, Operations.SelectReleasedWorkInstructionVersionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.SelectReleasedWorkInstructionVersionsQuery, Operations.SelectReleasedWorkInstructionVersionsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.SelectReleasedWorkInstructionVersionsQuery, undefined>(Operations.SelectReleasedWorkInstructionVersionsDocument, undefined, options);
          }
export type SelectReleasedWorkInstructionVersionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.SelectReleasedWorkInstructionVersionsQuery, Operations.SelectReleasedWorkInstructionVersionsQueryVariables>;

/**
 * __useUpdateArgoMediaMutation__
 *
 * To run a mutation, you first call `useUpdateArgoMediaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArgoMediaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateArgoMediaMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *      mediaInput: // value for 'mediaInput'
 *   },
 * });
 */
export function useUpdateArgoMediaMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateArgoMediaMutation, Operations.UpdateArgoMediaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateArgoMediaMutation, Operations.UpdateArgoMediaMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateArgoMediaMutation, Operations.UpdateArgoMediaMutationVariables>(Operations.UpdateArgoMediaDocument, options);
          }
export type UpdateArgoMediaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateArgoMediaMutation, Operations.UpdateArgoMediaMutationVariables>;

/**
 * __useUpsertAppletDesignVersionMutation__
 *
 * To run a mutation, you first call `useUpsertAppletDesignVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAppletDesignVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertAppletDesignVersionMutation({
 *   variables: {
 *      designVersion: // value for 'designVersion'
 *   },
 * });
 */
export function useUpsertAppletDesignVersionMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpsertAppletDesignVersionMutation, Operations.UpsertAppletDesignVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpsertAppletDesignVersionMutation, Operations.UpsertAppletDesignVersionMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpsertAppletDesignVersionMutation, Operations.UpsertAppletDesignVersionMutationVariables>(Operations.UpsertAppletDesignVersionDocument, options);
          }
export type UpsertAppletDesignVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpsertAppletDesignVersionMutation, Operations.UpsertAppletDesignVersionMutationVariables>;

/**
 * __useGetProcessDataElementNameQuery__
 *
 * To run a query within a Vue component, call `useGetProcessDataElementNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessDataElementNameQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProcessDataElementNameQuery(
 *   {
 *      dataElementId: // value for 'dataElementId'
 *   }
 * );
 */
export function useGetProcessDataElementNameQuery(variables: Operations.GetProcessDataElementNameQueryVariables | VueCompositionApi.Ref<Operations.GetProcessDataElementNameQueryVariables> | ReactiveFunction<Operations.GetProcessDataElementNameQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetProcessDataElementNameQuery, Operations.GetProcessDataElementNameQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetProcessDataElementNameQuery, Operations.GetProcessDataElementNameQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetProcessDataElementNameQuery, Operations.GetProcessDataElementNameQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetProcessDataElementNameQuery, Operations.GetProcessDataElementNameQueryVariables>(Operations.GetProcessDataElementNameDocument, variables, options);
          }
export type GetProcessDataElementNameQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetProcessDataElementNameQuery, Operations.GetProcessDataElementNameQueryVariables>;

/**
 * __useGetAppletRunnersQuery__
 *
 * To run a query within a Vue component, call `useGetAppletRunnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppletRunnersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAppletRunnersQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useGetAppletRunnersQuery(variables?: Operations.GetAppletRunnersQueryVariables | VueCompositionApi.Ref<Operations.GetAppletRunnersQueryVariables> | ReactiveFunction<Operations.GetAppletRunnersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAppletRunnersQuery, Operations.GetAppletRunnersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAppletRunnersQuery, Operations.GetAppletRunnersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAppletRunnersQuery, Operations.GetAppletRunnersQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAppletRunnersQuery, Operations.GetAppletRunnersQueryVariables>(Operations.GetAppletRunnersDocument, variables, options);
          }
export type GetAppletRunnersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAppletRunnersQuery, Operations.GetAppletRunnersQueryVariables>;

/**
 * __useGetDeploymentsQuery__
 *
 * To run a query within a Vue component, call `useGetDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetDeploymentsQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useGetDeploymentsQuery(variables?: Operations.GetDeploymentsQueryVariables | VueCompositionApi.Ref<Operations.GetDeploymentsQueryVariables> | ReactiveFunction<Operations.GetDeploymentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetDeploymentsQuery, Operations.GetDeploymentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetDeploymentsQuery, Operations.GetDeploymentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetDeploymentsQuery, Operations.GetDeploymentsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetDeploymentsQuery, Operations.GetDeploymentsQueryVariables>(Operations.GetDeploymentsDocument, variables, options);
          }
export type GetDeploymentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetDeploymentsQuery, Operations.GetDeploymentsQueryVariables>;

/**
 * __useSelectMaterialModelsForNodeControlQuery__
 *
 * To run a query within a Vue component, call `useSelectMaterialModelsForNodeControlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectMaterialModelsForNodeControlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSelectMaterialModelsForNodeControlQuery(
 *   {
 *      orderBy: // value for 'orderBy'
 *   }
 * );
 */
export function useSelectMaterialModelsForNodeControlQuery(variables: Operations.SelectMaterialModelsForNodeControlQueryVariables | VueCompositionApi.Ref<Operations.SelectMaterialModelsForNodeControlQueryVariables> | ReactiveFunction<Operations.SelectMaterialModelsForNodeControlQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.SelectMaterialModelsForNodeControlQuery, Operations.SelectMaterialModelsForNodeControlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.SelectMaterialModelsForNodeControlQuery, Operations.SelectMaterialModelsForNodeControlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.SelectMaterialModelsForNodeControlQuery, Operations.SelectMaterialModelsForNodeControlQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.SelectMaterialModelsForNodeControlQuery, Operations.SelectMaterialModelsForNodeControlQueryVariables>(Operations.SelectMaterialModelsForNodeControlDocument, variables, options);
          }
export type SelectMaterialModelsForNodeControlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.SelectMaterialModelsForNodeControlQuery, Operations.SelectMaterialModelsForNodeControlQueryVariables>;

/**
 * __useWatchAppletRunnersSubscription__
 *
 * To run a query within a Vue component, call `useWatchAppletRunnersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchAppletRunnersSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useWatchAppletRunnersSubscription(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useWatchAppletRunnersSubscription(variables?: Operations.WatchAppletRunnersSubscriptionVariables | VueCompositionApi.Ref<Operations.WatchAppletRunnersSubscriptionVariables> | ReactiveFunction<Operations.WatchAppletRunnersSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<Operations.WatchAppletRunnersSubscription, Operations.WatchAppletRunnersSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<Operations.WatchAppletRunnersSubscription, Operations.WatchAppletRunnersSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<Operations.WatchAppletRunnersSubscription, Operations.WatchAppletRunnersSubscriptionVariables>> = {}) {
          return VueApolloComposable.useSubscription<Operations.WatchAppletRunnersSubscription, Operations.WatchAppletRunnersSubscriptionVariables>(Operations.WatchAppletRunnersDocument, variables, options);
        }
export type WatchAppletRunnersSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<Operations.WatchAppletRunnersSubscription, Operations.WatchAppletRunnersSubscriptionVariables>;

/**
 * __useGetAllAttributesQuery__
 *
 * To run a query within a Vue component, call `useGetAllAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAttributesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAttributesQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortby: // value for 'sortby'
 *   }
 * );
 */
export function useGetAllAttributesQuery(variables: Operations.GetAllAttributesQueryVariables | VueCompositionApi.Ref<Operations.GetAllAttributesQueryVariables> | ReactiveFunction<Operations.GetAllAttributesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllAttributesQuery, Operations.GetAllAttributesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllAttributesQuery, Operations.GetAllAttributesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllAttributesQuery, Operations.GetAllAttributesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllAttributesQuery, Operations.GetAllAttributesQueryVariables>(Operations.GetAllAttributesDocument, variables, options);
          }
export type GetAllAttributesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllAttributesQuery, Operations.GetAllAttributesQueryVariables>;

/**
 * __useGetAttrSchemaPropsQuery__
 *
 * To run a query within a Vue component, call `useGetAttrSchemaPropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttrSchemaPropsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAttrSchemaPropsQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useGetAttrSchemaPropsQuery(variables?: Operations.GetAttrSchemaPropsQueryVariables | VueCompositionApi.Ref<Operations.GetAttrSchemaPropsQueryVariables> | ReactiveFunction<Operations.GetAttrSchemaPropsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAttrSchemaPropsQuery, Operations.GetAttrSchemaPropsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAttrSchemaPropsQuery, Operations.GetAttrSchemaPropsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAttrSchemaPropsQuery, Operations.GetAttrSchemaPropsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAttrSchemaPropsQuery, Operations.GetAttrSchemaPropsQueryVariables>(Operations.GetAttrSchemaPropsDocument, variables, options);
          }
export type GetAttrSchemaPropsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAttrSchemaPropsQuery, Operations.GetAttrSchemaPropsQueryVariables>;

/**
 * __useGetAllItemsThatUseLocationAttributeQuery__
 *
 * To run a query within a Vue component, call `useGetAllItemsThatUseLocationAttributeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllItemsThatUseLocationAttributeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllItemsThatUseLocationAttributeQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllItemsThatUseLocationAttributeQuery(variables: Operations.GetAllItemsThatUseLocationAttributeQueryVariables | VueCompositionApi.Ref<Operations.GetAllItemsThatUseLocationAttributeQueryVariables> | ReactiveFunction<Operations.GetAllItemsThatUseLocationAttributeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllItemsThatUseLocationAttributeQuery, Operations.GetAllItemsThatUseLocationAttributeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllItemsThatUseLocationAttributeQuery, Operations.GetAllItemsThatUseLocationAttributeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllItemsThatUseLocationAttributeQuery, Operations.GetAllItemsThatUseLocationAttributeQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllItemsThatUseLocationAttributeQuery, Operations.GetAllItemsThatUseLocationAttributeQueryVariables>(Operations.GetAllItemsThatUseLocationAttributeDocument, variables, options);
          }
export type GetAllItemsThatUseLocationAttributeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllItemsThatUseLocationAttributeQuery, Operations.GetAllItemsThatUseLocationAttributeQueryVariables>;

/**
 * __useGetAllItemsThatUseMaterialAttributeQuery__
 *
 * To run a query within a Vue component, call `useGetAllItemsThatUseMaterialAttributeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllItemsThatUseMaterialAttributeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllItemsThatUseMaterialAttributeQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllItemsThatUseMaterialAttributeQuery(variables: Operations.GetAllItemsThatUseMaterialAttributeQueryVariables | VueCompositionApi.Ref<Operations.GetAllItemsThatUseMaterialAttributeQueryVariables> | ReactiveFunction<Operations.GetAllItemsThatUseMaterialAttributeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllItemsThatUseMaterialAttributeQuery, Operations.GetAllItemsThatUseMaterialAttributeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllItemsThatUseMaterialAttributeQuery, Operations.GetAllItemsThatUseMaterialAttributeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllItemsThatUseMaterialAttributeQuery, Operations.GetAllItemsThatUseMaterialAttributeQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllItemsThatUseMaterialAttributeQuery, Operations.GetAllItemsThatUseMaterialAttributeQueryVariables>(Operations.GetAllItemsThatUseMaterialAttributeDocument, variables, options);
          }
export type GetAllItemsThatUseMaterialAttributeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllItemsThatUseMaterialAttributeQuery, Operations.GetAllItemsThatUseMaterialAttributeQueryVariables>;

/**
 * __useGetAttributeForMaterialQuery__
 *
 * To run a query within a Vue component, call `useGetAttributeForMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttributeForMaterialQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAttributeForMaterialQuery(
 *   {
 *      attributeId: // value for 'attributeId'
 *      serialNumber: // value for 'serialNumber'
 *   }
 * );
 */
export function useGetAttributeForMaterialQuery(variables: Operations.GetAttributeForMaterialQueryVariables | VueCompositionApi.Ref<Operations.GetAttributeForMaterialQueryVariables> | ReactiveFunction<Operations.GetAttributeForMaterialQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAttributeForMaterialQuery, Operations.GetAttributeForMaterialQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAttributeForMaterialQuery, Operations.GetAttributeForMaterialQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAttributeForMaterialQuery, Operations.GetAttributeForMaterialQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAttributeForMaterialQuery, Operations.GetAttributeForMaterialQueryVariables>(Operations.GetAttributeForMaterialDocument, variables, options);
          }
export type GetAttributeForMaterialQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAttributeForMaterialQuery, Operations.GetAttributeForMaterialQueryVariables>;

/**
 * __useGetSchemaQuery__
 *
 * To run a query within a Vue component, call `useGetSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchemaQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSchemaQuery(
 *   {
 *      schemaId: // value for 'schemaId'
 *   }
 * );
 */
export function useGetSchemaQuery(variables: Operations.GetSchemaQueryVariables | VueCompositionApi.Ref<Operations.GetSchemaQueryVariables> | ReactiveFunction<Operations.GetSchemaQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetSchemaQuery, Operations.GetSchemaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetSchemaQuery, Operations.GetSchemaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetSchemaQuery, Operations.GetSchemaQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetSchemaQuery, Operations.GetSchemaQueryVariables>(Operations.GetSchemaDocument, variables, options);
          }
export type GetSchemaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetSchemaQuery, Operations.GetSchemaQueryVariables>;

/**
 * __useInsertSchemaMutation__
 *
 * To run a mutation, you first call `useInsertSchemaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertSchemaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertSchemaMutation({
 *   variables: {
 *      schemas: // value for 'schemas'
 *   },
 * });
 */
export function useInsertSchemaMutation(options: VueApolloComposable.UseMutationOptions<Operations.InsertSchemaMutation, Operations.InsertSchemaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.InsertSchemaMutation, Operations.InsertSchemaMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.InsertSchemaMutation, Operations.InsertSchemaMutationVariables>(Operations.InsertSchemaDocument, options);
          }
export type InsertSchemaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.InsertSchemaMutation, Operations.InsertSchemaMutationVariables>;

/**
 * __useRetroApplyNewAttributeLinksMutation__
 *
 * To run a mutation, you first call `useRetroApplyNewAttributeLinksMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetroApplyNewAttributeLinksMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetroApplyNewAttributeLinksMutation({
 *   variables: {
 *      oldAttributeId: // value for 'oldAttributeId'
 *      newAttributeId: // value for 'newAttributeId'
 *      includeLocation: // value for 'includeLocation'
 *      locationIds: // value for 'locationIds'
 *      includeMaterial: // value for 'includeMaterial'
 *      materialIds: // value for 'materialIds'
 *      includeMaterialModel: // value for 'includeMaterialModel'
 *      materialModelIds: // value for 'materialModelIds'
 *      includeMaterialClass: // value for 'includeMaterialClass'
 *      materialClassIds: // value for 'materialClassIds'
 *   },
 * });
 */
export function useRetroApplyNewAttributeLinksMutation(options: VueApolloComposable.UseMutationOptions<Operations.RetroApplyNewAttributeLinksMutation, Operations.RetroApplyNewAttributeLinksMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.RetroApplyNewAttributeLinksMutation, Operations.RetroApplyNewAttributeLinksMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.RetroApplyNewAttributeLinksMutation, Operations.RetroApplyNewAttributeLinksMutationVariables>(Operations.RetroApplyNewAttributeLinksDocument, options);
          }
export type RetroApplyNewAttributeLinksMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.RetroApplyNewAttributeLinksMutation, Operations.RetroApplyNewAttributeLinksMutationVariables>;

/**
 * __useGetAllSchemasQuery__
 *
 * To run a query within a Vue component, call `useGetAllSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSchemasQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllSchemasQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortby: // value for 'sortby'
 *   }
 * );
 */
export function useGetAllSchemasQuery(variables?: Operations.GetAllSchemasQueryVariables | VueCompositionApi.Ref<Operations.GetAllSchemasQueryVariables> | ReactiveFunction<Operations.GetAllSchemasQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllSchemasQuery, Operations.GetAllSchemasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllSchemasQuery, Operations.GetAllSchemasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllSchemasQuery, Operations.GetAllSchemasQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllSchemasQuery, Operations.GetAllSchemasQueryVariables>(Operations.GetAllSchemasDocument, variables, options);
          }
export type GetAllSchemasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllSchemasQuery, Operations.GetAllSchemasQueryVariables>;

/**
 * __useSetAttributeToDisabledMutation__
 *
 * To run a mutation, you first call `useSetAttributeToDisabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetAttributeToDisabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetAttributeToDisabledMutation({
 *   variables: {
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useSetAttributeToDisabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetAttributeToDisabledMutation, Operations.SetAttributeToDisabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetAttributeToDisabledMutation, Operations.SetAttributeToDisabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetAttributeToDisabledMutation, Operations.SetAttributeToDisabledMutationVariables>(Operations.SetAttributeToDisabledDocument, options);
          }
export type SetAttributeToDisabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetAttributeToDisabledMutation, Operations.SetAttributeToDisabledMutationVariables>;

/**
 * __useSetSchemaToDisabledMutation__
 *
 * To run a mutation, you first call `useSetSchemaToDisabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetSchemaToDisabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetSchemaToDisabledMutation({
 *   variables: {
 *      schemaId: // value for 'schemaId'
 *   },
 * });
 */
export function useSetSchemaToDisabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetSchemaToDisabledMutation, Operations.SetSchemaToDisabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetSchemaToDisabledMutation, Operations.SetSchemaToDisabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetSchemaToDisabledMutation, Operations.SetSchemaToDisabledMutationVariables>(Operations.SetSchemaToDisabledDocument, options);
          }
export type SetSchemaToDisabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetSchemaToDisabledMutation, Operations.SetSchemaToDisabledMutationVariables>;

/**
 * __useUpdateSchemaMutation__
 *
 * To run a mutation, you first call `useUpdateSchemaMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchemaMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSchemaMutation({
 *   variables: {
 *      schemaId: // value for 'schemaId'
 *      attributeIdsToDelete: // value for 'attributeIdsToDelete'
 *      schema: // value for 'schema'
 *      schemaDefs: // value for 'schemaDefs'
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useUpdateSchemaMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateSchemaMutation, Operations.UpdateSchemaMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateSchemaMutation, Operations.UpdateSchemaMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateSchemaMutation, Operations.UpdateSchemaMutationVariables>(Operations.UpdateSchemaDocument, options);
          }
export type UpdateSchemaMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateSchemaMutation, Operations.UpdateSchemaMutationVariables>;

/**
 * __useAllEnabledUserAclsQuery__
 *
 * To run a query within a Vue component, call `useAllEnabledUserAclsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEnabledUserAclsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllEnabledUserAclsQuery(
 *   {
 *      userId: // value for 'userId'
 *   }
 * );
 */
export function useAllEnabledUserAclsQuery(variables: Operations.AllEnabledUserAclsQueryVariables | VueCompositionApi.Ref<Operations.AllEnabledUserAclsQueryVariables> | ReactiveFunction<Operations.AllEnabledUserAclsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.AllEnabledUserAclsQuery, Operations.AllEnabledUserAclsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.AllEnabledUserAclsQuery, Operations.AllEnabledUserAclsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.AllEnabledUserAclsQuery, Operations.AllEnabledUserAclsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.AllEnabledUserAclsQuery, Operations.AllEnabledUserAclsQueryVariables>(Operations.AllEnabledUserAclsDocument, variables, options);
          }
export type AllEnabledUserAclsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.AllEnabledUserAclsQuery, Operations.AllEnabledUserAclsQueryVariables>;

/**
 * __useAllUserContextsQuery__
 *
 * To run a query within a Vue component, call `useAllUserContextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserContextsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAllUserContextsQuery(
 *   {
 *   }
 * );
 */
export function useAllUserContextsQuery(options: VueApolloComposable.UseQueryOptions<Operations.AllUserContextsQuery, Operations.AllUserContextsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.AllUserContextsQuery, Operations.AllUserContextsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.AllUserContextsQuery, Operations.AllUserContextsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.AllUserContextsQuery, undefined>(Operations.AllUserContextsDocument, undefined, options);
          }
export type AllUserContextsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.AllUserContextsQuery, Operations.AllUserContextsQueryVariables>;

/**
 * __useGetAssetsForListViewQuery__
 *
 * To run a query within a Vue component, call `useGetAssetsForListViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsForListViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAssetsForListViewQuery(
 *   {
 *   }
 * );
 */
export function useGetAssetsForListViewQuery(options: VueApolloComposable.UseQueryOptions<Operations.GetAssetsForListViewQuery, Operations.GetAssetsForListViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAssetsForListViewQuery, Operations.GetAssetsForListViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAssetsForListViewQuery, Operations.GetAssetsForListViewQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAssetsForListViewQuery, undefined>(Operations.GetAssetsForListViewDocument, undefined, options);
          }
export type GetAssetsForListViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAssetsForListViewQuery, Operations.GetAssetsForListViewQueryVariables>;

/**
 * __useGetAttributeHistoryForItemQuery__
 *
 * To run a query within a Vue component, call `useGetAttributeHistoryForItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttributeHistoryForItemQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAttributeHistoryForItemQuery(
 *   {
 *      itemId: // value for 'itemId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      includeMaterial: // value for 'includeMaterial'
 *      includeLocation: // value for 'includeLocation'
 *   }
 * );
 */
export function useGetAttributeHistoryForItemQuery(variables: Operations.GetAttributeHistoryForItemQueryVariables | VueCompositionApi.Ref<Operations.GetAttributeHistoryForItemQueryVariables> | ReactiveFunction<Operations.GetAttributeHistoryForItemQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAttributeHistoryForItemQuery, Operations.GetAttributeHistoryForItemQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAttributeHistoryForItemQuery, Operations.GetAttributeHistoryForItemQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAttributeHistoryForItemQuery, Operations.GetAttributeHistoryForItemQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAttributeHistoryForItemQuery, Operations.GetAttributeHistoryForItemQueryVariables>(Operations.GetAttributeHistoryForItemDocument, variables, options);
          }
export type GetAttributeHistoryForItemQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAttributeHistoryForItemQuery, Operations.GetAttributeHistoryForItemQueryVariables>;

/**
 * __useGetAttributeDetailQuery__
 *
 * To run a query within a Vue component, call `useGetAttributeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttributeDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAttributeDetailQuery(
 *   {
 *      attributeIds: // value for 'attributeIds'
 *   }
 * );
 */
export function useGetAttributeDetailQuery(variables: Operations.GetAttributeDetailQueryVariables | VueCompositionApi.Ref<Operations.GetAttributeDetailQueryVariables> | ReactiveFunction<Operations.GetAttributeDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAttributeDetailQuery, Operations.GetAttributeDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAttributeDetailQuery, Operations.GetAttributeDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAttributeDetailQuery, Operations.GetAttributeDetailQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAttributeDetailQuery, Operations.GetAttributeDetailQueryVariables>(Operations.GetAttributeDetailDocument, variables, options);
          }
export type GetAttributeDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAttributeDetailQuery, Operations.GetAttributeDetailQueryVariables>;

/**
 * __useGetAttributeSchemaTypesQuery__
 *
 * To run a query within a Vue component, call `useGetAttributeSchemaTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttributeSchemaTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAttributeSchemaTypesQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAttributeSchemaTypesQuery(variables: Operations.GetAttributeSchemaTypesQueryVariables | VueCompositionApi.Ref<Operations.GetAttributeSchemaTypesQueryVariables> | ReactiveFunction<Operations.GetAttributeSchemaTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAttributeSchemaTypesQuery, Operations.GetAttributeSchemaTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAttributeSchemaTypesQuery, Operations.GetAttributeSchemaTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAttributeSchemaTypesQuery, Operations.GetAttributeSchemaTypesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAttributeSchemaTypesQuery, Operations.GetAttributeSchemaTypesQueryVariables>(Operations.GetAttributeSchemaTypesDocument, variables, options);
          }
export type GetAttributeSchemaTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAttributeSchemaTypesQuery, Operations.GetAttributeSchemaTypesQueryVariables>;

/**
 * __useAttributeSelectorQuery__
 *
 * To run a query within a Vue component, call `useAttributeSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAttributeSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *      selectedAttributes: // value for 'selectedAttributes'
 *   }
 * );
 */
export function useAttributeSelectorQuery(variables: Operations.AttributeSelectorQueryVariables | VueCompositionApi.Ref<Operations.AttributeSelectorQueryVariables> | ReactiveFunction<Operations.AttributeSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.AttributeSelectorQuery, Operations.AttributeSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.AttributeSelectorQuery, Operations.AttributeSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.AttributeSelectorQuery, Operations.AttributeSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.AttributeSelectorQuery, Operations.AttributeSelectorQueryVariables>(Operations.AttributeSelectorDocument, variables, options);
          }
export type AttributeSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.AttributeSelectorQuery, Operations.AttributeSelectorQueryVariables>;

/**
 * __useAuthProviderSelectorQuery__
 *
 * To run a query within a Vue component, call `useAuthProviderSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthProviderSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAuthProviderSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useAuthProviderSelectorQuery(variables: Operations.AuthProviderSelectorQueryVariables | VueCompositionApi.Ref<Operations.AuthProviderSelectorQueryVariables> | ReactiveFunction<Operations.AuthProviderSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.AuthProviderSelectorQuery, Operations.AuthProviderSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.AuthProviderSelectorQuery, Operations.AuthProviderSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.AuthProviderSelectorQuery, Operations.AuthProviderSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.AuthProviderSelectorQuery, Operations.AuthProviderSelectorQueryVariables>(Operations.AuthProviderSelectorDocument, variables, options);
          }
export type AuthProviderSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.AuthProviderSelectorQuery, Operations.AuthProviderSelectorQueryVariables>;

/**
 * __useCalendarSelectorQuery__
 *
 * To run a query within a Vue component, call `useCalendarSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCalendarSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useCalendarSelectorQuery(variables: Operations.CalendarSelectorQueryVariables | VueCompositionApi.Ref<Operations.CalendarSelectorQueryVariables> | ReactiveFunction<Operations.CalendarSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.CalendarSelectorQuery, Operations.CalendarSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.CalendarSelectorQuery, Operations.CalendarSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.CalendarSelectorQuery, Operations.CalendarSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.CalendarSelectorQuery, Operations.CalendarSelectorQueryVariables>(Operations.CalendarSelectorDocument, variables, options);
          }
export type CalendarSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.CalendarSelectorQuery, Operations.CalendarSelectorQueryVariables>;

/**
 * __useDesignVerSelectorQuery__
 *
 * To run a query within a Vue component, call `useDesignVerSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignVerSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDesignVerSelectorQuery(
 *   {
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   }
 * );
 */
export function useDesignVerSelectorQuery(variables: Operations.DesignVerSelectorQueryVariables | VueCompositionApi.Ref<Operations.DesignVerSelectorQueryVariables> | ReactiveFunction<Operations.DesignVerSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.DesignVerSelectorQuery, Operations.DesignVerSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.DesignVerSelectorQuery, Operations.DesignVerSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.DesignVerSelectorQuery, Operations.DesignVerSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.DesignVerSelectorQuery, Operations.DesignVerSelectorQueryVariables>(Operations.DesignVerSelectorDocument, variables, options);
          }
export type DesignVerSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.DesignVerSelectorQuery, Operations.DesignVerSelectorQueryVariables>;

/**
 * __useEventSelectorQuery__
 *
 * To run a query within a Vue component, call `useEventSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEventSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useEventSelectorQuery(variables: Operations.EventSelectorQueryVariables | VueCompositionApi.Ref<Operations.EventSelectorQueryVariables> | ReactiveFunction<Operations.EventSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.EventSelectorQuery, Operations.EventSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.EventSelectorQuery, Operations.EventSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.EventSelectorQuery, Operations.EventSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.EventSelectorQuery, Operations.EventSelectorQueryVariables>(Operations.EventSelectorDocument, variables, options);
          }
export type EventSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.EventSelectorQuery, Operations.EventSelectorQueryVariables>;

/**
 * __useLocationClassSelectorQuery__
 *
 * To run a query within a Vue component, call `useLocationClassSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationClassSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLocationClassSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useLocationClassSelectorQuery(variables: Operations.LocationClassSelectorQueryVariables | VueCompositionApi.Ref<Operations.LocationClassSelectorQueryVariables> | ReactiveFunction<Operations.LocationClassSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.LocationClassSelectorQuery, Operations.LocationClassSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.LocationClassSelectorQuery, Operations.LocationClassSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.LocationClassSelectorQuery, Operations.LocationClassSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.LocationClassSelectorQuery, Operations.LocationClassSelectorQueryVariables>(Operations.LocationClassSelectorDocument, variables, options);
          }
export type LocationClassSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.LocationClassSelectorQuery, Operations.LocationClassSelectorQueryVariables>;

/**
 * __useLocationSelectorQuery__
 *
 * To run a query within a Vue component, call `useLocationSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLocationSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useLocationSelectorQuery(variables: Operations.LocationSelectorQueryVariables | VueCompositionApi.Ref<Operations.LocationSelectorQueryVariables> | ReactiveFunction<Operations.LocationSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.LocationSelectorQuery, Operations.LocationSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.LocationSelectorQuery, Operations.LocationSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.LocationSelectorQuery, Operations.LocationSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.LocationSelectorQuery, Operations.LocationSelectorQueryVariables>(Operations.LocationSelectorDocument, variables, options);
          }
export type LocationSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.LocationSelectorQuery, Operations.LocationSelectorQueryVariables>;

/**
 * __useMaterialChipQuery__
 *
 * To run a query within a Vue component, call `useMaterialChipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialChipQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMaterialChipQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useMaterialChipQuery(variables: Operations.MaterialChipQueryVariables | VueCompositionApi.Ref<Operations.MaterialChipQueryVariables> | ReactiveFunction<Operations.MaterialChipQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.MaterialChipQuery, Operations.MaterialChipQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.MaterialChipQuery, Operations.MaterialChipQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.MaterialChipQuery, Operations.MaterialChipQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.MaterialChipQuery, Operations.MaterialChipQueryVariables>(Operations.MaterialChipDocument, variables, options);
          }
export type MaterialChipQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.MaterialChipQuery, Operations.MaterialChipQueryVariables>;

/**
 * __useMaterialClassChipQuery__
 *
 * To run a query within a Vue component, call `useMaterialClassChipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialClassChipQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMaterialClassChipQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useMaterialClassChipQuery(variables?: Operations.MaterialClassChipQueryVariables | VueCompositionApi.Ref<Operations.MaterialClassChipQueryVariables> | ReactiveFunction<Operations.MaterialClassChipQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.MaterialClassChipQuery, Operations.MaterialClassChipQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.MaterialClassChipQuery, Operations.MaterialClassChipQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.MaterialClassChipQuery, Operations.MaterialClassChipQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.MaterialClassChipQuery, Operations.MaterialClassChipQueryVariables>(Operations.MaterialClassChipDocument, variables, options);
          }
export type MaterialClassChipQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.MaterialClassChipQuery, Operations.MaterialClassChipQueryVariables>;

/**
 * __useMaterialModelChipQuery__
 *
 * To run a query within a Vue component, call `useMaterialModelChipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialModelChipQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMaterialModelChipQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useMaterialModelChipQuery(variables?: Operations.MaterialModelChipQueryVariables | VueCompositionApi.Ref<Operations.MaterialModelChipQueryVariables> | ReactiveFunction<Operations.MaterialModelChipQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.MaterialModelChipQuery, Operations.MaterialModelChipQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.MaterialModelChipQuery, Operations.MaterialModelChipQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.MaterialModelChipQuery, Operations.MaterialModelChipQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.MaterialModelChipQuery, Operations.MaterialModelChipQueryVariables>(Operations.MaterialModelChipDocument, variables, options);
          }
export type MaterialModelChipQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.MaterialModelChipQuery, Operations.MaterialModelChipQueryVariables>;

/**
 * __useMaterialModelSelectorQuery__
 *
 * To run a query within a Vue component, call `useMaterialModelSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialModelSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMaterialModelSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useMaterialModelSelectorQuery(variables: Operations.MaterialModelSelectorQueryVariables | VueCompositionApi.Ref<Operations.MaterialModelSelectorQueryVariables> | ReactiveFunction<Operations.MaterialModelSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.MaterialModelSelectorQuery, Operations.MaterialModelSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.MaterialModelSelectorQuery, Operations.MaterialModelSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.MaterialModelSelectorQuery, Operations.MaterialModelSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.MaterialModelSelectorQuery, Operations.MaterialModelSelectorQueryVariables>(Operations.MaterialModelSelectorDocument, variables, options);
          }
export type MaterialModelSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.MaterialModelSelectorQuery, Operations.MaterialModelSelectorQueryVariables>;

/**
 * __useGetMediaQuery__
 *
 * To run a query within a Vue component, call `useGetMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMediaQuery(
 *   {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   }
 * );
 */
export function useGetMediaQuery(variables?: Operations.GetMediaQueryVariables | VueCompositionApi.Ref<Operations.GetMediaQueryVariables> | ReactiveFunction<Operations.GetMediaQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetMediaQuery, Operations.GetMediaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetMediaQuery, Operations.GetMediaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetMediaQuery, Operations.GetMediaQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetMediaQuery, Operations.GetMediaQueryVariables>(Operations.GetMediaDocument, variables, options);
          }
export type GetMediaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetMediaQuery, Operations.GetMediaQueryVariables>;

/**
 * __useProcessTableQuery__
 *
 * To run a query within a Vue component, call `useProcessTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessTableQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProcessTableQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *      includePdeObj: // value for 'includePdeObj'
 *   }
 * );
 */
export function useProcessTableQuery(variables: Operations.ProcessTableQueryVariables | VueCompositionApi.Ref<Operations.ProcessTableQueryVariables> | ReactiveFunction<Operations.ProcessTableQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.ProcessTableQuery, Operations.ProcessTableQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.ProcessTableQuery, Operations.ProcessTableQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.ProcessTableQuery, Operations.ProcessTableQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.ProcessTableQuery, Operations.ProcessTableQueryVariables>(Operations.ProcessTableDocument, variables, options);
          }
export type ProcessTableQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.ProcessTableQuery, Operations.ProcessTableQueryVariables>;

/**
 * __useProcessMaterialStatusHistoryQuery__
 *
 * To run a query within a Vue component, call `useProcessMaterialStatusHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessMaterialStatusHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useProcessMaterialStatusHistoryQuery(
 *   {
 *      materialStateId: // value for 'materialStateId'
 *   }
 * );
 */
export function useProcessMaterialStatusHistoryQuery(variables: Operations.ProcessMaterialStatusHistoryQueryVariables | VueCompositionApi.Ref<Operations.ProcessMaterialStatusHistoryQueryVariables> | ReactiveFunction<Operations.ProcessMaterialStatusHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.ProcessMaterialStatusHistoryQuery, Operations.ProcessMaterialStatusHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.ProcessMaterialStatusHistoryQuery, Operations.ProcessMaterialStatusHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.ProcessMaterialStatusHistoryQuery, Operations.ProcessMaterialStatusHistoryQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.ProcessMaterialStatusHistoryQuery, Operations.ProcessMaterialStatusHistoryQueryVariables>(Operations.ProcessMaterialStatusHistoryDocument, variables, options);
          }
export type ProcessMaterialStatusHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.ProcessMaterialStatusHistoryQuery, Operations.ProcessMaterialStatusHistoryQueryVariables>;

/**
 * __useUpdateMaterialProcessStateMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialProcessStateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialProcessStateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMaterialProcessStateMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useUpdateMaterialProcessStateMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialProcessStateMutation, Operations.UpdateMaterialProcessStateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialProcessStateMutation, Operations.UpdateMaterialProcessStateMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateMaterialProcessStateMutation, Operations.UpdateMaterialProcessStateMutationVariables>(Operations.UpdateMaterialProcessStateDocument, options);
          }
export type UpdateMaterialProcessStateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateMaterialProcessStateMutation, Operations.UpdateMaterialProcessStateMutationVariables>;

/**
 * __useRoleSelectorQuery__
 *
 * To run a query within a Vue component, call `useRoleSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRoleSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useRoleSelectorQuery(variables: Operations.RoleSelectorQueryVariables | VueCompositionApi.Ref<Operations.RoleSelectorQueryVariables> | ReactiveFunction<Operations.RoleSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.RoleSelectorQuery, Operations.RoleSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.RoleSelectorQuery, Operations.RoleSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.RoleSelectorQuery, Operations.RoleSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.RoleSelectorQuery, Operations.RoleSelectorQueryVariables>(Operations.RoleSelectorDocument, variables, options);
          }
export type RoleSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.RoleSelectorQuery, Operations.RoleSelectorQueryVariables>;

/**
 * __useScheduleSelectorQuery__
 *
 * To run a query within a Vue component, call `useScheduleSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useScheduleSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useScheduleSelectorQuery(variables: Operations.ScheduleSelectorQueryVariables | VueCompositionApi.Ref<Operations.ScheduleSelectorQueryVariables> | ReactiveFunction<Operations.ScheduleSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.ScheduleSelectorQuery, Operations.ScheduleSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.ScheduleSelectorQuery, Operations.ScheduleSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.ScheduleSelectorQuery, Operations.ScheduleSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.ScheduleSelectorQuery, Operations.ScheduleSelectorQueryVariables>(Operations.ScheduleSelectorDocument, variables, options);
          }
export type ScheduleSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.ScheduleSelectorQuery, Operations.ScheduleSelectorQueryVariables>;

/**
 * __useSerialNumberFormatSelectorQuery__
 *
 * To run a query within a Vue component, call `useSerialNumberFormatSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSerialNumberFormatSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSerialNumberFormatSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useSerialNumberFormatSelectorQuery(variables: Operations.SerialNumberFormatSelectorQueryVariables | VueCompositionApi.Ref<Operations.SerialNumberFormatSelectorQueryVariables> | ReactiveFunction<Operations.SerialNumberFormatSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.SerialNumberFormatSelectorQuery, Operations.SerialNumberFormatSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.SerialNumberFormatSelectorQuery, Operations.SerialNumberFormatSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.SerialNumberFormatSelectorQuery, Operations.SerialNumberFormatSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.SerialNumberFormatSelectorQuery, Operations.SerialNumberFormatSelectorQueryVariables>(Operations.SerialNumberFormatSelectorDocument, variables, options);
          }
export type SerialNumberFormatSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.SerialNumberFormatSelectorQuery, Operations.SerialNumberFormatSelectorQueryVariables>;

/**
 * __useTzSelectorQuery__
 *
 * To run a query within a Vue component, call `useTzSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useTzSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTzSelectorQuery(
 *   {
 *   }
 * );
 */
export function useTzSelectorQuery(options: VueApolloComposable.UseQueryOptions<Operations.TzSelectorQuery, Operations.TzSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.TzSelectorQuery, Operations.TzSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.TzSelectorQuery, Operations.TzSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.TzSelectorQuery, undefined>(Operations.TzSelectorDocument, undefined, options);
          }
export type TzSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.TzSelectorQuery, Operations.TzSelectorQueryVariables>;

/**
 * __useUdfColumnSelectorQuery__
 *
 * To run a query within a Vue component, call `useUdfColumnSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useUdfColumnSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUdfColumnSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useUdfColumnSelectorQuery(variables: Operations.UdfColumnSelectorQueryVariables | VueCompositionApi.Ref<Operations.UdfColumnSelectorQueryVariables> | ReactiveFunction<Operations.UdfColumnSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.UdfColumnSelectorQuery, Operations.UdfColumnSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.UdfColumnSelectorQuery, Operations.UdfColumnSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.UdfColumnSelectorQuery, Operations.UdfColumnSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.UdfColumnSelectorQuery, Operations.UdfColumnSelectorQueryVariables>(Operations.UdfColumnSelectorDocument, variables, options);
          }
export type UdfColumnSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.UdfColumnSelectorQuery, Operations.UdfColumnSelectorQueryVariables>;

/**
 * __useUserSelectorQuery__
 *
 * To run a query within a Vue component, call `useUserSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useUserSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useUserSelectorQuery(variables: Operations.UserSelectorQueryVariables | VueCompositionApi.Ref<Operations.UserSelectorQueryVariables> | ReactiveFunction<Operations.UserSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.UserSelectorQuery, Operations.UserSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.UserSelectorQuery, Operations.UserSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.UserSelectorQuery, Operations.UserSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.UserSelectorQuery, Operations.UserSelectorQueryVariables>(Operations.UserSelectorDocument, variables, options);
          }
export type UserSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.UserSelectorQuery, Operations.UserSelectorQueryVariables>;

/**
 * __useGetAllNonRetiredConnectionConfigsForConnectionQuery__
 *
 * To run a query within a Vue component, call `useGetAllNonRetiredConnectionConfigsForConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNonRetiredConnectionConfigsForConnectionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllNonRetiredConnectionConfigsForConnectionQuery(
 *   {
 *      connectionId: // value for 'connectionId'
 *   }
 * );
 */
export function useGetAllNonRetiredConnectionConfigsForConnectionQuery(variables: Operations.GetAllNonRetiredConnectionConfigsForConnectionQueryVariables | VueCompositionApi.Ref<Operations.GetAllNonRetiredConnectionConfigsForConnectionQueryVariables> | ReactiveFunction<Operations.GetAllNonRetiredConnectionConfigsForConnectionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllNonRetiredConnectionConfigsForConnectionQuery, Operations.GetAllNonRetiredConnectionConfigsForConnectionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllNonRetiredConnectionConfigsForConnectionQuery, Operations.GetAllNonRetiredConnectionConfigsForConnectionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllNonRetiredConnectionConfigsForConnectionQuery, Operations.GetAllNonRetiredConnectionConfigsForConnectionQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllNonRetiredConnectionConfigsForConnectionQuery, Operations.GetAllNonRetiredConnectionConfigsForConnectionQueryVariables>(Operations.GetAllNonRetiredConnectionConfigsForConnectionDocument, variables, options);
          }
export type GetAllNonRetiredConnectionConfigsForConnectionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllNonRetiredConnectionConfigsForConnectionQuery, Operations.GetAllNonRetiredConnectionConfigsForConnectionQueryVariables>;

/**
 * __useGetConnectionConfigByIdQuery__
 *
 * To run a query within a Vue component, call `useGetConnectionConfigByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionConfigByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConnectionConfigByIdQuery(
 *   {
 *      connectionConfigId: // value for 'connectionConfigId'
 *   }
 * );
 */
export function useGetConnectionConfigByIdQuery(variables: Operations.GetConnectionConfigByIdQueryVariables | VueCompositionApi.Ref<Operations.GetConnectionConfigByIdQueryVariables> | ReactiveFunction<Operations.GetConnectionConfigByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetConnectionConfigByIdQuery, Operations.GetConnectionConfigByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetConnectionConfigByIdQuery, Operations.GetConnectionConfigByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetConnectionConfigByIdQuery, Operations.GetConnectionConfigByIdQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetConnectionConfigByIdQuery, Operations.GetConnectionConfigByIdQueryVariables>(Operations.GetConnectionConfigByIdDocument, variables, options);
          }
export type GetConnectionConfigByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetConnectionConfigByIdQuery, Operations.GetConnectionConfigByIdQueryVariables>;

/**
 * __useGetConnectionConfigsForListQuery__
 *
 * To run a query within a Vue component, call `useGetConnectionConfigsForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionConfigsForListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetConnectionConfigsForListQuery(
 *   {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   }
 * );
 */
export function useGetConnectionConfigsForListQuery(variables: Operations.GetConnectionConfigsForListQueryVariables | VueCompositionApi.Ref<Operations.GetConnectionConfigsForListQueryVariables> | ReactiveFunction<Operations.GetConnectionConfigsForListQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetConnectionConfigsForListQuery, Operations.GetConnectionConfigsForListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetConnectionConfigsForListQuery, Operations.GetConnectionConfigsForListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetConnectionConfigsForListQuery, Operations.GetConnectionConfigsForListQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetConnectionConfigsForListQuery, Operations.GetConnectionConfigsForListQueryVariables>(Operations.GetConnectionConfigsForListDocument, variables, options);
          }
export type GetConnectionConfigsForListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetConnectionConfigsForListQuery, Operations.GetConnectionConfigsForListQueryVariables>;

/**
 * __useGetCurrentlyActivatedConnectionConfigQuery__
 *
 * To run a query within a Vue component, call `useGetCurrentlyActivatedConnectionConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentlyActivatedConnectionConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCurrentlyActivatedConnectionConfigQuery(
 *   {
 *      connectionId: // value for 'connectionId'
 *   }
 * );
 */
export function useGetCurrentlyActivatedConnectionConfigQuery(variables: Operations.GetCurrentlyActivatedConnectionConfigQueryVariables | VueCompositionApi.Ref<Operations.GetCurrentlyActivatedConnectionConfigQueryVariables> | ReactiveFunction<Operations.GetCurrentlyActivatedConnectionConfigQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetCurrentlyActivatedConnectionConfigQuery, Operations.GetCurrentlyActivatedConnectionConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetCurrentlyActivatedConnectionConfigQuery, Operations.GetCurrentlyActivatedConnectionConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetCurrentlyActivatedConnectionConfigQuery, Operations.GetCurrentlyActivatedConnectionConfigQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetCurrentlyActivatedConnectionConfigQuery, Operations.GetCurrentlyActivatedConnectionConfigQueryVariables>(Operations.GetCurrentlyActivatedConnectionConfigDocument, variables, options);
          }
export type GetCurrentlyActivatedConnectionConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetCurrentlyActivatedConnectionConfigQuery, Operations.GetCurrentlyActivatedConnectionConfigQueryVariables>;

/**
 * __useGetLatestConnectionConfigVersionNumberQuery__
 *
 * To run a query within a Vue component, call `useGetLatestConnectionConfigVersionNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestConnectionConfigVersionNumberQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLatestConnectionConfigVersionNumberQuery(
 *   {
 *      connectionId: // value for 'connectionId'
 *   }
 * );
 */
export function useGetLatestConnectionConfigVersionNumberQuery(variables: Operations.GetLatestConnectionConfigVersionNumberQueryVariables | VueCompositionApi.Ref<Operations.GetLatestConnectionConfigVersionNumberQueryVariables> | ReactiveFunction<Operations.GetLatestConnectionConfigVersionNumberQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetLatestConnectionConfigVersionNumberQuery, Operations.GetLatestConnectionConfigVersionNumberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetLatestConnectionConfigVersionNumberQuery, Operations.GetLatestConnectionConfigVersionNumberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetLatestConnectionConfigVersionNumberQuery, Operations.GetLatestConnectionConfigVersionNumberQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetLatestConnectionConfigVersionNumberQuery, Operations.GetLatestConnectionConfigVersionNumberQueryVariables>(Operations.GetLatestConnectionConfigVersionNumberDocument, variables, options);
          }
export type GetLatestConnectionConfigVersionNumberQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetLatestConnectionConfigVersionNumberQuery, Operations.GetLatestConnectionConfigVersionNumberQueryVariables>;

/**
 * __useGetAllRolesForContextQuery__
 *
 * To run a query within a Vue component, call `useGetAllRolesForContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRolesForContextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllRolesForContextQuery(
 *   {
 *      contextId: // value for 'contextId'
 *   }
 * );
 */
export function useGetAllRolesForContextQuery(variables: Operations.GetAllRolesForContextQueryVariables | VueCompositionApi.Ref<Operations.GetAllRolesForContextQueryVariables> | ReactiveFunction<Operations.GetAllRolesForContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllRolesForContextQuery, Operations.GetAllRolesForContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllRolesForContextQuery, Operations.GetAllRolesForContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllRolesForContextQuery, Operations.GetAllRolesForContextQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllRolesForContextQuery, Operations.GetAllRolesForContextQueryVariables>(Operations.GetAllRolesForContextDocument, variables, options);
          }
export type GetAllRolesForContextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllRolesForContextQuery, Operations.GetAllRolesForContextQueryVariables>;

/**
 * __useAddContextMutation__
 *
 * To run a mutation, you first call `useAddContextMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddContextMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddContextMutation({
 *   variables: {
 *      context: // value for 'context'
 *      deleteArgoUserRoles: // value for 'deleteArgoUserRoles'
 *      contextUserRoles: // value for 'contextUserRoles'
 *      argoAuthProviderMsalSetting: // value for 'argoAuthProviderMsalSetting'
 *      argoAuthProviderLocalSetting: // value for 'argoAuthProviderLocalSetting'
 *   },
 * });
 */
export function useAddContextMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddContextMutation, Operations.AddContextMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddContextMutation, Operations.AddContextMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddContextMutation, Operations.AddContextMutationVariables>(Operations.AddContextDocument, options);
          }
export type AddContextMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddContextMutation, Operations.AddContextMutationVariables>;

/**
 * __useGetAllContextsQuery__
 *
 * To run a query within a Vue component, call `useGetAllContextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContextsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllContextsQuery(
 *   {
 *      contextFilter: // value for 'contextFilter'
 *   }
 * );
 */
export function useGetAllContextsQuery(variables?: Operations.GetAllContextsQueryVariables | VueCompositionApi.Ref<Operations.GetAllContextsQueryVariables> | ReactiveFunction<Operations.GetAllContextsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllContextsQuery, Operations.GetAllContextsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllContextsQuery, Operations.GetAllContextsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllContextsQuery, Operations.GetAllContextsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllContextsQuery, Operations.GetAllContextsQueryVariables>(Operations.GetAllContextsDocument, variables, options);
          }
export type GetAllContextsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllContextsQuery, Operations.GetAllContextsQueryVariables>;

/**
 * __useGetAuthProviderSettingsQuery__
 *
 * To run a query within a Vue component, call `useGetAuthProviderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthProviderSettingsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAuthProviderSettingsQuery(
 *   {
 *      contextId: // value for 'contextId'
 *   }
 * );
 */
export function useGetAuthProviderSettingsQuery(variables: Operations.GetAuthProviderSettingsQueryVariables | VueCompositionApi.Ref<Operations.GetAuthProviderSettingsQueryVariables> | ReactiveFunction<Operations.GetAuthProviderSettingsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAuthProviderSettingsQuery, Operations.GetAuthProviderSettingsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAuthProviderSettingsQuery, Operations.GetAuthProviderSettingsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAuthProviderSettingsQuery, Operations.GetAuthProviderSettingsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAuthProviderSettingsQuery, Operations.GetAuthProviderSettingsQueryVariables>(Operations.GetAuthProviderSettingsDocument, variables, options);
          }
export type GetAuthProviderSettingsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAuthProviderSettingsQuery, Operations.GetAuthProviderSettingsQueryVariables>;

/**
 * __useGetContextQuery__
 *
 * To run a query within a Vue component, call `useGetContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetContextQuery(
 *   {
 *      contextId: // value for 'contextId'
 *   }
 * );
 */
export function useGetContextQuery(variables: Operations.GetContextQueryVariables | VueCompositionApi.Ref<Operations.GetContextQueryVariables> | ReactiveFunction<Operations.GetContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetContextQuery, Operations.GetContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetContextQuery, Operations.GetContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetContextQuery, Operations.GetContextQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetContextQuery, Operations.GetContextQueryVariables>(Operations.GetContextDocument, variables, options);
          }
export type GetContextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetContextQuery, Operations.GetContextQueryVariables>;

/**
 * __useGetUsersForContextQuery__
 *
 * To run a query within a Vue component, call `useGetUsersForContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersForContextQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUsersForContextQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useGetUsersForContextQuery(variables?: Operations.GetUsersForContextQueryVariables | VueCompositionApi.Ref<Operations.GetUsersForContextQueryVariables> | ReactiveFunction<Operations.GetUsersForContextQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetUsersForContextQuery, Operations.GetUsersForContextQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetUsersForContextQuery, Operations.GetUsersForContextQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetUsersForContextQuery, Operations.GetUsersForContextQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetUsersForContextQuery, Operations.GetUsersForContextQueryVariables>(Operations.GetUsersForContextDocument, variables, options);
          }
export type GetUsersForContextQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetUsersForContextQuery, Operations.GetUsersForContextQueryVariables>;

/**
 * __useSetContextToDisabledMutation__
 *
 * To run a mutation, you first call `useSetContextToDisabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetContextToDisabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetContextToDisabledMutation({
 *   variables: {
 *      contextId: // value for 'contextId'
 *   },
 * });
 */
export function useSetContextToDisabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetContextToDisabledMutation, Operations.SetContextToDisabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetContextToDisabledMutation, Operations.SetContextToDisabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetContextToDisabledMutation, Operations.SetContextToDisabledMutationVariables>(Operations.SetContextToDisabledDocument, options);
          }
export type SetContextToDisabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetContextToDisabledMutation, Operations.SetContextToDisabledMutationVariables>;

/**
 * __useAddLinkMutation__
 *
 * To run a mutation, you first call `useAddLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddLinkMutation({
 *   variables: {
 *      link: // value for 'link'
 *   },
 * });
 */
export function useAddLinkMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddLinkMutation, Operations.AddLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddLinkMutation, Operations.AddLinkMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddLinkMutation, Operations.AddLinkMutationVariables>(Operations.AddLinkDocument, options);
          }
export type AddLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddLinkMutation, Operations.AddLinkMutationVariables>;

/**
 * __useDeleteLinkMutation__
 *
 * To run a mutation, you first call `useDeleteLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteLinkMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useDeleteLinkMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteLinkMutation, Operations.DeleteLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteLinkMutation, Operations.DeleteLinkMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteLinkMutation, Operations.DeleteLinkMutationVariables>(Operations.DeleteLinkDocument, options);
          }
export type DeleteLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteLinkMutation, Operations.DeleteLinkMutationVariables>;

/**
 * __useGetLinkQuery__
 *
 * To run a query within a Vue component, call `useGetLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLinkQuery(
 *   {
 *      linkId: // value for 'linkId'
 *   }
 * );
 */
export function useGetLinkQuery(variables: Operations.GetLinkQueryVariables | VueCompositionApi.Ref<Operations.GetLinkQueryVariables> | ReactiveFunction<Operations.GetLinkQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetLinkQuery, Operations.GetLinkQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetLinkQuery, Operations.GetLinkQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetLinkQuery, Operations.GetLinkQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetLinkQuery, Operations.GetLinkQueryVariables>(Operations.GetLinkDocument, variables, options);
          }
export type GetLinkQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetLinkQuery, Operations.GetLinkQueryVariables>;

/**
 * __useGetAllLinksQuery__
 *
 * To run a query within a Vue component, call `useGetAllLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllLinksQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllLinksQuery(variables: Operations.GetAllLinksQueryVariables | VueCompositionApi.Ref<Operations.GetAllLinksQueryVariables> | ReactiveFunction<Operations.GetAllLinksQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllLinksQuery, Operations.GetAllLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllLinksQuery, Operations.GetAllLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllLinksQuery, Operations.GetAllLinksQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllLinksQuery, Operations.GetAllLinksQueryVariables>(Operations.GetAllLinksDocument, variables, options);
          }
export type GetAllLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllLinksQuery, Operations.GetAllLinksQueryVariables>;

/**
 * __useUpdateLinkMutation__
 *
 * To run a mutation, you first call `useUpdateLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLinkMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useUpdateLinkMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateLinkMutation, Operations.UpdateLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateLinkMutation, Operations.UpdateLinkMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateLinkMutation, Operations.UpdateLinkMutationVariables>(Operations.UpdateLinkDocument, options);
          }
export type UpdateLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateLinkMutation, Operations.UpdateLinkMutationVariables>;

/**
 * __useGetAllLocationsFlatQuery__
 *
 * To run a query within a Vue component, call `useGetAllLocationsFlatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationsFlatQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllLocationsFlatQuery(
 *   {
 *   }
 * );
 */
export function useGetAllLocationsFlatQuery(options: VueApolloComposable.UseQueryOptions<Operations.GetAllLocationsFlatQuery, Operations.GetAllLocationsFlatQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllLocationsFlatQuery, Operations.GetAllLocationsFlatQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllLocationsFlatQuery, Operations.GetAllLocationsFlatQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllLocationsFlatQuery, undefined>(Operations.GetAllLocationsFlatDocument, undefined, options);
          }
export type GetAllLocationsFlatQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllLocationsFlatQuery, Operations.GetAllLocationsFlatQueryVariables>;

/**
 * __useGetLocationHierarchyQuery__
 *
 * To run a query within a Vue component, call `useGetLocationHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationHierarchyQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLocationHierarchyQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useGetLocationHierarchyQuery(variables: Operations.GetLocationHierarchyQueryVariables | VueCompositionApi.Ref<Operations.GetLocationHierarchyQueryVariables> | ReactiveFunction<Operations.GetLocationHierarchyQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetLocationHierarchyQuery, Operations.GetLocationHierarchyQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetLocationHierarchyQuery, Operations.GetLocationHierarchyQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetLocationHierarchyQuery, Operations.GetLocationHierarchyQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetLocationHierarchyQuery, Operations.GetLocationHierarchyQueryVariables>(Operations.GetLocationHierarchyDocument, variables, options);
          }
export type GetLocationHierarchyQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetLocationHierarchyQuery, Operations.GetLocationHierarchyQueryVariables>;

/**
 * __useAddLocationMutation__
 *
 * To run a mutation, you first call `useAddLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddLocationMutation({
 *   variables: {
 *      newDefault: // value for 'newDefault'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useAddLocationMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddLocationMutation, Operations.AddLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddLocationMutation, Operations.AddLocationMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddLocationMutation, Operations.AddLocationMutationVariables>(Operations.AddLocationDocument, options);
          }
export type AddLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddLocationMutation, Operations.AddLocationMutationVariables>;

/**
 * __useGetLocationQuery__
 *
 * To run a query within a Vue component, call `useGetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLocationQuery(
 *   {
 *      locationId: // value for 'locationId'
 *   }
 * );
 */
export function useGetLocationQuery(variables: Operations.GetLocationQueryVariables | VueCompositionApi.Ref<Operations.GetLocationQueryVariables> | ReactiveFunction<Operations.GetLocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetLocationQuery, Operations.GetLocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetLocationQuery, Operations.GetLocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetLocationQuery, Operations.GetLocationQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetLocationQuery, Operations.GetLocationQueryVariables>(Operations.GetLocationDocument, variables, options);
          }
export type GetLocationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetLocationQuery, Operations.GetLocationQueryVariables>;

/**
 * __useGetCalendarLocationLinksQuery__
 *
 * To run a query within a Vue component, call `useGetCalendarLocationLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarLocationLinksQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCalendarLocationLinksQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetCalendarLocationLinksQuery(variables: Operations.GetCalendarLocationLinksQueryVariables | VueCompositionApi.Ref<Operations.GetCalendarLocationLinksQueryVariables> | ReactiveFunction<Operations.GetCalendarLocationLinksQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetCalendarLocationLinksQuery, Operations.GetCalendarLocationLinksQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetCalendarLocationLinksQuery, Operations.GetCalendarLocationLinksQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetCalendarLocationLinksQuery, Operations.GetCalendarLocationLinksQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetCalendarLocationLinksQuery, Operations.GetCalendarLocationLinksQueryVariables>(Operations.GetCalendarLocationLinksDocument, variables, options);
          }
export type GetCalendarLocationLinksQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetCalendarLocationLinksQuery, Operations.GetCalendarLocationLinksQueryVariables>;

/**
 * __useFetchCurrentDefaultLocationQuery__
 *
 * To run a query within a Vue component, call `useFetchCurrentDefaultLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentDefaultLocationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchCurrentDefaultLocationQuery(
 *   {
 *   }
 * );
 */
export function useFetchCurrentDefaultLocationQuery(options: VueApolloComposable.UseQueryOptions<Operations.FetchCurrentDefaultLocationQuery, Operations.FetchCurrentDefaultLocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.FetchCurrentDefaultLocationQuery, Operations.FetchCurrentDefaultLocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.FetchCurrentDefaultLocationQuery, Operations.FetchCurrentDefaultLocationQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.FetchCurrentDefaultLocationQuery, undefined>(Operations.FetchCurrentDefaultLocationDocument, undefined, options);
          }
export type FetchCurrentDefaultLocationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.FetchCurrentDefaultLocationQuery, Operations.FetchCurrentDefaultLocationQueryVariables>;

/**
 * __useSetLocationEnabledMutation__
 *
 * To run a mutation, you first call `useSetLocationEnabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetLocationEnabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetLocationEnabledMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useSetLocationEnabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetLocationEnabledMutation, Operations.SetLocationEnabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetLocationEnabledMutation, Operations.SetLocationEnabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetLocationEnabledMutation, Operations.SetLocationEnabledMutationVariables>(Operations.SetLocationEnabledDocument, options);
          }
export type SetLocationEnabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetLocationEnabledMutation, Operations.SetLocationEnabledMutationVariables>;

/**
 * __useUpdateCalendarLocationMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCalendarLocationMutation({
 *   variables: {
 *      calendarLocationId: // value for 'calendarLocationId'
 *      calendarLocation: // value for 'calendarLocation'
 *   },
 * });
 */
export function useUpdateCalendarLocationMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateCalendarLocationMutation, Operations.UpdateCalendarLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateCalendarLocationMutation, Operations.UpdateCalendarLocationMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateCalendarLocationMutation, Operations.UpdateCalendarLocationMutationVariables>(Operations.UpdateCalendarLocationDocument, options);
          }
export type UpdateCalendarLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateCalendarLocationMutation, Operations.UpdateCalendarLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLocationMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      newDefault: // value for 'newDefault'
 *      attributesToUnlink: // value for 'attributesToUnlink'
 *      location: // value for 'location'
 *      calendarIdsThatAreBeingUpdated: // value for 'calendarIdsThatAreBeingUpdated'
 *      calendarsToLink: // value for 'calendarsToLink'
 *      attributesToLink: // value for 'attributesToLink'
 *      updatedCalendarLocations: // value for 'updatedCalendarLocations'
 *   },
 * });
 */
export function useUpdateLocationMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateLocationMutation, Operations.UpdateLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateLocationMutation, Operations.UpdateLocationMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateLocationMutation, Operations.UpdateLocationMutationVariables>(Operations.UpdateLocationDocument, options);
          }
export type UpdateLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateLocationMutation, Operations.UpdateLocationMutationVariables>;

/**
 * __useGetAllLocationsQuery__
 *
 * To run a query within a Vue component, call `useGetAllLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllLocationsQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllLocationsQuery(variables: Operations.GetAllLocationsQueryVariables | VueCompositionApi.Ref<Operations.GetAllLocationsQueryVariables> | ReactiveFunction<Operations.GetAllLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllLocationsQuery, Operations.GetAllLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllLocationsQuery, Operations.GetAllLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllLocationsQuery, Operations.GetAllLocationsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllLocationsQuery, Operations.GetAllLocationsQueryVariables>(Operations.GetAllLocationsDocument, variables, options);
          }
export type GetAllLocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllLocationsQuery, Operations.GetAllLocationsQueryVariables>;

/**
 * __useUpdateLocationAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateLocationAttributesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationAttributesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLocationAttributesMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      locationAttrInput: // value for 'locationAttrInput'
 *      attributeIdList: // value for 'attributeIdList'
 *   },
 * });
 */
export function useUpdateLocationAttributesMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateLocationAttributesMutation, Operations.UpdateLocationAttributesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateLocationAttributesMutation, Operations.UpdateLocationAttributesMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateLocationAttributesMutation, Operations.UpdateLocationAttributesMutationVariables>(Operations.UpdateLocationAttributesDocument, options);
          }
export type UpdateLocationAttributesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateLocationAttributesMutation, Operations.UpdateLocationAttributesMutationVariables>;

/**
 * __useAddMaterialClassMutation__
 *
 * To run a mutation, you first call `useAddMaterialClassMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMaterialClassMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMaterialClassMutation({
 *   variables: {
 *      materialClass: // value for 'materialClass'
 *   },
 * });
 */
export function useAddMaterialClassMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddMaterialClassMutation, Operations.AddMaterialClassMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddMaterialClassMutation, Operations.AddMaterialClassMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddMaterialClassMutation, Operations.AddMaterialClassMutationVariables>(Operations.AddMaterialClassDocument, options);
          }
export type AddMaterialClassMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddMaterialClassMutation, Operations.AddMaterialClassMutationVariables>;

/**
 * __useDeleteMaterialModelMutation__
 *
 * To run a mutation, you first call `useDeleteMaterialModelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaterialModelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMaterialModelMutation({
 *   variables: {
 *      materialModelId: // value for 'materialModelId'
 *   },
 * });
 */
export function useDeleteMaterialModelMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteMaterialModelMutation, Operations.DeleteMaterialModelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteMaterialModelMutation, Operations.DeleteMaterialModelMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteMaterialModelMutation, Operations.DeleteMaterialModelMutationVariables>(Operations.DeleteMaterialModelDocument, options);
          }
export type DeleteMaterialModelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteMaterialModelMutation, Operations.DeleteMaterialModelMutationVariables>;

/**
 * __useDeleteMaterialModelSupportingConfigMutation__
 *
 * To run a mutation, you first call `useDeleteMaterialModelSupportingConfigMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaterialModelSupportingConfigMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteMaterialModelSupportingConfigMutation({
 *   variables: {
 *      materialModelId: // value for 'materialModelId'
 *   },
 * });
 */
export function useDeleteMaterialModelSupportingConfigMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteMaterialModelSupportingConfigMutation, Operations.DeleteMaterialModelSupportingConfigMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteMaterialModelSupportingConfigMutation, Operations.DeleteMaterialModelSupportingConfigMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteMaterialModelSupportingConfigMutation, Operations.DeleteMaterialModelSupportingConfigMutationVariables>(Operations.DeleteMaterialModelSupportingConfigDocument, options);
          }
export type DeleteMaterialModelSupportingConfigMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteMaterialModelSupportingConfigMutation, Operations.DeleteMaterialModelSupportingConfigMutationVariables>;

/**
 * __useDeleteSerialNumberFormatMutation__
 *
 * To run a mutation, you first call `useDeleteSerialNumberFormatMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSerialNumberFormatMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteSerialNumberFormatMutation({
 *   variables: {
 *      serialNumberFormatId: // value for 'serialNumberFormatId'
 *      contextId: // value for 'contextId'
 *   },
 * });
 */
export function useDeleteSerialNumberFormatMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteSerialNumberFormatMutation, Operations.DeleteSerialNumberFormatMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteSerialNumberFormatMutation, Operations.DeleteSerialNumberFormatMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteSerialNumberFormatMutation, Operations.DeleteSerialNumberFormatMutationVariables>(Operations.DeleteSerialNumberFormatDocument, options);
          }
export type DeleteSerialNumberFormatMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteSerialNumberFormatMutation, Operations.DeleteSerialNumberFormatMutationVariables>;

/**
 * __useDeleteUdfColumnsMutation__
 *
 * To run a mutation, you first call `useDeleteUdfColumnsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUdfColumnsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUdfColumnsMutation({
 *   variables: {
 *      udfColumnIds: // value for 'udfColumnIds'
 *   },
 * });
 */
export function useDeleteUdfColumnsMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteUdfColumnsMutation, Operations.DeleteUdfColumnsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteUdfColumnsMutation, Operations.DeleteUdfColumnsMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteUdfColumnsMutation, Operations.DeleteUdfColumnsMutationVariables>(Operations.DeleteUdfColumnsDocument, options);
          }
export type DeleteUdfColumnsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteUdfColumnsMutation, Operations.DeleteUdfColumnsMutationVariables>;

/**
 * __useGenerateSerialNumberAlignContentMutation__
 *
 * To run a mutation, you first call `useGenerateSerialNumberAlignContentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSerialNumberAlignContentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateSerialNumberAlignContentMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGenerateSerialNumberAlignContentMutation(options: VueApolloComposable.UseMutationOptions<Operations.GenerateSerialNumberAlignContentMutation, Operations.GenerateSerialNumberAlignContentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.GenerateSerialNumberAlignContentMutation, Operations.GenerateSerialNumberAlignContentMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.GenerateSerialNumberAlignContentMutation, Operations.GenerateSerialNumberAlignContentMutationVariables>(Operations.GenerateSerialNumberAlignContentDocument, options);
          }
export type GenerateSerialNumberAlignContentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.GenerateSerialNumberAlignContentMutation, Operations.GenerateSerialNumberAlignContentMutationVariables>;

/**
 * __useGenerateSerialNumberDatetimeTokenMutation__
 *
 * To run a mutation, you first call `useGenerateSerialNumberDatetimeTokenMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSerialNumberDatetimeTokenMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateSerialNumberDatetimeTokenMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGenerateSerialNumberDatetimeTokenMutation(options: VueApolloComposable.UseMutationOptions<Operations.GenerateSerialNumberDatetimeTokenMutation, Operations.GenerateSerialNumberDatetimeTokenMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.GenerateSerialNumberDatetimeTokenMutation, Operations.GenerateSerialNumberDatetimeTokenMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.GenerateSerialNumberDatetimeTokenMutation, Operations.GenerateSerialNumberDatetimeTokenMutationVariables>(Operations.GenerateSerialNumberDatetimeTokenDocument, options);
          }
export type GenerateSerialNumberDatetimeTokenMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.GenerateSerialNumberDatetimeTokenMutation, Operations.GenerateSerialNumberDatetimeTokenMutationVariables>;

/**
 * __useGenerateSerialNumberSequenceMutation__
 *
 * To run a mutation, you first call `useGenerateSerialNumberSequenceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSerialNumberSequenceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateSerialNumberSequenceMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGenerateSerialNumberSequenceMutation(options: VueApolloComposable.UseMutationOptions<Operations.GenerateSerialNumberSequenceMutation, Operations.GenerateSerialNumberSequenceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.GenerateSerialNumberSequenceMutation, Operations.GenerateSerialNumberSequenceMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.GenerateSerialNumberSequenceMutation, Operations.GenerateSerialNumberSequenceMutationVariables>(Operations.GenerateSerialNumberSequenceDocument, options);
          }
export type GenerateSerialNumberSequenceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.GenerateSerialNumberSequenceMutation, Operations.GenerateSerialNumberSequenceMutationVariables>;

/**
 * __useGetAllModelsAndAllModelUdfsUsingClassIdQuery__
 *
 * To run a query within a Vue component, call `useGetAllModelsAndAllModelUdfsUsingClassIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllModelsAndAllModelUdfsUsingClassIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllModelsAndAllModelUdfsUsingClassIdQuery(
 *   {
 *      materialClassId: // value for 'materialClassId'
 *   }
 * );
 */
export function useGetAllModelsAndAllModelUdfsUsingClassIdQuery(variables: Operations.GetAllModelsAndAllModelUdfsUsingClassIdQueryVariables | VueCompositionApi.Ref<Operations.GetAllModelsAndAllModelUdfsUsingClassIdQueryVariables> | ReactiveFunction<Operations.GetAllModelsAndAllModelUdfsUsingClassIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllModelsAndAllModelUdfsUsingClassIdQuery, Operations.GetAllModelsAndAllModelUdfsUsingClassIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllModelsAndAllModelUdfsUsingClassIdQuery, Operations.GetAllModelsAndAllModelUdfsUsingClassIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllModelsAndAllModelUdfsUsingClassIdQuery, Operations.GetAllModelsAndAllModelUdfsUsingClassIdQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllModelsAndAllModelUdfsUsingClassIdQuery, Operations.GetAllModelsAndAllModelUdfsUsingClassIdQueryVariables>(Operations.GetAllModelsAndAllModelUdfsUsingClassIdDocument, variables, options);
          }
export type GetAllModelsAndAllModelUdfsUsingClassIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllModelsAndAllModelUdfsUsingClassIdQuery, Operations.GetAllModelsAndAllModelUdfsUsingClassIdQueryVariables>;

/**
 * __useGetAllProcessesQuery__
 *
 * To run a query within a Vue component, call `useGetAllProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProcessesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllProcessesQuery(
 *   {
 *      processFilter: // value for 'processFilter'
 *      limit: // value for 'limit'
 *   }
 * );
 */
export function useGetAllProcessesQuery(variables: Operations.GetAllProcessesQueryVariables | VueCompositionApi.Ref<Operations.GetAllProcessesQueryVariables> | ReactiveFunction<Operations.GetAllProcessesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllProcessesQuery, Operations.GetAllProcessesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllProcessesQuery, Operations.GetAllProcessesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllProcessesQuery, Operations.GetAllProcessesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllProcessesQuery, Operations.GetAllProcessesQueryVariables>(Operations.GetAllProcessesDocument, variables, options);
          }
export type GetAllProcessesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllProcessesQuery, Operations.GetAllProcessesQueryVariables>;

/**
 * __useGetAllSerialNumberFormatsForMaterialClassQuery__
 *
 * To run a query within a Vue component, call `useGetAllSerialNumberFormatsForMaterialClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSerialNumberFormatsForMaterialClassQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllSerialNumberFormatsForMaterialClassQuery(
 *   {
 *      materialClassId: // value for 'materialClassId'
 *   }
 * );
 */
export function useGetAllSerialNumberFormatsForMaterialClassQuery(variables: Operations.GetAllSerialNumberFormatsForMaterialClassQueryVariables | VueCompositionApi.Ref<Operations.GetAllSerialNumberFormatsForMaterialClassQueryVariables> | ReactiveFunction<Operations.GetAllSerialNumberFormatsForMaterialClassQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllSerialNumberFormatsForMaterialClassQuery, Operations.GetAllSerialNumberFormatsForMaterialClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllSerialNumberFormatsForMaterialClassQuery, Operations.GetAllSerialNumberFormatsForMaterialClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllSerialNumberFormatsForMaterialClassQuery, Operations.GetAllSerialNumberFormatsForMaterialClassQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllSerialNumberFormatsForMaterialClassQuery, Operations.GetAllSerialNumberFormatsForMaterialClassQueryVariables>(Operations.GetAllSerialNumberFormatsForMaterialClassDocument, variables, options);
          }
export type GetAllSerialNumberFormatsForMaterialClassQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllSerialNumberFormatsForMaterialClassQuery, Operations.GetAllSerialNumberFormatsForMaterialClassQueryVariables>;

/**
 * __useGetMaterialClassQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialClassQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialClassQuery(
 *   {
 *      materialClassId: // value for 'materialClassId'
 *   }
 * );
 */
export function useGetMaterialClassQuery(variables: Operations.GetMaterialClassQueryVariables | VueCompositionApi.Ref<Operations.GetMaterialClassQueryVariables> | ReactiveFunction<Operations.GetMaterialClassQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetMaterialClassQuery, Operations.GetMaterialClassQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetMaterialClassQuery, Operations.GetMaterialClassQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetMaterialClassQuery, Operations.GetMaterialClassQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetMaterialClassQuery, Operations.GetMaterialClassQueryVariables>(Operations.GetMaterialClassDocument, variables, options);
          }
export type GetMaterialClassQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetMaterialClassQuery, Operations.GetMaterialClassQueryVariables>;

/**
 * __useGetAllMaterialClassAttributesQuery__
 *
 * To run a query within a Vue component, call `useGetAllMaterialClassAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMaterialClassAttributesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllMaterialClassAttributesQuery(
 *   {
 *   }
 * );
 */
export function useGetAllMaterialClassAttributesQuery(options: VueApolloComposable.UseQueryOptions<Operations.GetAllMaterialClassAttributesQuery, Operations.GetAllMaterialClassAttributesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllMaterialClassAttributesQuery, Operations.GetAllMaterialClassAttributesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllMaterialClassAttributesQuery, Operations.GetAllMaterialClassAttributesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllMaterialClassAttributesQuery, undefined>(Operations.GetAllMaterialClassAttributesDocument, undefined, options);
          }
export type GetAllMaterialClassAttributesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllMaterialClassAttributesQuery, Operations.GetAllMaterialClassAttributesQueryVariables>;

/**
 * __useGetAllMaterialClassesQuery__
 *
 * To run a query within a Vue component, call `useGetAllMaterialClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMaterialClassesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllMaterialClassesQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllMaterialClassesQuery(variables: Operations.GetAllMaterialClassesQueryVariables | VueCompositionApi.Ref<Operations.GetAllMaterialClassesQueryVariables> | ReactiveFunction<Operations.GetAllMaterialClassesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllMaterialClassesQuery, Operations.GetAllMaterialClassesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllMaterialClassesQuery, Operations.GetAllMaterialClassesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllMaterialClassesQuery, Operations.GetAllMaterialClassesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllMaterialClassesQuery, Operations.GetAllMaterialClassesQueryVariables>(Operations.GetAllMaterialClassesDocument, variables, options);
          }
export type GetAllMaterialClassesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllMaterialClassesQuery, Operations.GetAllMaterialClassesQueryVariables>;

/**
 * __useInsertMaterialModelMutation__
 *
 * To run a mutation, you first call `useInsertMaterialModelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertMaterialModelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertMaterialModelMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useInsertMaterialModelMutation(options: VueApolloComposable.UseMutationOptions<Operations.InsertMaterialModelMutation, Operations.InsertMaterialModelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.InsertMaterialModelMutation, Operations.InsertMaterialModelMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.InsertMaterialModelMutation, Operations.InsertMaterialModelMutationVariables>(Operations.InsertMaterialModelDocument, options);
          }
export type InsertMaterialModelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.InsertMaterialModelMutation, Operations.InsertMaterialModelMutationVariables>;

/**
 * __useInsertNewSerialNumberFormatMutation__
 *
 * To run a mutation, you first call `useInsertNewSerialNumberFormatMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewSerialNumberFormatMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertNewSerialNumberFormatMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useInsertNewSerialNumberFormatMutation(options: VueApolloComposable.UseMutationOptions<Operations.InsertNewSerialNumberFormatMutation, Operations.InsertNewSerialNumberFormatMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.InsertNewSerialNumberFormatMutation, Operations.InsertNewSerialNumberFormatMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.InsertNewSerialNumberFormatMutation, Operations.InsertNewSerialNumberFormatMutationVariables>(Operations.InsertNewSerialNumberFormatDocument, options);
          }
export type InsertNewSerialNumberFormatMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.InsertNewSerialNumberFormatMutation, Operations.InsertNewSerialNumberFormatMutationVariables>;

/**
 * __useSetMaterialClassToDisabledMutation__
 *
 * To run a mutation, you first call `useSetMaterialClassToDisabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetMaterialClassToDisabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetMaterialClassToDisabledMutation({
 *   variables: {
 *      materialClassId: // value for 'materialClassId'
 *   },
 * });
 */
export function useSetMaterialClassToDisabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetMaterialClassToDisabledMutation, Operations.SetMaterialClassToDisabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetMaterialClassToDisabledMutation, Operations.SetMaterialClassToDisabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetMaterialClassToDisabledMutation, Operations.SetMaterialClassToDisabledMutationVariables>(Operations.SetMaterialClassToDisabledDocument, options);
          }
export type SetMaterialClassToDisabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetMaterialClassToDisabledMutation, Operations.SetMaterialClassToDisabledMutationVariables>;

/**
 * __useUpdateMaterialClassMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialClassMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialClassMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMaterialClassMutation({
 *   variables: {
 *      materialClassId: // value for 'materialClassId'
 *      deleteUdfSchemas: // value for 'deleteUdfSchemas'
 *      materialClass: // value for 'materialClass'
 *      udfSchema: // value for 'udfSchema'
 *      materialClassProcesses: // value for 'materialClassProcesses'
 *      deleteMatClassProcessInputs: // value for 'deleteMatClassProcessInputs'
 *      addMaterialClassAttributeSettings: // value for 'addMaterialClassAttributeSettings'
 *      updateMaterialClassAttributeSettings: // value for 'updateMaterialClassAttributeSettings'
 *      deleteMaterialClassAttributeSettings: // value for 'deleteMaterialClassAttributeSettings'
 *   },
 * });
 */
export function useUpdateMaterialClassMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialClassMutation, Operations.UpdateMaterialClassMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialClassMutation, Operations.UpdateMaterialClassMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateMaterialClassMutation, Operations.UpdateMaterialClassMutationVariables>(Operations.UpdateMaterialClassDocument, options);
          }
export type UpdateMaterialClassMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateMaterialClassMutation, Operations.UpdateMaterialClassMutationVariables>;

/**
 * __useUpdateMaterialClassAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialClassAttributesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialClassAttributesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMaterialClassAttributesMutation({
 *   variables: {
 *      materialClassId: // value for 'materialClassId'
 *      materialClassAttrInput: // value for 'materialClassAttrInput'
 *      attributeIdList: // value for 'attributeIdList'
 *   },
 * });
 */
export function useUpdateMaterialClassAttributesMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialClassAttributesMutation, Operations.UpdateMaterialClassAttributesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialClassAttributesMutation, Operations.UpdateMaterialClassAttributesMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateMaterialClassAttributesMutation, Operations.UpdateMaterialClassAttributesMutationVariables>(Operations.UpdateMaterialClassAttributesDocument, options);
          }
export type UpdateMaterialClassAttributesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateMaterialClassAttributesMutation, Operations.UpdateMaterialClassAttributesMutationVariables>;

/**
 * __useUpdateMaterialModelMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialModelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialModelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMaterialModelMutation({
 *   variables: {
 *      materialModelId: // value for 'materialModelId'
 *      materialModelProcessDeletes: // value for 'materialModelProcessDeletes'
 *      materialModelDefaultUdfDataDeletes: // value for 'materialModelDefaultUdfDataDeletes'
 *      newMaterialModel: // value for 'newMaterialModel'
 *      materialModelProcessUpdates: // value for 'materialModelProcessUpdates'
 *      materialModelProcessInserts: // value for 'materialModelProcessInserts'
 *      materialModelDefaultUdfDataUpdates: // value for 'materialModelDefaultUdfDataUpdates'
 *      materialModelDefaultUdfDataInserts: // value for 'materialModelDefaultUdfDataInserts'
 *   },
 * });
 */
export function useUpdateMaterialModelMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialModelMutation, Operations.UpdateMaterialModelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialModelMutation, Operations.UpdateMaterialModelMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateMaterialModelMutation, Operations.UpdateMaterialModelMutationVariables>(Operations.UpdateMaterialModelDocument, options);
          }
export type UpdateMaterialModelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateMaterialModelMutation, Operations.UpdateMaterialModelMutationVariables>;

/**
 * __useUpdateSerialNumberFormatMutation__
 *
 * To run a mutation, you first call `useUpdateSerialNumberFormatMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSerialNumberFormatMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSerialNumberFormatMutation({
 *   variables: {
 *      serialNumberFormatId: // value for 'serialNumberFormatId'
 *      contextId: // value for 'contextId'
 *      serialNumberFormat: // value for 'serialNumberFormat'
 *   },
 * });
 */
export function useUpdateSerialNumberFormatMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateSerialNumberFormatMutation, Operations.UpdateSerialNumberFormatMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateSerialNumberFormatMutation, Operations.UpdateSerialNumberFormatMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateSerialNumberFormatMutation, Operations.UpdateSerialNumberFormatMutationVariables>(Operations.UpdateSerialNumberFormatDocument, options);
          }
export type UpdateSerialNumberFormatMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateSerialNumberFormatMutation, Operations.UpdateSerialNumberFormatMutationVariables>;

/**
 * __useUpdateSerialNumberFormatStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSerialNumberFormatStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSerialNumberFormatStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateSerialNumberFormatStatusMutation({
 *   variables: {
 *      serialNumberFormatId: // value for 'serialNumberFormatId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateSerialNumberFormatStatusMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateSerialNumberFormatStatusMutation, Operations.UpdateSerialNumberFormatStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateSerialNumberFormatStatusMutation, Operations.UpdateSerialNumberFormatStatusMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateSerialNumberFormatStatusMutation, Operations.UpdateSerialNumberFormatStatusMutationVariables>(Operations.UpdateSerialNumberFormatStatusDocument, options);
          }
export type UpdateSerialNumberFormatStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateSerialNumberFormatStatusMutation, Operations.UpdateSerialNumberFormatStatusMutationVariables>;

/**
 * __useAddNewMaterialMutation__
 *
 * To run a mutation, you first call `useAddNewMaterialMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddNewMaterialMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddNewMaterialMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAddNewMaterialMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddNewMaterialMutation, Operations.AddNewMaterialMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddNewMaterialMutation, Operations.AddNewMaterialMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddNewMaterialMutation, Operations.AddNewMaterialMutationVariables>(Operations.AddNewMaterialDocument, options);
          }
export type AddNewMaterialMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddNewMaterialMutation, Operations.AddNewMaterialMutationVariables>;

/**
 * __useCreateMaterialMutation__
 *
 * To run a mutation, you first call `useCreateMaterialMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateMaterialMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateMaterialMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCreateMaterialMutation(options: VueApolloComposable.UseMutationOptions<Operations.CreateMaterialMutation, Operations.CreateMaterialMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.CreateMaterialMutation, Operations.CreateMaterialMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.CreateMaterialMutation, Operations.CreateMaterialMutationVariables>(Operations.CreateMaterialDocument, options);
          }
export type CreateMaterialMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.CreateMaterialMutation, Operations.CreateMaterialMutationVariables>;

/**
 * __useFetchDefaultLocationQuery__
 *
 * To run a query within a Vue component, call `useFetchDefaultLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDefaultLocationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchDefaultLocationQuery(
 *   {
 *      contextId: // value for 'contextId'
 *   }
 * );
 */
export function useFetchDefaultLocationQuery(variables: Operations.FetchDefaultLocationQueryVariables | VueCompositionApi.Ref<Operations.FetchDefaultLocationQueryVariables> | ReactiveFunction<Operations.FetchDefaultLocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.FetchDefaultLocationQuery, Operations.FetchDefaultLocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.FetchDefaultLocationQuery, Operations.FetchDefaultLocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.FetchDefaultLocationQuery, Operations.FetchDefaultLocationQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.FetchDefaultLocationQuery, Operations.FetchDefaultLocationQueryVariables>(Operations.FetchDefaultLocationDocument, variables, options);
          }
export type FetchDefaultLocationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.FetchDefaultLocationQuery, Operations.FetchDefaultLocationQueryVariables>;

/**
 * __useGetAllAttributeSchemasQuery__
 *
 * To run a query within a Vue component, call `useGetAllAttributeSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAttributeSchemasQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAttributeSchemasQuery(
 *   {
 *      schemaTypes: // value for 'schemaTypes'
 *   }
 * );
 */
export function useGetAllAttributeSchemasQuery(variables: Operations.GetAllAttributeSchemasQueryVariables | VueCompositionApi.Ref<Operations.GetAllAttributeSchemasQueryVariables> | ReactiveFunction<Operations.GetAllAttributeSchemasQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllAttributeSchemasQuery, Operations.GetAllAttributeSchemasQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllAttributeSchemasQuery, Operations.GetAllAttributeSchemasQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllAttributeSchemasQuery, Operations.GetAllAttributeSchemasQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllAttributeSchemasQuery, Operations.GetAllAttributeSchemasQueryVariables>(Operations.GetAllAttributeSchemasDocument, variables, options);
          }
export type GetAllAttributeSchemasQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllAttributeSchemasQuery, Operations.GetAllAttributeSchemasQueryVariables>;

/**
 * __useGetAllAttributeSettingsForMaterialUsingMaterialModelIdQuery__
 *
 * To run a query within a Vue component, call `useGetAllAttributeSettingsForMaterialUsingMaterialModelIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAttributeSettingsForMaterialUsingMaterialModelIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAttributeSettingsForMaterialUsingMaterialModelIdQuery(
 *   {
 *      materialModelId: // value for 'materialModelId'
 *   }
 * );
 */
export function useGetAllAttributeSettingsForMaterialUsingMaterialModelIdQuery(variables: Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQueryVariables | VueCompositionApi.Ref<Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQueryVariables> | ReactiveFunction<Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQuery, Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQuery, Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQuery, Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQuery, Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQueryVariables>(Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdDocument, variables, options);
          }
export type GetAllAttributeSettingsForMaterialUsingMaterialModelIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQuery, Operations.GetAllAttributeSettingsForMaterialUsingMaterialModelIdQueryVariables>;

/**
 * __useGetAllLocationsForMaterialSearchQuery__
 *
 * To run a query within a Vue component, call `useGetAllLocationsForMaterialSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationsForMaterialSearchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllLocationsForMaterialSearchQuery(
 *   {
 *   }
 * );
 */
export function useGetAllLocationsForMaterialSearchQuery(options: VueApolloComposable.UseQueryOptions<Operations.GetAllLocationsForMaterialSearchQuery, Operations.GetAllLocationsForMaterialSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllLocationsForMaterialSearchQuery, Operations.GetAllLocationsForMaterialSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllLocationsForMaterialSearchQuery, Operations.GetAllLocationsForMaterialSearchQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllLocationsForMaterialSearchQuery, undefined>(Operations.GetAllLocationsForMaterialSearchDocument, undefined, options);
          }
export type GetAllLocationsForMaterialSearchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllLocationsForMaterialSearchQuery, Operations.GetAllLocationsForMaterialSearchQueryVariables>;

/**
 * __useGetAssemblyTreeItemsQuery__
 *
 * To run a query within a Vue component, call `useGetAssemblyTreeItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssemblyTreeItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAssemblyTreeItemsQuery(
 *   {
 *      material_id: // value for 'material_id'
 *      direction: // value for 'direction'
 *   }
 * );
 */
export function useGetAssemblyTreeItemsQuery(variables: Operations.GetAssemblyTreeItemsQueryVariables | VueCompositionApi.Ref<Operations.GetAssemblyTreeItemsQueryVariables> | ReactiveFunction<Operations.GetAssemblyTreeItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAssemblyTreeItemsQuery, Operations.GetAssemblyTreeItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAssemblyTreeItemsQuery, Operations.GetAssemblyTreeItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAssemblyTreeItemsQuery, Operations.GetAssemblyTreeItemsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAssemblyTreeItemsQuery, Operations.GetAssemblyTreeItemsQueryVariables>(Operations.GetAssemblyTreeItemsDocument, variables, options);
          }
export type GetAssemblyTreeItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAssemblyTreeItemsQuery, Operations.GetAssemblyTreeItemsQueryVariables>;

/**
 * __useGetClassUdfSchemasUsingMaterialModelIdQuery__
 *
 * To run a query within a Vue component, call `useGetClassUdfSchemasUsingMaterialModelIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassUdfSchemasUsingMaterialModelIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetClassUdfSchemasUsingMaterialModelIdQuery(
 *   {
 *      materialModelId: // value for 'materialModelId'
 *   }
 * );
 */
export function useGetClassUdfSchemasUsingMaterialModelIdQuery(variables: Operations.GetClassUdfSchemasUsingMaterialModelIdQueryVariables | VueCompositionApi.Ref<Operations.GetClassUdfSchemasUsingMaterialModelIdQueryVariables> | ReactiveFunction<Operations.GetClassUdfSchemasUsingMaterialModelIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetClassUdfSchemasUsingMaterialModelIdQuery, Operations.GetClassUdfSchemasUsingMaterialModelIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetClassUdfSchemasUsingMaterialModelIdQuery, Operations.GetClassUdfSchemasUsingMaterialModelIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetClassUdfSchemasUsingMaterialModelIdQuery, Operations.GetClassUdfSchemasUsingMaterialModelIdQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetClassUdfSchemasUsingMaterialModelIdQuery, Operations.GetClassUdfSchemasUsingMaterialModelIdQueryVariables>(Operations.GetClassUdfSchemasUsingMaterialModelIdDocument, variables, options);
          }
export type GetClassUdfSchemasUsingMaterialModelIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetClassUdfSchemasUsingMaterialModelIdQuery, Operations.GetClassUdfSchemasUsingMaterialModelIdQueryVariables>;

/**
 * __useGetContextDefaultModelQuery__
 *
 * To run a query within a Vue component, call `useGetContextDefaultModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContextDefaultModelQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetContextDefaultModelQuery(
 *   {
 *      contextId: // value for 'contextId'
 *   }
 * );
 */
export function useGetContextDefaultModelQuery(variables: Operations.GetContextDefaultModelQueryVariables | VueCompositionApi.Ref<Operations.GetContextDefaultModelQueryVariables> | ReactiveFunction<Operations.GetContextDefaultModelQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetContextDefaultModelQuery, Operations.GetContextDefaultModelQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetContextDefaultModelQuery, Operations.GetContextDefaultModelQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetContextDefaultModelQuery, Operations.GetContextDefaultModelQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetContextDefaultModelQuery, Operations.GetContextDefaultModelQueryVariables>(Operations.GetContextDefaultModelDocument, variables, options);
          }
export type GetContextDefaultModelQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetContextDefaultModelQuery, Operations.GetContextDefaultModelQueryVariables>;

/**
 * __useGetLocationDetailQuery__
 *
 * To run a query within a Vue component, call `useGetLocationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLocationDetailQuery(
 *   {
 *      locationId: // value for 'locationId'
 *   }
 * );
 */
export function useGetLocationDetailQuery(variables: Operations.GetLocationDetailQueryVariables | VueCompositionApi.Ref<Operations.GetLocationDetailQueryVariables> | ReactiveFunction<Operations.GetLocationDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetLocationDetailQuery, Operations.GetLocationDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetLocationDetailQuery, Operations.GetLocationDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetLocationDetailQuery, Operations.GetLocationDetailQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetLocationDetailQuery, Operations.GetLocationDetailQueryVariables>(Operations.GetLocationDetailDocument, variables, options);
          }
export type GetLocationDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetLocationDetailQuery, Operations.GetLocationDetailQueryVariables>;

/**
 * __useGetMaterialQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialQuery(
 *   {
 *      materialId: // value for 'materialId'
 *   }
 * );
 */
export function useGetMaterialQuery(variables: Operations.GetMaterialQueryVariables | VueCompositionApi.Ref<Operations.GetMaterialQueryVariables> | ReactiveFunction<Operations.GetMaterialQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetMaterialQuery, Operations.GetMaterialQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetMaterialQuery, Operations.GetMaterialQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetMaterialQuery, Operations.GetMaterialQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetMaterialQuery, Operations.GetMaterialQueryVariables>(Operations.GetMaterialDocument, variables, options);
          }
export type GetMaterialQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetMaterialQuery, Operations.GetMaterialQueryVariables>;

/**
 * __useGetMaterialComponentsQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialComponentsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialComponentsQuery(
 *   {
 *      material_ids: // value for 'material_ids'
 *   }
 * );
 */
export function useGetMaterialComponentsQuery(variables?: Operations.GetMaterialComponentsQueryVariables | VueCompositionApi.Ref<Operations.GetMaterialComponentsQueryVariables> | ReactiveFunction<Operations.GetMaterialComponentsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetMaterialComponentsQuery, Operations.GetMaterialComponentsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetMaterialComponentsQuery, Operations.GetMaterialComponentsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetMaterialComponentsQuery, Operations.GetMaterialComponentsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetMaterialComponentsQuery, Operations.GetMaterialComponentsQueryVariables>(Operations.GetMaterialComponentsDocument, variables, options);
          }
export type GetMaterialComponentsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetMaterialComponentsQuery, Operations.GetMaterialComponentsQueryVariables>;

/**
 * __useGetMaterialMarriagesQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialMarriagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialMarriagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialMarriagesQuery(
 *   {
 *      material_ids: // value for 'material_ids'
 *   }
 * );
 */
export function useGetMaterialMarriagesQuery(variables?: Operations.GetMaterialMarriagesQueryVariables | VueCompositionApi.Ref<Operations.GetMaterialMarriagesQueryVariables> | ReactiveFunction<Operations.GetMaterialMarriagesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetMaterialMarriagesQuery, Operations.GetMaterialMarriagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetMaterialMarriagesQuery, Operations.GetMaterialMarriagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetMaterialMarriagesQuery, Operations.GetMaterialMarriagesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetMaterialMarriagesQuery, Operations.GetMaterialMarriagesQueryVariables>(Operations.GetMaterialMarriagesDocument, variables, options);
          }
export type GetMaterialMarriagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetMaterialMarriagesQuery, Operations.GetMaterialMarriagesQueryVariables>;

/**
 * __useGetMaterialModelQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialModelQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialModelQuery(
 *   {
 *      materialModelId: // value for 'materialModelId'
 *   }
 * );
 */
export function useGetMaterialModelQuery(variables: Operations.GetMaterialModelQueryVariables | VueCompositionApi.Ref<Operations.GetMaterialModelQueryVariables> | ReactiveFunction<Operations.GetMaterialModelQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetMaterialModelQuery, Operations.GetMaterialModelQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetMaterialModelQuery, Operations.GetMaterialModelQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetMaterialModelQuery, Operations.GetMaterialModelQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetMaterialModelQuery, Operations.GetMaterialModelQueryVariables>(Operations.GetMaterialModelDocument, variables, options);
          }
export type GetMaterialModelQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetMaterialModelQuery, Operations.GetMaterialModelQueryVariables>;

/**
 * __useGetMaterialSerialNumberQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialSerialNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialSerialNumberQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialSerialNumberQuery(
 *   {
 *      materialId: // value for 'materialId'
 *   }
 * );
 */
export function useGetMaterialSerialNumberQuery(variables: Operations.GetMaterialSerialNumberQueryVariables | VueCompositionApi.Ref<Operations.GetMaterialSerialNumberQueryVariables> | ReactiveFunction<Operations.GetMaterialSerialNumberQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetMaterialSerialNumberQuery, Operations.GetMaterialSerialNumberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetMaterialSerialNumberQuery, Operations.GetMaterialSerialNumberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetMaterialSerialNumberQuery, Operations.GetMaterialSerialNumberQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetMaterialSerialNumberQuery, Operations.GetMaterialSerialNumberQueryVariables>(Operations.GetMaterialSerialNumberDocument, variables, options);
          }
export type GetMaterialSerialNumberQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetMaterialSerialNumberQuery, Operations.GetMaterialSerialNumberQueryVariables>;

/**
 * __useGetMaterialWorkInstructionHistoryQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialWorkInstructionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialWorkInstructionHistoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialWorkInstructionHistoryQuery(
 *   {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      materialId: // value for 'materialId'
 *      orderBy: // value for 'orderBy'
 *   }
 * );
 */
export function useGetMaterialWorkInstructionHistoryQuery(variables: Operations.GetMaterialWorkInstructionHistoryQueryVariables | VueCompositionApi.Ref<Operations.GetMaterialWorkInstructionHistoryQueryVariables> | ReactiveFunction<Operations.GetMaterialWorkInstructionHistoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetMaterialWorkInstructionHistoryQuery, Operations.GetMaterialWorkInstructionHistoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetMaterialWorkInstructionHistoryQuery, Operations.GetMaterialWorkInstructionHistoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetMaterialWorkInstructionHistoryQuery, Operations.GetMaterialWorkInstructionHistoryQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetMaterialWorkInstructionHistoryQuery, Operations.GetMaterialWorkInstructionHistoryQueryVariables>(Operations.GetMaterialWorkInstructionHistoryDocument, variables, options);
          }
export type GetMaterialWorkInstructionHistoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetMaterialWorkInstructionHistoryQuery, Operations.GetMaterialWorkInstructionHistoryQueryVariables>;

/**
 * __useGetAllMaterialQuery__
 *
 * To run a query within a Vue component, call `useGetAllMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMaterialQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllMaterialQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllMaterialQuery(variables: Operations.GetAllMaterialQueryVariables | VueCompositionApi.Ref<Operations.GetAllMaterialQueryVariables> | ReactiveFunction<Operations.GetAllMaterialQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllMaterialQuery, Operations.GetAllMaterialQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllMaterialQuery, Operations.GetAllMaterialQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllMaterialQuery, Operations.GetAllMaterialQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllMaterialQuery, Operations.GetAllMaterialQueryVariables>(Operations.GetAllMaterialDocument, variables, options);
          }
export type GetAllMaterialQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllMaterialQuery, Operations.GetAllMaterialQueryVariables>;

/**
 * __useGetSerialNumberFormatCfgUsingMaterialClassIdQuery__
 *
 * To run a query within a Vue component, call `useGetSerialNumberFormatCfgUsingMaterialClassIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSerialNumberFormatCfgUsingMaterialClassIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSerialNumberFormatCfgUsingMaterialClassIdQuery(
 *   {
 *      materialClassId: // value for 'materialClassId'
 *   }
 * );
 */
export function useGetSerialNumberFormatCfgUsingMaterialClassIdQuery(variables: Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQueryVariables | VueCompositionApi.Ref<Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQueryVariables> | ReactiveFunction<Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQuery, Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQuery, Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQuery, Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQuery, Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQueryVariables>(Operations.GetSerialNumberFormatCfgUsingMaterialClassIdDocument, variables, options);
          }
export type GetSerialNumberFormatCfgUsingMaterialClassIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQuery, Operations.GetSerialNumberFormatCfgUsingMaterialClassIdQueryVariables>;

/**
 * __useGetSnFormatQuery__
 *
 * To run a query within a Vue component, call `useGetSnFormatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnFormatQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetSnFormatQuery(
 *   {
 *      snFormatId: // value for 'snFormatId'
 *   }
 * );
 */
export function useGetSnFormatQuery(variables: Operations.GetSnFormatQueryVariables | VueCompositionApi.Ref<Operations.GetSnFormatQueryVariables> | ReactiveFunction<Operations.GetSnFormatQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetSnFormatQuery, Operations.GetSnFormatQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetSnFormatQuery, Operations.GetSnFormatQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetSnFormatQuery, Operations.GetSnFormatQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetSnFormatQuery, Operations.GetSnFormatQueryVariables>(Operations.GetSnFormatDocument, variables, options);
          }
export type GetSnFormatQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetSnFormatQuery, Operations.GetSnFormatQueryVariables>;

/**
 * __useInsertMaterialAttributeMutation__
 *
 * To run a mutation, you first call `useInsertMaterialAttributeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertMaterialAttributeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertMaterialAttributeMutation({
 *   variables: {
 *      materialAttributes: // value for 'materialAttributes'
 *   },
 * });
 */
export function useInsertMaterialAttributeMutation(options: VueApolloComposable.UseMutationOptions<Operations.InsertMaterialAttributeMutation, Operations.InsertMaterialAttributeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.InsertMaterialAttributeMutation, Operations.InsertMaterialAttributeMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.InsertMaterialAttributeMutation, Operations.InsertMaterialAttributeMutationVariables>(Operations.InsertMaterialAttributeDocument, options);
          }
export type InsertMaterialAttributeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.InsertMaterialAttributeMutation, Operations.InsertMaterialAttributeMutationVariables>;

/**
 * __useMaterialSearchQuery__
 *
 * To run a query within a Vue component, call `useMaterialSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialSearchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMaterialSearchQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useMaterialSearchQuery(variables: Operations.MaterialSearchQueryVariables | VueCompositionApi.Ref<Operations.MaterialSearchQueryVariables> | ReactiveFunction<Operations.MaterialSearchQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.MaterialSearchQuery, Operations.MaterialSearchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.MaterialSearchQuery, Operations.MaterialSearchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.MaterialSearchQuery, Operations.MaterialSearchQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.MaterialSearchQuery, Operations.MaterialSearchQueryVariables>(Operations.MaterialSearchDocument, variables, options);
          }
export type MaterialSearchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.MaterialSearchQuery, Operations.MaterialSearchQueryVariables>;

/**
 * __useGetMaterialUdfColumnsQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialUdfColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialUdfColumnsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialUdfColumnsQuery(
 *   {
 *      materialModelId: // value for 'materialModelId'
 *      getDisabled: // value for 'getDisabled'
 *   }
 * );
 */
export function useGetMaterialUdfColumnsQuery(variables: Operations.GetMaterialUdfColumnsQueryVariables | VueCompositionApi.Ref<Operations.GetMaterialUdfColumnsQueryVariables> | ReactiveFunction<Operations.GetMaterialUdfColumnsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetMaterialUdfColumnsQuery, Operations.GetMaterialUdfColumnsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetMaterialUdfColumnsQuery, Operations.GetMaterialUdfColumnsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetMaterialUdfColumnsQuery, Operations.GetMaterialUdfColumnsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetMaterialUdfColumnsQuery, Operations.GetMaterialUdfColumnsQueryVariables>(Operations.GetMaterialUdfColumnsDocument, variables, options);
          }
export type GetMaterialUdfColumnsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetMaterialUdfColumnsQuery, Operations.GetMaterialUdfColumnsQueryVariables>;

/**
 * __useGetMaterialUdfDefaultDataQuery__
 *
 * To run a query within a Vue component, call `useGetMaterialUdfDefaultDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialUdfDefaultDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetMaterialUdfDefaultDataQuery(
 *   {
 *      materialModelId: // value for 'materialModelId'
 *      getDisabled: // value for 'getDisabled'
 *   }
 * );
 */
export function useGetMaterialUdfDefaultDataQuery(variables: Operations.GetMaterialUdfDefaultDataQueryVariables | VueCompositionApi.Ref<Operations.GetMaterialUdfDefaultDataQueryVariables> | ReactiveFunction<Operations.GetMaterialUdfDefaultDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetMaterialUdfDefaultDataQuery, Operations.GetMaterialUdfDefaultDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetMaterialUdfDefaultDataQuery, Operations.GetMaterialUdfDefaultDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetMaterialUdfDefaultDataQuery, Operations.GetMaterialUdfDefaultDataQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetMaterialUdfDefaultDataQuery, Operations.GetMaterialUdfDefaultDataQueryVariables>(Operations.GetMaterialUdfDefaultDataDocument, variables, options);
          }
export type GetMaterialUdfDefaultDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetMaterialUdfDefaultDataQuery, Operations.GetMaterialUdfDefaultDataQueryVariables>;

/**
 * __useRemoveMaterialMarriageMutation__
 *
 * To run a mutation, you first call `useRemoveMaterialMarriageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMaterialMarriageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRemoveMaterialMarriageMutation({
 *   variables: {
 *      marriageId: // value for 'marriageId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRemoveMaterialMarriageMutation(options: VueApolloComposable.UseMutationOptions<Operations.RemoveMaterialMarriageMutation, Operations.RemoveMaterialMarriageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.RemoveMaterialMarriageMutation, Operations.RemoveMaterialMarriageMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.RemoveMaterialMarriageMutation, Operations.RemoveMaterialMarriageMutationVariables>(Operations.RemoveMaterialMarriageDocument, options);
          }
export type RemoveMaterialMarriageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.RemoveMaterialMarriageMutation, Operations.RemoveMaterialMarriageMutationVariables>;

/**
 * __useUpdateMaterialStatusMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMaterialStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateMaterialStatusMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialStatusMutation, Operations.UpdateMaterialStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialStatusMutation, Operations.UpdateMaterialStatusMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateMaterialStatusMutation, Operations.UpdateMaterialStatusMutationVariables>(Operations.UpdateMaterialStatusDocument, options);
          }
export type UpdateMaterialStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateMaterialStatusMutation, Operations.UpdateMaterialStatusMutationVariables>;

/**
 * __useUpdateMaterialUdfsAndAttributesMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialUdfsAndAttributesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialUdfsAndAttributesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateMaterialUdfsAndAttributesMutation({
 *   variables: {
 *      materialId: // value for 'materialId'
 *      attrsToDelete: // value for 'attrsToDelete'
 *      attrsToAdd: // value for 'attrsToAdd'
 *      materialUdfs: // value for 'materialUdfs'
 *   },
 * });
 */
export function useUpdateMaterialUdfsAndAttributesMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialUdfsAndAttributesMutation, Operations.UpdateMaterialUdfsAndAttributesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateMaterialUdfsAndAttributesMutation, Operations.UpdateMaterialUdfsAndAttributesMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateMaterialUdfsAndAttributesMutation, Operations.UpdateMaterialUdfsAndAttributesMutationVariables>(Operations.UpdateMaterialUdfsAndAttributesDocument, options);
          }
export type UpdateMaterialUdfsAndAttributesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateMaterialUdfsAndAttributesMutation, Operations.UpdateMaterialUdfsAndAttributesMutationVariables>;

/**
 * __useAddMaterialModelMutation__
 *
 * To run a mutation, you first call `useAddMaterialModelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddMaterialModelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddMaterialModelMutation({
 *   variables: {
 *      modelNumber: // value for 'modelNumber'
 *   },
 * });
 */
export function useAddMaterialModelMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddMaterialModelMutation, Operations.AddMaterialModelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddMaterialModelMutation, Operations.AddMaterialModelMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddMaterialModelMutation, Operations.AddMaterialModelMutationVariables>(Operations.AddMaterialModelDocument, options);
          }
export type AddMaterialModelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddMaterialModelMutation, Operations.AddMaterialModelMutationVariables>;

/**
 * __useGetAllModelNumbersQuery__
 *
 * To run a query within a Vue component, call `useGetAllModelNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllModelNumbersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllModelNumbersQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllModelNumbersQuery(variables: Operations.GetAllModelNumbersQueryVariables | VueCompositionApi.Ref<Operations.GetAllModelNumbersQueryVariables> | ReactiveFunction<Operations.GetAllModelNumbersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllModelNumbersQuery, Operations.GetAllModelNumbersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllModelNumbersQuery, Operations.GetAllModelNumbersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllModelNumbersQuery, Operations.GetAllModelNumbersQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllModelNumbersQuery, Operations.GetAllModelNumbersQueryVariables>(Operations.GetAllModelNumbersDocument, variables, options);
          }
export type GetAllModelNumbersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllModelNumbersQuery, Operations.GetAllModelNumbersQueryVariables>;

/**
 * __useAddAssetMutation__
 *
 * To run a mutation, you first call `useAddAssetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddAssetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddAssetMutation({
 *   variables: {
 *      asset: // value for 'asset'
 *   },
 * });
 */
export function useAddAssetMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddAssetMutation, Operations.AddAssetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddAssetMutation, Operations.AddAssetMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddAssetMutation, Operations.AddAssetMutationVariables>(Operations.AddAssetDocument, options);
          }
export type AddAssetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddAssetMutation, Operations.AddAssetMutationVariables>;

/**
 * __useAddDataLabelMutation__
 *
 * To run a mutation, you first call `useAddDataLabelMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddDataLabelMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddDataLabelMutation({
 *   variables: {
 *      data_label: // value for 'data_label'
 *   },
 * });
 */
export function useAddDataLabelMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddDataLabelMutation, Operations.AddDataLabelMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddDataLabelMutation, Operations.AddDataLabelMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddDataLabelMutation, Operations.AddDataLabelMutationVariables>(Operations.AddDataLabelDocument, options);
          }
export type AddDataLabelMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddDataLabelMutation, Operations.AddDataLabelMutationVariables>;

/**
 * __useGetAllAssetCodesQuery__
 *
 * To run a query within a Vue component, call `useGetAllAssetCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssetCodesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAssetCodesQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *   }
 * );
 */
export function useGetAllAssetCodesQuery(variables: Operations.GetAllAssetCodesQueryVariables | VueCompositionApi.Ref<Operations.GetAllAssetCodesQueryVariables> | ReactiveFunction<Operations.GetAllAssetCodesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllAssetCodesQuery, Operations.GetAllAssetCodesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllAssetCodesQuery, Operations.GetAllAssetCodesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllAssetCodesQuery, Operations.GetAllAssetCodesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllAssetCodesQuery, Operations.GetAllAssetCodesQueryVariables>(Operations.GetAllAssetCodesDocument, variables, options);
          }
export type GetAllAssetCodesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllAssetCodesQuery, Operations.GetAllAssetCodesQueryVariables>;

/**
 * __useGetAllAssetTypesQuery__
 *
 * To run a query within a Vue component, call `useGetAllAssetTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssetTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllAssetTypesQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useGetAllAssetTypesQuery(variables: Operations.GetAllAssetTypesQueryVariables | VueCompositionApi.Ref<Operations.GetAllAssetTypesQueryVariables> | ReactiveFunction<Operations.GetAllAssetTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllAssetTypesQuery, Operations.GetAllAssetTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllAssetTypesQuery, Operations.GetAllAssetTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllAssetTypesQuery, Operations.GetAllAssetTypesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllAssetTypesQuery, Operations.GetAllAssetTypesQueryVariables>(Operations.GetAllAssetTypesDocument, variables, options);
          }
export type GetAllAssetTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllAssetTypesQuery, Operations.GetAllAssetTypesQueryVariables>;

/**
 * __useCatReportQuery__
 *
 * To run a query within a Vue component, call `useCatReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCatReportQuery(
 *   {
 *      args: // value for 'args'
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useCatReportQuery(variables: Operations.CatReportQueryVariables | VueCompositionApi.Ref<Operations.CatReportQueryVariables> | ReactiveFunction<Operations.CatReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.CatReportQuery, Operations.CatReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.CatReportQuery, Operations.CatReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.CatReportQuery, Operations.CatReportQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.CatReportQuery, Operations.CatReportQueryVariables>(Operations.CatReportDocument, variables, options);
          }
export type CatReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.CatReportQuery, Operations.CatReportQueryVariables>;

/**
 * __useFisDataLabelSelectorQuery__
 *
 * To run a query within a Vue component, call `useFisDataLabelSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useFisDataLabelSelectorQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFisDataLabelSelectorQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useFisDataLabelSelectorQuery(variables: Operations.FisDataLabelSelectorQueryVariables | VueCompositionApi.Ref<Operations.FisDataLabelSelectorQueryVariables> | ReactiveFunction<Operations.FisDataLabelSelectorQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.FisDataLabelSelectorQuery, Operations.FisDataLabelSelectorQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.FisDataLabelSelectorQuery, Operations.FisDataLabelSelectorQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.FisDataLabelSelectorQuery, Operations.FisDataLabelSelectorQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.FisDataLabelSelectorQuery, Operations.FisDataLabelSelectorQueryVariables>(Operations.FisDataLabelSelectorDocument, variables, options);
          }
export type FisDataLabelSelectorQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.FisDataLabelSelectorQuery, Operations.FisDataLabelSelectorQueryVariables>;

/**
 * __useDeleteAssetMutation__
 *
 * To run a mutation, you first call `useDeleteAssetMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssetMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteAssetMutation, Operations.DeleteAssetMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteAssetMutation, Operations.DeleteAssetMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteAssetMutation, Operations.DeleteAssetMutationVariables>(Operations.DeleteAssetDocument, options);
          }
export type DeleteAssetMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteAssetMutation, Operations.DeleteAssetMutationVariables>;

/**
 * __useFisDetailReportQuery__
 *
 * To run a query within a Vue component, call `useFisDetailReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFisDetailReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFisDetailReportQuery(
 *   {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *   }
 * );
 */
export function useFisDetailReportQuery(variables: Operations.FisDetailReportQueryVariables | VueCompositionApi.Ref<Operations.FisDetailReportQueryVariables> | ReactiveFunction<Operations.FisDetailReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.FisDetailReportQuery, Operations.FisDetailReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.FisDetailReportQuery, Operations.FisDetailReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.FisDetailReportQuery, Operations.FisDetailReportQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.FisDetailReportQuery, Operations.FisDetailReportQueryVariables>(Operations.FisDetailReportDocument, variables, options);
          }
export type FisDetailReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.FisDetailReportQuery, Operations.FisDetailReportQueryVariables>;

/**
 * __useFaultReportQuery__
 *
 * To run a query within a Vue component, call `useFaultReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaultReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFaultReportQuery(
 *   {
 *      args: // value for 'args'
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useFaultReportQuery(variables: Operations.FaultReportQueryVariables | VueCompositionApi.Ref<Operations.FaultReportQueryVariables> | ReactiveFunction<Operations.FaultReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.FaultReportQuery, Operations.FaultReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.FaultReportQuery, Operations.FaultReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.FaultReportQuery, Operations.FaultReportQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.FaultReportQuery, Operations.FaultReportQueryVariables>(Operations.FaultReportDocument, variables, options);
          }
export type FaultReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.FaultReportQuery, Operations.FaultReportQueryVariables>;

/**
 * __useGetAssetsQuery__
 *
 * To run a query within a Vue component, call `useGetAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAssetsQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useGetAssetsQuery(variables: Operations.GetAssetsQueryVariables | VueCompositionApi.Ref<Operations.GetAssetsQueryVariables> | ReactiveFunction<Operations.GetAssetsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAssetsQuery, Operations.GetAssetsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAssetsQuery, Operations.GetAssetsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAssetsQuery, Operations.GetAssetsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAssetsQuery, Operations.GetAssetsQueryVariables>(Operations.GetAssetsDocument, variables, options);
          }
export type GetAssetsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAssetsQuery, Operations.GetAssetsQueryVariables>;

/**
 * __useMtbfReportQuery__
 *
 * To run a query within a Vue component, call `useMtbfReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useMtbfReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMtbfReportQuery(
 *   {
 *      args: // value for 'args'
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useMtbfReportQuery(variables: Operations.MtbfReportQueryVariables | VueCompositionApi.Ref<Operations.MtbfReportQueryVariables> | ReactiveFunction<Operations.MtbfReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.MtbfReportQuery, Operations.MtbfReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.MtbfReportQuery, Operations.MtbfReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.MtbfReportQuery, Operations.MtbfReportQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.MtbfReportQuery, Operations.MtbfReportQueryVariables>(Operations.MtbfReportDocument, variables, options);
          }
export type MtbfReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.MtbfReportQuery, Operations.MtbfReportQueryVariables>;

/**
 * __useOeeReportQuery__
 *
 * To run a query within a Vue component, call `useOeeReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOeeReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOeeReportQuery(
 *   {
 *      args: // value for 'args'
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useOeeReportQuery(variables: Operations.OeeReportQueryVariables | VueCompositionApi.Ref<Operations.OeeReportQueryVariables> | ReactiveFunction<Operations.OeeReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.OeeReportQuery, Operations.OeeReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.OeeReportQuery, Operations.OeeReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.OeeReportQuery, Operations.OeeReportQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.OeeReportQuery, Operations.OeeReportQueryVariables>(Operations.OeeReportDocument, variables, options);
          }
export type OeeReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.OeeReportQuery, Operations.OeeReportQueryVariables>;

/**
 * __useStateReportQuery__
 *
 * To run a query within a Vue component, call `useStateReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useStateReportQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useStateReportQuery(
 *   {
 *      args: // value for 'args'
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useStateReportQuery(variables: Operations.StateReportQueryVariables | VueCompositionApi.Ref<Operations.StateReportQueryVariables> | ReactiveFunction<Operations.StateReportQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.StateReportQuery, Operations.StateReportQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.StateReportQuery, Operations.StateReportQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.StateReportQuery, Operations.StateReportQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.StateReportQuery, Operations.StateReportQueryVariables>(Operations.StateReportDocument, variables, options);
          }
export type StateReportQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.StateReportQuery, Operations.StateReportQueryVariables>;

/**
 * __useDistinctDataLabelsQuery__
 *
 * To run a query within a Vue component, call `useDistinctDataLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistinctDataLabelsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDistinctDataLabelsQuery(
 *   {
 *      args: // value for 'args'
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useDistinctDataLabelsQuery(variables: Operations.DistinctDataLabelsQueryVariables | VueCompositionApi.Ref<Operations.DistinctDataLabelsQueryVariables> | ReactiveFunction<Operations.DistinctDataLabelsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.DistinctDataLabelsQuery, Operations.DistinctDataLabelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.DistinctDataLabelsQuery, Operations.DistinctDataLabelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.DistinctDataLabelsQuery, Operations.DistinctDataLabelsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.DistinctDataLabelsQuery, Operations.DistinctDataLabelsQueryVariables>(Operations.DistinctDataLabelsDocument, variables, options);
          }
export type DistinctDataLabelsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.DistinctDataLabelsQuery, Operations.DistinctDataLabelsQueryVariables>;

/**
 * __useGetAllDataLabelsQuery__
 *
 * To run a query within a Vue component, call `useGetAllDataLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDataLabelsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllDataLabelsQuery(
 *   {
 *      filter: // value for 'filter'
 *      order_by: // value for 'order_by'
 *   }
 * );
 */
export function useGetAllDataLabelsQuery(variables: Operations.GetAllDataLabelsQueryVariables | VueCompositionApi.Ref<Operations.GetAllDataLabelsQueryVariables> | ReactiveFunction<Operations.GetAllDataLabelsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllDataLabelsQuery, Operations.GetAllDataLabelsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllDataLabelsQuery, Operations.GetAllDataLabelsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllDataLabelsQuery, Operations.GetAllDataLabelsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllDataLabelsQuery, Operations.GetAllDataLabelsQueryVariables>(Operations.GetAllDataLabelsDocument, variables, options);
          }
export type GetAllDataLabelsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllDataLabelsQuery, Operations.GetAllDataLabelsQueryVariables>;

/**
 * __useAddAssetTypeMutation__
 *
 * To run a mutation, you first call `useAddAssetTypeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddAssetTypeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddAssetTypeMutation({
 *   variables: {
 *      assetType: // value for 'assetType'
 *   },
 * });
 */
export function useAddAssetTypeMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddAssetTypeMutation, Operations.AddAssetTypeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddAssetTypeMutation, Operations.AddAssetTypeMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddAssetTypeMutation, Operations.AddAssetTypeMutationVariables>(Operations.AddAssetTypeDocument, options);
          }
export type AddAssetTypeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddAssetTypeMutation, Operations.AddAssetTypeMutationVariables>;

/**
 * __useGetAssetTypeQuery__
 *
 * To run a query within a Vue component, call `useGetAssetTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetTypeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAssetTypeQuery(
 *   {
 *      assetTypeId: // value for 'assetTypeId'
 *   }
 * );
 */
export function useGetAssetTypeQuery(variables: Operations.GetAssetTypeQueryVariables | VueCompositionApi.Ref<Operations.GetAssetTypeQueryVariables> | ReactiveFunction<Operations.GetAssetTypeQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAssetTypeQuery, Operations.GetAssetTypeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAssetTypeQuery, Operations.GetAssetTypeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAssetTypeQuery, Operations.GetAssetTypeQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAssetTypeQuery, Operations.GetAssetTypeQueryVariables>(Operations.GetAssetTypeDocument, variables, options);
          }
export type GetAssetTypeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAssetTypeQuery, Operations.GetAssetTypeQueryVariables>;

/**
 * __useUpdateAssetTypeMutation__
 *
 * To run a mutation, you first call `useUpdateAssetTypeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetTypeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAssetTypeMutation({
 *   variables: {
 *      assetTypeId: // value for 'assetTypeId'
 *      assetType: // value for 'assetType'
 *      insertAssetCodes: // value for 'insertAssetCodes'
 *      deleteAssetCodeBoolExp: // value for 'deleteAssetCodeBoolExp'
 *   },
 * });
 */
export function useUpdateAssetTypeMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateAssetTypeMutation, Operations.UpdateAssetTypeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateAssetTypeMutation, Operations.UpdateAssetTypeMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateAssetTypeMutation, Operations.UpdateAssetTypeMutationVariables>(Operations.UpdateAssetTypeDocument, options);
          }
export type UpdateAssetTypeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateAssetTypeMutation, Operations.UpdateAssetTypeMutationVariables>;

/**
 * __useGetAllSchemaPropertiesQuery__
 *
 * To run a query within a Vue component, call `useGetAllSchemaPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSchemaPropertiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllSchemaPropertiesQuery(
 *   {
 *      schemaId: // value for 'schemaId'
 *   }
 * );
 */
export function useGetAllSchemaPropertiesQuery(variables: Operations.GetAllSchemaPropertiesQueryVariables | VueCompositionApi.Ref<Operations.GetAllSchemaPropertiesQueryVariables> | ReactiveFunction<Operations.GetAllSchemaPropertiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllSchemaPropertiesQuery, Operations.GetAllSchemaPropertiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllSchemaPropertiesQuery, Operations.GetAllSchemaPropertiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllSchemaPropertiesQuery, Operations.GetAllSchemaPropertiesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllSchemaPropertiesQuery, Operations.GetAllSchemaPropertiesQueryVariables>(Operations.GetAllSchemaPropertiesDocument, variables, options);
          }
export type GetAllSchemaPropertiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllSchemaPropertiesQuery, Operations.GetAllSchemaPropertiesQueryVariables>;

/**
 * __useSaveProcessMutation__
 *
 * To run a mutation, you first call `useSaveProcessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveProcessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveProcessMutation({
 *   variables: {
 *      processInput: // value for 'processInput'
 *      processOnConflict: // value for 'processOnConflict'
 *   },
 * });
 */
export function useSaveProcessMutation(options: VueApolloComposable.UseMutationOptions<Operations.SaveProcessMutation, Operations.SaveProcessMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SaveProcessMutation, Operations.SaveProcessMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SaveProcessMutation, Operations.SaveProcessMutationVariables>(Operations.SaveProcessDocument, options);
          }
export type SaveProcessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SaveProcessMutation, Operations.SaveProcessMutationVariables>;

/**
 * __useGetProcessQuery__
 *
 * To run a query within a Vue component, call `useGetProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProcessQuery(
 *   {
 *      process_id: // value for 'process_id'
 *   }
 * );
 */
export function useGetProcessQuery(variables: Operations.GetProcessQueryVariables | VueCompositionApi.Ref<Operations.GetProcessQueryVariables> | ReactiveFunction<Operations.GetProcessQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetProcessQuery, Operations.GetProcessQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetProcessQuery, Operations.GetProcessQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetProcessQuery, Operations.GetProcessQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetProcessQuery, Operations.GetProcessQueryVariables>(Operations.GetProcessDocument, variables, options);
          }
export type GetProcessQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetProcessQuery, Operations.GetProcessQueryVariables>;

/**
 * __useGetProcessesForListQuery__
 *
 * To run a query within a Vue component, call `useGetProcessesForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessesForListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetProcessesForListQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useGetProcessesForListQuery(variables: Operations.GetProcessesForListQueryVariables | VueCompositionApi.Ref<Operations.GetProcessesForListQueryVariables> | ReactiveFunction<Operations.GetProcessesForListQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetProcessesForListQuery, Operations.GetProcessesForListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetProcessesForListQuery, Operations.GetProcessesForListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetProcessesForListQuery, Operations.GetProcessesForListQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetProcessesForListQuery, Operations.GetProcessesForListQueryVariables>(Operations.GetProcessesForListDocument, variables, options);
          }
export type GetProcessesForListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetProcessesForListQuery, Operations.GetProcessesForListQueryVariables>;

/**
 * __useDeleteProcessMutation__
 *
 * To run a mutation, you first call `useDeleteProcessMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcessMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProcessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProcessMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteProcessMutation, Operations.DeleteProcessMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteProcessMutation, Operations.DeleteProcessMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteProcessMutation, Operations.DeleteProcessMutationVariables>(Operations.DeleteProcessDocument, options);
          }
export type DeleteProcessMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteProcessMutation, Operations.DeleteProcessMutationVariables>;

/**
 * __useAddRoleMutation__
 *
 * To run a mutation, you first call `useAddRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddRoleMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddRoleMutation, Operations.AddRoleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddRoleMutation, Operations.AddRoleMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddRoleMutation, Operations.AddRoleMutationVariables>(Operations.AddRoleDocument, options);
          }
export type AddRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddRoleMutation, Operations.AddRoleMutationVariables>;

/**
 * __useGetRoleByIdQuery__
 *
 * To run a query within a Vue component, call `useGetRoleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRoleByIdQuery(
 *   {
 *      roleId: // value for 'roleId'
 *   }
 * );
 */
export function useGetRoleByIdQuery(variables: Operations.GetRoleByIdQueryVariables | VueCompositionApi.Ref<Operations.GetRoleByIdQueryVariables> | ReactiveFunction<Operations.GetRoleByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetRoleByIdQuery, Operations.GetRoleByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetRoleByIdQuery, Operations.GetRoleByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetRoleByIdQuery, Operations.GetRoleByIdQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetRoleByIdQuery, Operations.GetRoleByIdQueryVariables>(Operations.GetRoleByIdDocument, variables, options);
          }
export type GetRoleByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetRoleByIdQuery, Operations.GetRoleByIdQueryVariables>;

/**
 * __useGetRoleUsersQuery__
 *
 * To run a query within a Vue component, call `useGetRoleUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetRoleUsersQuery(
 *   {
 *      roleId: // value for 'roleId'
 *   }
 * );
 */
export function useGetRoleUsersQuery(variables: Operations.GetRoleUsersQueryVariables | VueCompositionApi.Ref<Operations.GetRoleUsersQueryVariables> | ReactiveFunction<Operations.GetRoleUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetRoleUsersQuery, Operations.GetRoleUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetRoleUsersQuery, Operations.GetRoleUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetRoleUsersQuery, Operations.GetRoleUsersQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetRoleUsersQuery, Operations.GetRoleUsersQueryVariables>(Operations.GetRoleUsersDocument, variables, options);
          }
export type GetRoleUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetRoleUsersQuery, Operations.GetRoleUsersQueryVariables>;

/**
 * __useGetAllRolesQuery__
 *
 * To run a query within a Vue component, call `useGetAllRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRolesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllRolesQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortby: // value for 'sortby'
 *   }
 * );
 */
export function useGetAllRolesQuery(variables?: Operations.GetAllRolesQueryVariables | VueCompositionApi.Ref<Operations.GetAllRolesQueryVariables> | ReactiveFunction<Operations.GetAllRolesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllRolesQuery, Operations.GetAllRolesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllRolesQuery, Operations.GetAllRolesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllRolesQuery, Operations.GetAllRolesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllRolesQuery, Operations.GetAllRolesQueryVariables>(Operations.GetAllRolesDocument, variables, options);
          }
export type GetAllRolesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllRolesQuery, Operations.GetAllRolesQueryVariables>;

/**
 * __useSetRoleToDisabledMutation__
 *
 * To run a mutation, you first call `useSetRoleToDisabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetRoleToDisabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetRoleToDisabledMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useSetRoleToDisabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetRoleToDisabledMutation, Operations.SetRoleToDisabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetRoleToDisabledMutation, Operations.SetRoleToDisabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetRoleToDisabledMutation, Operations.SetRoleToDisabledMutationVariables>(Operations.SetRoleToDisabledDocument, options);
          }
export type SetRoleToDisabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetRoleToDisabledMutation, Operations.SetRoleToDisabledMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      role: // value for 'role'
 *      insertRoleAcls: // value for 'insertRoleAcls'
 *      deleteRoleAclsBoolExp: // value for 'deleteRoleAclsBoolExp'
 *   },
 * });
 */
export function useUpdateRoleMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateRoleMutation, Operations.UpdateRoleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateRoleMutation, Operations.UpdateRoleMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateRoleMutation, Operations.UpdateRoleMutationVariables>(Operations.UpdateRoleDocument, options);
          }
export type UpdateRoleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateRoleMutation, Operations.UpdateRoleMutationVariables>;

/**
 * __useAddCalendarMutation__
 *
 * To run a mutation, you first call `useAddCalendarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCalendarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCalendarMutation({
 *   variables: {
 *      calendar: // value for 'calendar'
 *   },
 * });
 */
export function useAddCalendarMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddCalendarMutation, Operations.AddCalendarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddCalendarMutation, Operations.AddCalendarMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddCalendarMutation, Operations.AddCalendarMutationVariables>(Operations.AddCalendarDocument, options);
          }
export type AddCalendarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddCalendarMutation, Operations.AddCalendarMutationVariables>;

/**
 * __useGetAllCalendarsQuery__
 *
 * To run a query within a Vue component, call `useGetAllCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCalendarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllCalendarsQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllCalendarsQuery(variables: Operations.GetAllCalendarsQueryVariables | VueCompositionApi.Ref<Operations.GetAllCalendarsQueryVariables> | ReactiveFunction<Operations.GetAllCalendarsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarsQuery, Operations.GetAllCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarsQuery, Operations.GetAllCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarsQuery, Operations.GetAllCalendarsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllCalendarsQuery, Operations.GetAllCalendarsQueryVariables>(Operations.GetAllCalendarsDocument, variables, options);
          }
export type GetAllCalendarsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllCalendarsQuery, Operations.GetAllCalendarsQueryVariables>;

/**
 * __useGetActiveCalendarQuery__
 *
 * To run a query within a Vue component, call `useGetActiveCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCalendarQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetActiveCalendarQuery(
 *   {
 *      args: // value for 'args'
 *   }
 * );
 */
export function useGetActiveCalendarQuery(variables: Operations.GetActiveCalendarQueryVariables | VueCompositionApi.Ref<Operations.GetActiveCalendarQueryVariables> | ReactiveFunction<Operations.GetActiveCalendarQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetActiveCalendarQuery, Operations.GetActiveCalendarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetActiveCalendarQuery, Operations.GetActiveCalendarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetActiveCalendarQuery, Operations.GetActiveCalendarQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetActiveCalendarQuery, Operations.GetActiveCalendarQueryVariables>(Operations.GetActiveCalendarDocument, variables, options);
          }
export type GetActiveCalendarQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetActiveCalendarQuery, Operations.GetActiveCalendarQueryVariables>;

/**
 * __useGetCalendarQuery__
 *
 * To run a query within a Vue component, call `useGetCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCalendarQuery(
 *   {
 *      calendarId: // value for 'calendarId'
 *   }
 * );
 */
export function useGetCalendarQuery(variables: Operations.GetCalendarQueryVariables | VueCompositionApi.Ref<Operations.GetCalendarQueryVariables> | ReactiveFunction<Operations.GetCalendarQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetCalendarQuery, Operations.GetCalendarQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetCalendarQuery, Operations.GetCalendarQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetCalendarQuery, Operations.GetCalendarQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetCalendarQuery, Operations.GetCalendarQueryVariables>(Operations.GetCalendarDocument, variables, options);
          }
export type GetCalendarQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetCalendarQuery, Operations.GetCalendarQueryVariables>;

/**
 * __useSetCalendarToDisabledMutation__
 *
 * To run a mutation, you first call `useSetCalendarToDisabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCalendarToDisabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCalendarToDisabledMutation({
 *   variables: {
 *      calendarId: // value for 'calendarId'
 *   },
 * });
 */
export function useSetCalendarToDisabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetCalendarToDisabledMutation, Operations.SetCalendarToDisabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetCalendarToDisabledMutation, Operations.SetCalendarToDisabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetCalendarToDisabledMutation, Operations.SetCalendarToDisabledMutationVariables>(Operations.SetCalendarToDisabledDocument, options);
          }
export type SetCalendarToDisabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetCalendarToDisabledMutation, Operations.SetCalendarToDisabledMutationVariables>;

/**
 * __useUpdateCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCalendarMutation({
 *   variables: {
 *      calendar: // value for 'calendar'
 *      deleteCalEvents: // value for 'deleteCalEvents'
 *   },
 * });
 */
export function useUpdateCalendarMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateCalendarMutation, Operations.UpdateCalendarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateCalendarMutation, Operations.UpdateCalendarMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateCalendarMutation, Operations.UpdateCalendarMutationVariables>(Operations.UpdateCalendarDocument, options);
          }
export type UpdateCalendarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateCalendarMutation, Operations.UpdateCalendarMutationVariables>;

/**
 * __useAddCalendarEventsMutation__
 *
 * To run a mutation, you first call `useAddCalendarEventsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCalendarEventsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCalendarEventsMutation({
 *   variables: {
 *      calendarEvent: // value for 'calendarEvent'
 *   },
 * });
 */
export function useAddCalendarEventsMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddCalendarEventsMutation, Operations.AddCalendarEventsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddCalendarEventsMutation, Operations.AddCalendarEventsMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddCalendarEventsMutation, Operations.AddCalendarEventsMutationVariables>(Operations.AddCalendarEventsDocument, options);
          }
export type AddCalendarEventsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddCalendarEventsMutation, Operations.AddCalendarEventsMutationVariables>;

/**
 * __useDeleteCalendarEventMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCalendarEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCalendarEventMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteCalendarEventMutation, Operations.DeleteCalendarEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteCalendarEventMutation, Operations.DeleteCalendarEventMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteCalendarEventMutation, Operations.DeleteCalendarEventMutationVariables>(Operations.DeleteCalendarEventDocument, options);
          }
export type DeleteCalendarEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteCalendarEventMutation, Operations.DeleteCalendarEventMutationVariables>;

/**
 * __useGetAllCalendarEventUdfsQuery__
 *
 * To run a query within a Vue component, call `useGetAllCalendarEventUdfsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCalendarEventUdfsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllCalendarEventUdfsQuery(
 *   {
 *   }
 * );
 */
export function useGetAllCalendarEventUdfsQuery(options: VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarEventUdfsQuery, Operations.GetAllCalendarEventUdfsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarEventUdfsQuery, Operations.GetAllCalendarEventUdfsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarEventUdfsQuery, Operations.GetAllCalendarEventUdfsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllCalendarEventUdfsQuery, undefined>(Operations.GetAllCalendarEventUdfsDocument, undefined, options);
          }
export type GetAllCalendarEventUdfsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllCalendarEventUdfsQuery, Operations.GetAllCalendarEventUdfsQueryVariables>;

/**
 * __useGetAllCalendarEventsQuery__
 *
 * To run a query within a Vue component, call `useGetAllCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCalendarEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllCalendarEventsQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllCalendarEventsQuery(variables: Operations.GetAllCalendarEventsQueryVariables | VueCompositionApi.Ref<Operations.GetAllCalendarEventsQueryVariables> | ReactiveFunction<Operations.GetAllCalendarEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarEventsQuery, Operations.GetAllCalendarEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarEventsQuery, Operations.GetAllCalendarEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarEventsQuery, Operations.GetAllCalendarEventsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllCalendarEventsQuery, Operations.GetAllCalendarEventsQueryVariables>(Operations.GetAllCalendarEventsDocument, variables, options);
          }
export type GetAllCalendarEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllCalendarEventsQuery, Operations.GetAllCalendarEventsQueryVariables>;

/**
 * __useGetCalendarEventQuery__
 *
 * To run a query within a Vue component, call `useGetCalendarEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarEventQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCalendarEventQuery(
 *   {
 *      calendarEventId: // value for 'calendarEventId'
 *   }
 * );
 */
export function useGetCalendarEventQuery(variables: Operations.GetCalendarEventQueryVariables | VueCompositionApi.Ref<Operations.GetCalendarEventQueryVariables> | ReactiveFunction<Operations.GetCalendarEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetCalendarEventQuery, Operations.GetCalendarEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetCalendarEventQuery, Operations.GetCalendarEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetCalendarEventQuery, Operations.GetCalendarEventQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetCalendarEventQuery, Operations.GetCalendarEventQueryVariables>(Operations.GetCalendarEventDocument, variables, options);
          }
export type GetCalendarEventQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetCalendarEventQuery, Operations.GetCalendarEventQueryVariables>;

/**
 * __useGetCalendarEventsForScheduleQuery__
 *
 * To run a query within a Vue component, call `useGetCalendarEventsForScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarEventsForScheduleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCalendarEventsForScheduleQuery(
 *   {
 *      calendarId: // value for 'calendarId'
 *   }
 * );
 */
export function useGetCalendarEventsForScheduleQuery(variables: Operations.GetCalendarEventsForScheduleQueryVariables | VueCompositionApi.Ref<Operations.GetCalendarEventsForScheduleQueryVariables> | ReactiveFunction<Operations.GetCalendarEventsForScheduleQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetCalendarEventsForScheduleQuery, Operations.GetCalendarEventsForScheduleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetCalendarEventsForScheduleQuery, Operations.GetCalendarEventsForScheduleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetCalendarEventsForScheduleQuery, Operations.GetCalendarEventsForScheduleQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetCalendarEventsForScheduleQuery, Operations.GetCalendarEventsForScheduleQueryVariables>(Operations.GetCalendarEventsForScheduleDocument, variables, options);
          }
export type GetCalendarEventsForScheduleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetCalendarEventsForScheduleQuery, Operations.GetCalendarEventsForScheduleQueryVariables>;

/**
 * __useUpdateCalendarEventMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCalendarEventMutation({
 *   variables: {
 *      calendarEventId: // value for 'calendarEventId'
 *      calendarEvent: // value for 'calendarEvent'
 *   },
 * });
 */
export function useUpdateCalendarEventMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateCalendarEventMutation, Operations.UpdateCalendarEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateCalendarEventMutation, Operations.UpdateCalendarEventMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateCalendarEventMutation, Operations.UpdateCalendarEventMutationVariables>(Operations.UpdateCalendarEventDocument, options);
          }
export type UpdateCalendarEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateCalendarEventMutation, Operations.UpdateCalendarEventMutationVariables>;

/**
 * __useAddCalendarLocationMutation__
 *
 * To run a mutation, you first call `useAddCalendarLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddCalendarLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddCalendarLocationMutation({
 *   variables: {
 *      calendarLocation: // value for 'calendarLocation'
 *   },
 * });
 */
export function useAddCalendarLocationMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddCalendarLocationMutation, Operations.AddCalendarLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddCalendarLocationMutation, Operations.AddCalendarLocationMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddCalendarLocationMutation, Operations.AddCalendarLocationMutationVariables>(Operations.AddCalendarLocationDocument, options);
          }
export type AddCalendarLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddCalendarLocationMutation, Operations.AddCalendarLocationMutationVariables>;

/**
 * __useGetAllCalendarLocationsQuery__
 *
 * To run a query within a Vue component, call `useGetAllCalendarLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCalendarLocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllCalendarLocationsQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllCalendarLocationsQuery(variables: Operations.GetAllCalendarLocationsQueryVariables | VueCompositionApi.Ref<Operations.GetAllCalendarLocationsQueryVariables> | ReactiveFunction<Operations.GetAllCalendarLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarLocationsQuery, Operations.GetAllCalendarLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarLocationsQuery, Operations.GetAllCalendarLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllCalendarLocationsQuery, Operations.GetAllCalendarLocationsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllCalendarLocationsQuery, Operations.GetAllCalendarLocationsQueryVariables>(Operations.GetAllCalendarLocationsDocument, variables, options);
          }
export type GetAllCalendarLocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllCalendarLocationsQuery, Operations.GetAllCalendarLocationsQueryVariables>;

/**
 * __useGetCalendarLocationQuery__
 *
 * To run a query within a Vue component, call `useGetCalendarLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarLocationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCalendarLocationQuery(
 *   {
 *      calendarLocationId: // value for 'calendarLocationId'
 *   }
 * );
 */
export function useGetCalendarLocationQuery(variables: Operations.GetCalendarLocationQueryVariables | VueCompositionApi.Ref<Operations.GetCalendarLocationQueryVariables> | ReactiveFunction<Operations.GetCalendarLocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetCalendarLocationQuery, Operations.GetCalendarLocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetCalendarLocationQuery, Operations.GetCalendarLocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetCalendarLocationQuery, Operations.GetCalendarLocationQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetCalendarLocationQuery, Operations.GetCalendarLocationQueryVariables>(Operations.GetCalendarLocationDocument, variables, options);
          }
export type GetCalendarLocationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetCalendarLocationQuery, Operations.GetCalendarLocationQueryVariables>;

/**
 * __useGetCalendarsByLocationQuery__
 *
 * To run a query within a Vue component, call `useGetCalendarsByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarsByLocationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCalendarsByLocationQuery(
 *   {
 *      locationId: // value for 'locationId'
 *   }
 * );
 */
export function useGetCalendarsByLocationQuery(variables: Operations.GetCalendarsByLocationQueryVariables | VueCompositionApi.Ref<Operations.GetCalendarsByLocationQueryVariables> | ReactiveFunction<Operations.GetCalendarsByLocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetCalendarsByLocationQuery, Operations.GetCalendarsByLocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetCalendarsByLocationQuery, Operations.GetCalendarsByLocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetCalendarsByLocationQuery, Operations.GetCalendarsByLocationQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetCalendarsByLocationQuery, Operations.GetCalendarsByLocationQueryVariables>(Operations.GetCalendarsByLocationDocument, variables, options);
          }
export type GetCalendarsByLocationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetCalendarsByLocationQuery, Operations.GetCalendarsByLocationQueryVariables>;

/**
 * __useSetCalendarLocationToDisabledMutation__
 *
 * To run a mutation, you first call `useSetCalendarLocationToDisabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetCalendarLocationToDisabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetCalendarLocationToDisabledMutation({
 *   variables: {
 *      calendarLocationId: // value for 'calendarLocationId'
 *   },
 * });
 */
export function useSetCalendarLocationToDisabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetCalendarLocationToDisabledMutation, Operations.SetCalendarLocationToDisabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetCalendarLocationToDisabledMutation, Operations.SetCalendarLocationToDisabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetCalendarLocationToDisabledMutation, Operations.SetCalendarLocationToDisabledMutationVariables>(Operations.SetCalendarLocationToDisabledDocument, options);
          }
export type SetCalendarLocationToDisabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetCalendarLocationToDisabledMutation, Operations.SetCalendarLocationToDisabledMutationVariables>;

/**
 * __useAddEventMutation__
 *
 * To run a mutation, you first call `useAddEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *   },
 * });
 */
export function useAddEventMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddEventMutation, Operations.AddEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddEventMutation, Operations.AddEventMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddEventMutation, Operations.AddEventMutationVariables>(Operations.AddEventDocument, options);
          }
export type AddEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddEventMutation, Operations.AddEventMutationVariables>;

/**
 * __useGetAllEventsQuery__
 *
 * To run a query within a Vue component, call `useGetAllEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllEventsQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllEventsQuery(variables: Operations.GetAllEventsQueryVariables | VueCompositionApi.Ref<Operations.GetAllEventsQueryVariables> | ReactiveFunction<Operations.GetAllEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllEventsQuery, Operations.GetAllEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllEventsQuery, Operations.GetAllEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllEventsQuery, Operations.GetAllEventsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllEventsQuery, Operations.GetAllEventsQueryVariables>(Operations.GetAllEventsDocument, variables, options);
          }
export type GetAllEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllEventsQuery, Operations.GetAllEventsQueryVariables>;

/**
 * __useGetEventQuery__
 *
 * To run a query within a Vue component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEventQuery(
 *   {
 *      eventId: // value for 'eventId'
 *   }
 * );
 */
export function useGetEventQuery(variables: Operations.GetEventQueryVariables | VueCompositionApi.Ref<Operations.GetEventQueryVariables> | ReactiveFunction<Operations.GetEventQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetEventQuery, Operations.GetEventQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetEventQuery, Operations.GetEventQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetEventQuery, Operations.GetEventQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetEventQuery, Operations.GetEventQueryVariables>(Operations.GetEventDocument, variables, options);
          }
export type GetEventQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetEventQuery, Operations.GetEventQueryVariables>;

/**
 * __useSetEventToDisabledMutation__
 *
 * To run a mutation, you first call `useSetEventToDisabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetEventToDisabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetEventToDisabledMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSetEventToDisabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetEventToDisabledMutation, Operations.SetEventToDisabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetEventToDisabledMutation, Operations.SetEventToDisabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetEventToDisabledMutation, Operations.SetEventToDisabledMutationVariables>(Operations.SetEventToDisabledDocument, options);
          }
export type SetEventToDisabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetEventToDisabledMutation, Operations.SetEventToDisabledMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      event: // value for 'event'
 *   },
 * });
 */
export function useUpdateEventMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateEventMutation, Operations.UpdateEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateEventMutation, Operations.UpdateEventMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateEventMutation, Operations.UpdateEventMutationVariables>(Operations.UpdateEventDocument, options);
          }
export type UpdateEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateEventMutation, Operations.UpdateEventMutationVariables>;

/**
 * __useGetEventTypesWithSchemaQuery__
 *
 * To run a query within a Vue component, call `useGetEventTypesWithSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventTypesWithSchemaQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetEventTypesWithSchemaQuery(
 *   {
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetEventTypesWithSchemaQuery(variables?: Operations.GetEventTypesWithSchemaQueryVariables | VueCompositionApi.Ref<Operations.GetEventTypesWithSchemaQueryVariables> | ReactiveFunction<Operations.GetEventTypesWithSchemaQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetEventTypesWithSchemaQuery, Operations.GetEventTypesWithSchemaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetEventTypesWithSchemaQuery, Operations.GetEventTypesWithSchemaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetEventTypesWithSchemaQuery, Operations.GetEventTypesWithSchemaQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetEventTypesWithSchemaQuery, Operations.GetEventTypesWithSchemaQueryVariables>(Operations.GetEventTypesWithSchemaDocument, variables, options);
          }
export type GetEventTypesWithSchemaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetEventTypesWithSchemaQuery, Operations.GetEventTypesWithSchemaQueryVariables>;

/**
 * __useGetAllEventTypesQuery__
 *
 * To run a query within a Vue component, call `useGetAllEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEventTypesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllEventTypesQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllEventTypesQuery(variables?: Operations.GetAllEventTypesQueryVariables | VueCompositionApi.Ref<Operations.GetAllEventTypesQueryVariables> | ReactiveFunction<Operations.GetAllEventTypesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllEventTypesQuery, Operations.GetAllEventTypesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllEventTypesQuery, Operations.GetAllEventTypesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllEventTypesQuery, Operations.GetAllEventTypesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllEventTypesQuery, Operations.GetAllEventTypesQueryVariables>(Operations.GetAllEventTypesDocument, variables, options);
          }
export type GetAllEventTypesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllEventTypesQuery, Operations.GetAllEventTypesQueryVariables>;

/**
 * __useUpdateEventTypeUdfColumnsMutation__
 *
 * To run a mutation, you first call `useUpdateEventTypeUdfColumnsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventTypeUdfColumnsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEventTypeUdfColumnsMutation({
 *   variables: {
 *      eventTypeLinks: // value for 'eventTypeLinks'
 *   },
 * });
 */
export function useUpdateEventTypeUdfColumnsMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateEventTypeUdfColumnsMutation, Operations.UpdateEventTypeUdfColumnsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateEventTypeUdfColumnsMutation, Operations.UpdateEventTypeUdfColumnsMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateEventTypeUdfColumnsMutation, Operations.UpdateEventTypeUdfColumnsMutationVariables>(Operations.UpdateEventTypeUdfColumnsDocument, options);
          }
export type UpdateEventTypeUdfColumnsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateEventTypeUdfColumnsMutation, Operations.UpdateEventTypeUdfColumnsMutationVariables>;

/**
 * __useAddScheduleEventsMutation__
 *
 * To run a mutation, you first call `useAddScheduleEventsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddScheduleEventsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddScheduleEventsMutation({
 *   variables: {
 *      scheduleEvent: // value for 'scheduleEvent'
 *   },
 * });
 */
export function useAddScheduleEventsMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddScheduleEventsMutation, Operations.AddScheduleEventsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddScheduleEventsMutation, Operations.AddScheduleEventsMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddScheduleEventsMutation, Operations.AddScheduleEventsMutationVariables>(Operations.AddScheduleEventsDocument, options);
          }
export type AddScheduleEventsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddScheduleEventsMutation, Operations.AddScheduleEventsMutationVariables>;

/**
 * __useAddSchedulesMutation__
 *
 * To run a mutation, you first call `useAddSchedulesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddSchedulesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddSchedulesMutation({
 *   variables: {
 *      schedule: // value for 'schedule'
 *   },
 * });
 */
export function useAddSchedulesMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddSchedulesMutation, Operations.AddSchedulesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddSchedulesMutation, Operations.AddSchedulesMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddSchedulesMutation, Operations.AddSchedulesMutationVariables>(Operations.AddSchedulesDocument, options);
          }
export type AddSchedulesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddSchedulesMutation, Operations.AddSchedulesMutationVariables>;

/**
 * __useDeleteScheduleEventMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteScheduleEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduleEventMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteScheduleEventMutation, Operations.DeleteScheduleEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteScheduleEventMutation, Operations.DeleteScheduleEventMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteScheduleEventMutation, Operations.DeleteScheduleEventMutationVariables>(Operations.DeleteScheduleEventDocument, options);
          }
export type DeleteScheduleEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteScheduleEventMutation, Operations.DeleteScheduleEventMutationVariables>;

/**
 * __useGetAllScheduleEventsQuery__
 *
 * To run a query within a Vue component, call `useGetAllScheduleEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllScheduleEventsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllScheduleEventsQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllScheduleEventsQuery(variables: Operations.GetAllScheduleEventsQueryVariables | VueCompositionApi.Ref<Operations.GetAllScheduleEventsQueryVariables> | ReactiveFunction<Operations.GetAllScheduleEventsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllScheduleEventsQuery, Operations.GetAllScheduleEventsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllScheduleEventsQuery, Operations.GetAllScheduleEventsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllScheduleEventsQuery, Operations.GetAllScheduleEventsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllScheduleEventsQuery, Operations.GetAllScheduleEventsQueryVariables>(Operations.GetAllScheduleEventsDocument, variables, options);
          }
export type GetAllScheduleEventsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllScheduleEventsQuery, Operations.GetAllScheduleEventsQueryVariables>;

/**
 * __useGetScheduleQuery__
 *
 * To run a query within a Vue component, call `useGetScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetScheduleQuery(
 *   {
 *      scheduleId: // value for 'scheduleId'
 *   }
 * );
 */
export function useGetScheduleQuery(variables: Operations.GetScheduleQueryVariables | VueCompositionApi.Ref<Operations.GetScheduleQueryVariables> | ReactiveFunction<Operations.GetScheduleQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetScheduleQuery, Operations.GetScheduleQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetScheduleQuery, Operations.GetScheduleQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetScheduleQuery, Operations.GetScheduleQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetScheduleQuery, Operations.GetScheduleQueryVariables>(Operations.GetScheduleDocument, variables, options);
          }
export type GetScheduleQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetScheduleQuery, Operations.GetScheduleQueryVariables>;

/**
 * __useGetAllSchedulesQuery__
 *
 * To run a query within a Vue component, call `useGetAllSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSchedulesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllSchedulesQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllSchedulesQuery(variables: Operations.GetAllSchedulesQueryVariables | VueCompositionApi.Ref<Operations.GetAllSchedulesQueryVariables> | ReactiveFunction<Operations.GetAllSchedulesQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllSchedulesQuery, Operations.GetAllSchedulesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllSchedulesQuery, Operations.GetAllSchedulesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllSchedulesQuery, Operations.GetAllSchedulesQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllSchedulesQuery, Operations.GetAllSchedulesQueryVariables>(Operations.GetAllSchedulesDocument, variables, options);
          }
export type GetAllSchedulesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllSchedulesQuery, Operations.GetAllSchedulesQueryVariables>;

/**
 * __useSetScheduleToDisabledMutation__
 *
 * To run a mutation, you first call `useSetScheduleToDisabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetScheduleToDisabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetScheduleToDisabledMutation({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useSetScheduleToDisabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetScheduleToDisabledMutation, Operations.SetScheduleToDisabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetScheduleToDisabledMutation, Operations.SetScheduleToDisabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetScheduleToDisabledMutation, Operations.SetScheduleToDisabledMutationVariables>(Operations.SetScheduleToDisabledDocument, options);
          }
export type SetScheduleToDisabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetScheduleToDisabledMutation, Operations.SetScheduleToDisabledMutationVariables>;

/**
 * __useUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateScheduleMutation({
 *   variables: {
 *      schedule: // value for 'schedule'
 *      deleteScheduleEvents: // value for 'deleteScheduleEvents'
 *   },
 * });
 */
export function useUpdateScheduleMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateScheduleMutation, Operations.UpdateScheduleMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateScheduleMutation, Operations.UpdateScheduleMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateScheduleMutation, Operations.UpdateScheduleMutationVariables>(Operations.UpdateScheduleDocument, options);
          }
export type UpdateScheduleMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateScheduleMutation, Operations.UpdateScheduleMutationVariables>;

/**
 * __useUpdateScheduleEventMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleEventMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleEventMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateScheduleEventMutation({
 *   variables: {
 *      scheduleEventId: // value for 'scheduleEventId'
 *      scheduleEvent: // value for 'scheduleEvent'
 *   },
 * });
 */
export function useUpdateScheduleEventMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateScheduleEventMutation, Operations.UpdateScheduleEventMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateScheduleEventMutation, Operations.UpdateScheduleEventMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateScheduleEventMutation, Operations.UpdateScheduleEventMutationVariables>(Operations.UpdateScheduleEventDocument, options);
          }
export type UpdateScheduleEventMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateScheduleEventMutation, Operations.UpdateScheduleEventMutationVariables>;

/**
 * __useGetAllScheduleDaysQuery__
 *
 * To run a query within a Vue component, call `useGetAllScheduleDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllScheduleDaysQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllScheduleDaysQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useGetAllScheduleDaysQuery(variables: Operations.GetAllScheduleDaysQueryVariables | VueCompositionApi.Ref<Operations.GetAllScheduleDaysQueryVariables> | ReactiveFunction<Operations.GetAllScheduleDaysQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllScheduleDaysQuery, Operations.GetAllScheduleDaysQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllScheduleDaysQuery, Operations.GetAllScheduleDaysQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllScheduleDaysQuery, Operations.GetAllScheduleDaysQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllScheduleDaysQuery, Operations.GetAllScheduleDaysQueryVariables>(Operations.GetAllScheduleDaysDocument, variables, options);
          }
export type GetAllScheduleDaysQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllScheduleDaysQuery, Operations.GetAllScheduleDaysQueryVariables>;

/**
 * __useGetUdfColumnsQuery__
 *
 * To run a query within a Vue component, call `useGetUdfColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUdfColumnsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUdfColumnsQuery(
 *   {
 *      filter: // value for 'filter'
 *   }
 * );
 */
export function useGetUdfColumnsQuery(variables?: Operations.GetUdfColumnsQueryVariables | VueCompositionApi.Ref<Operations.GetUdfColumnsQueryVariables> | ReactiveFunction<Operations.GetUdfColumnsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetUdfColumnsQuery, Operations.GetUdfColumnsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetUdfColumnsQuery, Operations.GetUdfColumnsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetUdfColumnsQuery, Operations.GetUdfColumnsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetUdfColumnsQuery, Operations.GetUdfColumnsQueryVariables>(Operations.GetUdfColumnsDocument, variables, options);
          }
export type GetUdfColumnsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetUdfColumnsQuery, Operations.GetUdfColumnsQueryVariables>;

/**
 * __useGetAllUomsQuery__
 *
 * To run a query within a Vue component, call `useGetAllUomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUomsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllUomsQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useGetAllUomsQuery(variables: Operations.GetAllUomsQueryVariables | VueCompositionApi.Ref<Operations.GetAllUomsQueryVariables> | ReactiveFunction<Operations.GetAllUomsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllUomsQuery, Operations.GetAllUomsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllUomsQuery, Operations.GetAllUomsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllUomsQuery, Operations.GetAllUomsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllUomsQuery, Operations.GetAllUomsQueryVariables>(Operations.GetAllUomsDocument, variables, options);
          }
export type GetAllUomsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllUomsQuery, Operations.GetAllUomsQueryVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useAddUserMutation(options: VueApolloComposable.UseMutationOptions<Operations.AddUserMutation, Operations.AddUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.AddUserMutation, Operations.AddUserMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.AddUserMutation, Operations.AddUserMutationVariables>(Operations.AddUserDocument, options);
          }
export type AddUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.AddUserMutation, Operations.AddUserMutationVariables>;

/**
 * __useDeleteUserBadgeMutation__
 *
 * To run a mutation, you first call `useDeleteUserBadgeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserBadgeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteUserBadgeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserBadgeMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteUserBadgeMutation, Operations.DeleteUserBadgeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteUserBadgeMutation, Operations.DeleteUserBadgeMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteUserBadgeMutation, Operations.DeleteUserBadgeMutationVariables>(Operations.DeleteUserBadgeDocument, options);
          }
export type DeleteUserBadgeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteUserBadgeMutation, Operations.DeleteUserBadgeMutationVariables>;

/**
 * __useGetUserQuery__
 *
 * To run a query within a Vue component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetUserQuery(
 *   {
 *      queryFilter: // value for 'queryFilter'
 *   }
 * );
 */
export function useGetUserQuery(variables: Operations.GetUserQueryVariables | VueCompositionApi.Ref<Operations.GetUserQueryVariables> | ReactiveFunction<Operations.GetUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetUserQuery, Operations.GetUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetUserQuery, Operations.GetUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetUserQuery, Operations.GetUserQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetUserQuery, Operations.GetUserQueryVariables>(Operations.GetUserDocument, variables, options);
          }
export type GetUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetUserQuery, Operations.GetUserQueryVariables>;

/**
 * __useGetAllUserAclsQuery__
 *
 * To run a query within a Vue component, call `useGetAllUserAclsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserAclsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllUserAclsQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortby: // value for 'sortby'
 *   }
 * );
 */
export function useGetAllUserAclsQuery(variables?: Operations.GetAllUserAclsQueryVariables | VueCompositionApi.Ref<Operations.GetAllUserAclsQueryVariables> | ReactiveFunction<Operations.GetAllUserAclsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllUserAclsQuery, Operations.GetAllUserAclsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllUserAclsQuery, Operations.GetAllUserAclsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllUserAclsQuery, Operations.GetAllUserAclsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllUserAclsQuery, Operations.GetAllUserAclsQueryVariables>(Operations.GetAllUserAclsDocument, variables, options);
          }
export type GetAllUserAclsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllUserAclsQuery, Operations.GetAllUserAclsQueryVariables>;

/**
 * __useSetUserToDisabledMutation__
 *
 * To run a mutation, you first call `useSetUserToDisabledMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetUserToDisabledMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetUserToDisabledMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetUserToDisabledMutation(options: VueApolloComposable.UseMutationOptions<Operations.SetUserToDisabledMutation, Operations.SetUserToDisabledMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SetUserToDisabledMutation, Operations.SetUserToDisabledMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SetUserToDisabledMutation, Operations.SetUserToDisabledMutationVariables>(Operations.SetUserToDisabledDocument, options);
          }
export type SetUserToDisabledMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SetUserToDisabledMutation, Operations.SetUserToDisabledMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserMutation({
 *   variables: {
 *      isAdmin: // value for 'isAdmin'
 *      userId: // value for 'userId'
 *      user: // value for 'user'
 *      insertUserContexts: // value for 'insertUserContexts'
 *      deleteUserContextsBoolExp: // value for 'deleteUserContextsBoolExp'
 *      insertUserRoles: // value for 'insertUserRoles'
 *      deleteUserRoleBoolExp: // value for 'deleteUserRoleBoolExp'
 *      deleteUserAccessTokenKeysBoolExp: // value for 'deleteUserAccessTokenKeysBoolExp'
 *   },
 * });
 */
export function useUpdateUserMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdateUserMutation, Operations.UpdateUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdateUserMutation, Operations.UpdateUserMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdateUserMutation, Operations.UpdateUserMutationVariables>(Operations.UpdateUserDocument, options);
          }
export type UpdateUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdateUserMutation, Operations.UpdateUserMutationVariables>;

/**
 * __useUpsertUserBadgeMutation__
 *
 * To run a mutation, you first call `useUpsertUserBadgeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserBadgeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertUserBadgeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useUpsertUserBadgeMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpsertUserBadgeMutation, Operations.UpsertUserBadgeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpsertUserBadgeMutation, Operations.UpsertUserBadgeMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpsertUserBadgeMutation, Operations.UpsertUserBadgeMutationVariables>(Operations.UpsertUserBadgeDocument, options);
          }
export type UpsertUserBadgeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpsertUserBadgeMutation, Operations.UpsertUserBadgeMutationVariables>;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a Vue component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllUsersQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortby: // value for 'sortby'
 *   }
 * );
 */
export function useGetAllUsersQuery(variables?: Operations.GetAllUsersQueryVariables | VueCompositionApi.Ref<Operations.GetAllUsersQueryVariables> | ReactiveFunction<Operations.GetAllUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllUsersQuery, Operations.GetAllUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllUsersQuery, Operations.GetAllUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllUsersQuery, Operations.GetAllUsersQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllUsersQuery, Operations.GetAllUsersQueryVariables>(Operations.GetAllUsersDocument, variables, options);
          }
export type GetAllUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllUsersQuery, Operations.GetAllUsersQueryVariables>;

/**
 * __useActivateWorkInstructionVersionMutation__
 *
 * To run a mutation, you first call `useActivateWorkInstructionVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useActivateWorkInstructionVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useActivateWorkInstructionVersionMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      versionNumber: // value for 'versionNumber'
 *   },
 * });
 */
export function useActivateWorkInstructionVersionMutation(options: VueApolloComposable.UseMutationOptions<Operations.ActivateWorkInstructionVersionMutation, Operations.ActivateWorkInstructionVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.ActivateWorkInstructionVersionMutation, Operations.ActivateWorkInstructionVersionMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.ActivateWorkInstructionVersionMutation, Operations.ActivateWorkInstructionVersionMutationVariables>(Operations.ActivateWorkInstructionVersionDocument, options);
          }
export type ActivateWorkInstructionVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.ActivateWorkInstructionVersionMutation, Operations.ActivateWorkInstructionVersionMutationVariables>;

/**
 * __useDeleteWorkInstructionVersionMutation__
 *
 * To run a mutation, you first call `useDeleteWorkInstructionVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkInstructionVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteWorkInstructionVersionMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useDeleteWorkInstructionVersionMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteWorkInstructionVersionMutation, Operations.DeleteWorkInstructionVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteWorkInstructionVersionMutation, Operations.DeleteWorkInstructionVersionMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteWorkInstructionVersionMutation, Operations.DeleteWorkInstructionVersionMutationVariables>(Operations.DeleteWorkInstructionVersionDocument, options);
          }
export type DeleteWorkInstructionVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteWorkInstructionVersionMutation, Operations.DeleteWorkInstructionVersionMutationVariables>;

/**
 * __useDeleteWorkInstructionMutation__
 *
 * To run a mutation, you first call `useDeleteWorkInstructionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkInstructionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteWorkInstructionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkInstructionMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteWorkInstructionMutation, Operations.DeleteWorkInstructionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteWorkInstructionMutation, Operations.DeleteWorkInstructionMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteWorkInstructionMutation, Operations.DeleteWorkInstructionMutationVariables>(Operations.DeleteWorkInstructionDocument, options);
          }
export type DeleteWorkInstructionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteWorkInstructionMutation, Operations.DeleteWorkInstructionMutationVariables>;

/**
 * __useGetAllNonRetiredWorkInstructionVersionsForWorkInstructionQuery__
 *
 * To run a query within a Vue component, call `useGetAllNonRetiredWorkInstructionVersionsForWorkInstructionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNonRetiredWorkInstructionVersionsForWorkInstructionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllNonRetiredWorkInstructionVersionsForWorkInstructionQuery(
 *   {
 *      workInstructionId: // value for 'workInstructionId'
 *   }
 * );
 */
export function useGetAllNonRetiredWorkInstructionVersionsForWorkInstructionQuery(variables: Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQueryVariables | VueCompositionApi.Ref<Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQueryVariables> | ReactiveFunction<Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQuery, Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQuery, Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQuery, Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQuery, Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQueryVariables>(Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionDocument, variables, options);
          }
export type GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQuery, Operations.GetAllNonRetiredWorkInstructionVersionsForWorkInstructionQueryVariables>;

/**
 * __useGetAllWorkInstructionsForListQuery__
 *
 * To run a query within a Vue component, call `useGetAllWorkInstructionsForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWorkInstructionsForListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAllWorkInstructionsForListQuery(
 *   {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   }
 * );
 */
export function useGetAllWorkInstructionsForListQuery(variables: Operations.GetAllWorkInstructionsForListQueryVariables | VueCompositionApi.Ref<Operations.GetAllWorkInstructionsForListQueryVariables> | ReactiveFunction<Operations.GetAllWorkInstructionsForListQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetAllWorkInstructionsForListQuery, Operations.GetAllWorkInstructionsForListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetAllWorkInstructionsForListQuery, Operations.GetAllWorkInstructionsForListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetAllWorkInstructionsForListQuery, Operations.GetAllWorkInstructionsForListQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetAllWorkInstructionsForListQuery, Operations.GetAllWorkInstructionsForListQueryVariables>(Operations.GetAllWorkInstructionsForListDocument, variables, options);
          }
export type GetAllWorkInstructionsForListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetAllWorkInstructionsForListQuery, Operations.GetAllWorkInstructionsForListQueryVariables>;

/**
 * __useGetCurrentlyActivatedWorkInstructionVersionQuery__
 *
 * To run a query within a Vue component, call `useGetCurrentlyActivatedWorkInstructionVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentlyActivatedWorkInstructionVersionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCurrentlyActivatedWorkInstructionVersionQuery(
 *   {
 *      id: // value for 'id'
 *   }
 * );
 */
export function useGetCurrentlyActivatedWorkInstructionVersionQuery(variables: Operations.GetCurrentlyActivatedWorkInstructionVersionQueryVariables | VueCompositionApi.Ref<Operations.GetCurrentlyActivatedWorkInstructionVersionQueryVariables> | ReactiveFunction<Operations.GetCurrentlyActivatedWorkInstructionVersionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetCurrentlyActivatedWorkInstructionVersionQuery, Operations.GetCurrentlyActivatedWorkInstructionVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetCurrentlyActivatedWorkInstructionVersionQuery, Operations.GetCurrentlyActivatedWorkInstructionVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetCurrentlyActivatedWorkInstructionVersionQuery, Operations.GetCurrentlyActivatedWorkInstructionVersionQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetCurrentlyActivatedWorkInstructionVersionQuery, Operations.GetCurrentlyActivatedWorkInstructionVersionQueryVariables>(Operations.GetCurrentlyActivatedWorkInstructionVersionDocument, variables, options);
          }
export type GetCurrentlyActivatedWorkInstructionVersionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetCurrentlyActivatedWorkInstructionVersionQuery, Operations.GetCurrentlyActivatedWorkInstructionVersionQueryVariables>;

/**
 * __useGetLatestWorkInstructionVersionNumberQuery__
 *
 * To run a query within a Vue component, call `useGetLatestWorkInstructionVersionNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestWorkInstructionVersionNumberQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLatestWorkInstructionVersionNumberQuery(
 *   {
 *      id: // value for 'id'
 *   }
 * );
 */
export function useGetLatestWorkInstructionVersionNumberQuery(variables: Operations.GetLatestWorkInstructionVersionNumberQueryVariables | VueCompositionApi.Ref<Operations.GetLatestWorkInstructionVersionNumberQueryVariables> | ReactiveFunction<Operations.GetLatestWorkInstructionVersionNumberQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetLatestWorkInstructionVersionNumberQuery, Operations.GetLatestWorkInstructionVersionNumberQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetLatestWorkInstructionVersionNumberQuery, Operations.GetLatestWorkInstructionVersionNumberQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetLatestWorkInstructionVersionNumberQuery, Operations.GetLatestWorkInstructionVersionNumberQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetLatestWorkInstructionVersionNumberQuery, Operations.GetLatestWorkInstructionVersionNumberQueryVariables>(Operations.GetLatestWorkInstructionVersionNumberDocument, variables, options);
          }
export type GetLatestWorkInstructionVersionNumberQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetLatestWorkInstructionVersionNumberQuery, Operations.GetLatestWorkInstructionVersionNumberQueryVariables>;

/**
 * __useGetLinkedProcessDataQuery__
 *
 * To run a query within a Vue component, call `useGetLinkedProcessDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedProcessDataQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLinkedProcessDataQuery(
 *   {
 *      processIds: // value for 'processIds'
 *   }
 * );
 */
export function useGetLinkedProcessDataQuery(variables: Operations.GetLinkedProcessDataQueryVariables | VueCompositionApi.Ref<Operations.GetLinkedProcessDataQueryVariables> | ReactiveFunction<Operations.GetLinkedProcessDataQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetLinkedProcessDataQuery, Operations.GetLinkedProcessDataQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetLinkedProcessDataQuery, Operations.GetLinkedProcessDataQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetLinkedProcessDataQuery, Operations.GetLinkedProcessDataQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetLinkedProcessDataQuery, Operations.GetLinkedProcessDataQueryVariables>(Operations.GetLinkedProcessDataDocument, variables, options);
          }
export type GetLinkedProcessDataQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetLinkedProcessDataQuery, Operations.GetLinkedProcessDataQueryVariables>;

/**
 * __useGetWorkInstructionVersionQuery__
 *
 * To run a query within a Vue component, call `useGetWorkInstructionVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkInstructionVersionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWorkInstructionVersionQuery(
 *   {
 *      workInstructionVersionId: // value for 'workInstructionVersionId'
 *   }
 * );
 */
export function useGetWorkInstructionVersionQuery(variables: Operations.GetWorkInstructionVersionQueryVariables | VueCompositionApi.Ref<Operations.GetWorkInstructionVersionQueryVariables> | ReactiveFunction<Operations.GetWorkInstructionVersionQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetWorkInstructionVersionQuery, Operations.GetWorkInstructionVersionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetWorkInstructionVersionQuery, Operations.GetWorkInstructionVersionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetWorkInstructionVersionQuery, Operations.GetWorkInstructionVersionQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetWorkInstructionVersionQuery, Operations.GetWorkInstructionVersionQueryVariables>(Operations.GetWorkInstructionVersionDocument, variables, options);
          }
export type GetWorkInstructionVersionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetWorkInstructionVersionQuery, Operations.GetWorkInstructionVersionQueryVariables>;

/**
 * __useInsertWorkInstructionMutation__
 *
 * To run a mutation, you first call `useInsertWorkInstructionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertWorkInstructionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertWorkInstructionMutation({
 *   variables: {
 *      workInstruction: // value for 'workInstruction'
 *   },
 * });
 */
export function useInsertWorkInstructionMutation(options: VueApolloComposable.UseMutationOptions<Operations.InsertWorkInstructionMutation, Operations.InsertWorkInstructionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.InsertWorkInstructionMutation, Operations.InsertWorkInstructionMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.InsertWorkInstructionMutation, Operations.InsertWorkInstructionMutationVariables>(Operations.InsertWorkInstructionDocument, options);
          }
export type InsertWorkInstructionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.InsertWorkInstructionMutation, Operations.InsertWorkInstructionMutationVariables>;

/**
 * __useInsertWorkInstructionVersionMutation__
 *
 * To run a mutation, you first call `useInsertWorkInstructionVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useInsertWorkInstructionVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useInsertWorkInstructionVersionMutation({
 *   variables: {
 *      workInstructionVersion: // value for 'workInstructionVersion'
 *   },
 * });
 */
export function useInsertWorkInstructionVersionMutation(options: VueApolloComposable.UseMutationOptions<Operations.InsertWorkInstructionVersionMutation, Operations.InsertWorkInstructionVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.InsertWorkInstructionVersionMutation, Operations.InsertWorkInstructionVersionMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.InsertWorkInstructionVersionMutation, Operations.InsertWorkInstructionVersionMutationVariables>(Operations.InsertWorkInstructionVersionDocument, options);
          }
export type InsertWorkInstructionVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.InsertWorkInstructionVersionMutation, Operations.InsertWorkInstructionVersionMutationVariables>;

/**
 * __useRetireActivatedWorkInstructionMutation__
 *
 * To run a mutation, you first call `useRetireActivatedWorkInstructionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetireActivatedWorkInstructionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetireActivatedWorkInstructionMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      workInstructionId: // value for 'workInstructionId'
 *      discontinueAfter: // value for 'discontinueAfter'
 *      newWorkInstructionName: // value for 'newWorkInstructionName'
 *   },
 * });
 */
export function useRetireActivatedWorkInstructionMutation(options: VueApolloComposable.UseMutationOptions<Operations.RetireActivatedWorkInstructionMutation, Operations.RetireActivatedWorkInstructionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.RetireActivatedWorkInstructionMutation, Operations.RetireActivatedWorkInstructionMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.RetireActivatedWorkInstructionMutation, Operations.RetireActivatedWorkInstructionMutationVariables>(Operations.RetireActivatedWorkInstructionDocument, options);
          }
export type RetireActivatedWorkInstructionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.RetireActivatedWorkInstructionMutation, Operations.RetireActivatedWorkInstructionMutationVariables>;

/**
 * __useRetireActivatedWorkInstructionVersionMutation__
 *
 * To run a mutation, you first call `useRetireActivatedWorkInstructionVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRetireActivatedWorkInstructionVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRetireActivatedWorkInstructionVersionMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      discontinueAfter: // value for 'discontinueAfter'
 *   },
 * });
 */
export function useRetireActivatedWorkInstructionVersionMutation(options: VueApolloComposable.UseMutationOptions<Operations.RetireActivatedWorkInstructionVersionMutation, Operations.RetireActivatedWorkInstructionVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.RetireActivatedWorkInstructionVersionMutation, Operations.RetireActivatedWorkInstructionVersionMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.RetireActivatedWorkInstructionVersionMutation, Operations.RetireActivatedWorkInstructionVersionMutationVariables>(Operations.RetireActivatedWorkInstructionVersionDocument, options);
          }
export type RetireActivatedWorkInstructionVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.RetireActivatedWorkInstructionVersionMutation, Operations.RetireActivatedWorkInstructionVersionMutationVariables>;

/**
 * __useUpdatePendingWorkInstructionVersionMutation__
 *
 * To run a mutation, you first call `useUpdatePendingWorkInstructionVersionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePendingWorkInstructionVersionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdatePendingWorkInstructionVersionMutation({
 *   variables: {
 *      workInstructionId: // value for 'workInstructionId'
 *      workInstructionVersionId: // value for 'workInstructionVersionId'
 *      workInstructionVersionSetInput: // value for 'workInstructionVersionSetInput'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdatePendingWorkInstructionVersionMutation(options: VueApolloComposable.UseMutationOptions<Operations.UpdatePendingWorkInstructionVersionMutation, Operations.UpdatePendingWorkInstructionVersionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.UpdatePendingWorkInstructionVersionMutation, Operations.UpdatePendingWorkInstructionVersionMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.UpdatePendingWorkInstructionVersionMutation, Operations.UpdatePendingWorkInstructionVersionMutationVariables>(Operations.UpdatePendingWorkInstructionVersionDocument, options);
          }
export type UpdatePendingWorkInstructionVersionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.UpdatePendingWorkInstructionVersionMutation, Operations.UpdatePendingWorkInstructionVersionMutationVariables>;

/**
 * __useCreateWorkOrderMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateWorkOrderMutation({
 *   variables: {
 *      workOrder: // value for 'workOrder'
 *   },
 * });
 */
export function useCreateWorkOrderMutation(options: VueApolloComposable.UseMutationOptions<Operations.CreateWorkOrderMutation, Operations.CreateWorkOrderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.CreateWorkOrderMutation, Operations.CreateWorkOrderMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.CreateWorkOrderMutation, Operations.CreateWorkOrderMutationVariables>(Operations.CreateWorkOrderDocument, options);
          }
export type CreateWorkOrderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.CreateWorkOrderMutation, Operations.CreateWorkOrderMutationVariables>;

/**
 * __useCreateWorkOrderLocationsMutation__
 *
 * To run a mutation, you first call `useCreateWorkOrderLocationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkOrderLocationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateWorkOrderLocationsMutation({
 *   variables: {
 *      insertWorkOrderLocations: // value for 'insertWorkOrderLocations'
 *   },
 * });
 */
export function useCreateWorkOrderLocationsMutation(options: VueApolloComposable.UseMutationOptions<Operations.CreateWorkOrderLocationsMutation, Operations.CreateWorkOrderLocationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.CreateWorkOrderLocationsMutation, Operations.CreateWorkOrderLocationsMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.CreateWorkOrderLocationsMutation, Operations.CreateWorkOrderLocationsMutationVariables>(Operations.CreateWorkOrderLocationsDocument, options);
          }
export type CreateWorkOrderLocationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.CreateWorkOrderLocationsMutation, Operations.CreateWorkOrderLocationsMutationVariables>;

/**
 * __useGetLocationDetailsQuery__
 *
 * To run a query within a Vue component, call `useGetLocationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationDetailsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetLocationDetailsQuery(
 *   {
 *      locationIds: // value for 'locationIds'
 *   }
 * );
 */
export function useGetLocationDetailsQuery(variables: Operations.GetLocationDetailsQueryVariables | VueCompositionApi.Ref<Operations.GetLocationDetailsQueryVariables> | ReactiveFunction<Operations.GetLocationDetailsQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetLocationDetailsQuery, Operations.GetLocationDetailsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetLocationDetailsQuery, Operations.GetLocationDetailsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetLocationDetailsQuery, Operations.GetLocationDetailsQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetLocationDetailsQuery, Operations.GetLocationDetailsQueryVariables>(Operations.GetLocationDetailsDocument, variables, options);
          }
export type GetLocationDetailsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetLocationDetailsQuery, Operations.GetLocationDetailsQueryVariables>;

/**
 * __useGetWorkOrderQuery__
 *
 * To run a query within a Vue component, call `useGetWorkOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrderQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWorkOrderQuery(
 *   {
 *      work_order_id: // value for 'work_order_id'
 *   }
 * );
 */
export function useGetWorkOrderQuery(variables: Operations.GetWorkOrderQueryVariables | VueCompositionApi.Ref<Operations.GetWorkOrderQueryVariables> | ReactiveFunction<Operations.GetWorkOrderQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetWorkOrderQuery, Operations.GetWorkOrderQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetWorkOrderQuery, Operations.GetWorkOrderQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetWorkOrderQuery, Operations.GetWorkOrderQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetWorkOrderQuery, Operations.GetWorkOrderQueryVariables>(Operations.GetWorkOrderDocument, variables, options);
          }
export type GetWorkOrderQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetWorkOrderQuery, Operations.GetWorkOrderQueryVariables>;

/**
 * __useGetWorkOrdersForListQuery__
 *
 * To run a query within a Vue component, call `useGetWorkOrdersForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkOrdersForListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetWorkOrdersForListQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *      selectedIds: // value for 'selectedIds'
 *   }
 * );
 */
export function useGetWorkOrdersForListQuery(variables: Operations.GetWorkOrdersForListQueryVariables | VueCompositionApi.Ref<Operations.GetWorkOrdersForListQueryVariables> | ReactiveFunction<Operations.GetWorkOrdersForListQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.GetWorkOrdersForListQuery, Operations.GetWorkOrdersForListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.GetWorkOrdersForListQuery, Operations.GetWorkOrdersForListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.GetWorkOrdersForListQuery, Operations.GetWorkOrdersForListQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.GetWorkOrdersForListQuery, Operations.GetWorkOrdersForListQueryVariables>(Operations.GetWorkOrdersForListDocument, variables, options);
          }
export type GetWorkOrdersForListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.GetWorkOrdersForListQuery, Operations.GetWorkOrdersForListQueryVariables>;

/**
 * __useSaveWorkOrderMutation__
 *
 * To run a mutation, you first call `useSaveWorkOrderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveWorkOrderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveWorkOrderMutation({
 *   variables: {
 *      workOrderId: // value for 'workOrderId'
 *      workOrderInput: // value for 'workOrderInput'
 *      insertWorkOrderLocations: // value for 'insertWorkOrderLocations'
 *      deleteWorkOrderLocationBoolExp: // value for 'deleteWorkOrderLocationBoolExp'
 *      insertWorkOrderMaterials: // value for 'insertWorkOrderMaterials'
 *      deleteWorkOrderMaterialBoolExp: // value for 'deleteWorkOrderMaterialBoolExp'
 *   },
 * });
 */
export function useSaveWorkOrderMutation(options: VueApolloComposable.UseMutationOptions<Operations.SaveWorkOrderMutation, Operations.SaveWorkOrderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.SaveWorkOrderMutation, Operations.SaveWorkOrderMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.SaveWorkOrderMutation, Operations.SaveWorkOrderMutationVariables>(Operations.SaveWorkOrderDocument, options);
          }
export type SaveWorkOrderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.SaveWorkOrderMutation, Operations.SaveWorkOrderMutationVariables>;

/**
 * __useDeleteWorkOrderMutation__
 *
 * To run a mutation, you first call `useDeleteWorkOrderMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkOrderMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteWorkOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkOrderMutation(options: VueApolloComposable.UseMutationOptions<Operations.DeleteWorkOrderMutation, Operations.DeleteWorkOrderMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.DeleteWorkOrderMutation, Operations.DeleteWorkOrderMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.DeleteWorkOrderMutation, Operations.DeleteWorkOrderMutationVariables>(Operations.DeleteWorkOrderDocument, options);
          }
export type DeleteWorkOrderMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.DeleteWorkOrderMutation, Operations.DeleteWorkOrderMutationVariables>;

/**
 * __useWorkOrderActivityQuery__
 *
 * To run a query within a Vue component, call `useWorkOrderActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderActivityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWorkOrderActivityQuery(
 *   {
 *      workOrderId: // value for 'workOrderId'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useWorkOrderActivityQuery(variables: Operations.WorkOrderActivityQueryVariables | VueCompositionApi.Ref<Operations.WorkOrderActivityQueryVariables> | ReactiveFunction<Operations.WorkOrderActivityQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.WorkOrderActivityQuery, Operations.WorkOrderActivityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.WorkOrderActivityQuery, Operations.WorkOrderActivityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.WorkOrderActivityQuery, Operations.WorkOrderActivityQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.WorkOrderActivityQuery, Operations.WorkOrderActivityQueryVariables>(Operations.WorkOrderActivityDocument, variables, options);
          }
export type WorkOrderActivityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.WorkOrderActivityQuery, Operations.WorkOrderActivityQueryVariables>;

/**
 * __useWorkOrderSetStatusMutation__
 *
 * To run a mutation, you first call `useWorkOrderSetStatusMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderSetStatusMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useWorkOrderSetStatusMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useWorkOrderSetStatusMutation(options: VueApolloComposable.UseMutationOptions<Operations.WorkOrderSetStatusMutation, Operations.WorkOrderSetStatusMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<Operations.WorkOrderSetStatusMutation, Operations.WorkOrderSetStatusMutationVariables>>) {
            return VueApolloComposable.useMutation<Operations.WorkOrderSetStatusMutation, Operations.WorkOrderSetStatusMutationVariables>(Operations.WorkOrderSetStatusDocument, options);
          }
export type WorkOrderSetStatusMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<Operations.WorkOrderSetStatusMutation, Operations.WorkOrderSetStatusMutationVariables>;

/**
 * __useWorkOrderMaterialListQuery__
 *
 * To run a query within a Vue component, call `useWorkOrderMaterialListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkOrderMaterialListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWorkOrderMaterialListQuery(
 *   {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      colsToOrderBy: // value for 'colsToOrderBy'
 *   }
 * );
 */
export function useWorkOrderMaterialListQuery(variables: Operations.WorkOrderMaterialListQueryVariables | VueCompositionApi.Ref<Operations.WorkOrderMaterialListQueryVariables> | ReactiveFunction<Operations.WorkOrderMaterialListQueryVariables>, options: VueApolloComposable.UseQueryOptions<Operations.WorkOrderMaterialListQuery, Operations.WorkOrderMaterialListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<Operations.WorkOrderMaterialListQuery, Operations.WorkOrderMaterialListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<Operations.WorkOrderMaterialListQuery, Operations.WorkOrderMaterialListQueryVariables>> = {}) {
            return VueApolloComposable.useQuery<Operations.WorkOrderMaterialListQuery, Operations.WorkOrderMaterialListQueryVariables>(Operations.WorkOrderMaterialListDocument, variables, options);
          }
export type WorkOrderMaterialListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<Operations.WorkOrderMaterialListQuery, Operations.WorkOrderMaterialListQueryVariables>;